<template>
<div class="scrolling-box">  
  <!-- Example Langue 

<p v-html="$ml.get('title')"></p>
<p v-text="$ml.get('msg')"></p>

 Fin Example Langue -->

  <a id="top"></a>

  <b-container>
    <div class="d-flex justify-content-between" style="overflow: auto; white-space: nowrap; margin: 35px 0px">
      <b-col style="padding:0.2rem; text-align:center">
        <b-button class="col-md-8 col-12" variant="msstreamblue" style="padding:6px" @click="emitVoD">
          <font-awesome-icon icon="film" /> 
          &nbsp;<span v-text="$ml.get('newvideos')"></span>
        </b-button>
      </b-col>
      <b-col style="padding:0.2rem; text-align:center">
        <b-button class="col-md-8 col-12" variant="msstreamblue" style="padding:6px" @click="emitLive">
          <font-awesome-icon icon="video" /> 
          &nbsp;<span v-text="$ml.get('newlive')"></span>
        </b-button>
      </b-col>
      
    </div>
    <div class="greysearch">
      <b-form @submit.prevent="onSearchBar">
        <b-form-group style="margin-bottom: 3px;">
          <b-input-group :disabled='barOrCheck' >
            <b-input-group-prepend><b-button type="submit" class="input-group-text" variant="db-sb"><font-awesome-icon icon="search"></font-awesome-icon></b-button></b-input-group-prepend>
            <b-form-input :disabled='barOrCheck' v-model="search" @input="startTimeoutSearch"></b-form-input>
            <b-input-group-append>
              <b-input-group-text id="popover-help" style="cursor:pointer;"> 
                <font-awesome-icon icon="question-circle" />
              </b-input-group-text>
              <b-input-group-text title="Show advanced filters" v-if="!advancedFilter" @click="advancedFilter = !advancedFilter" style="cursor:pointer;"> 
                <font-awesome-layers>
                  <font-awesome-icon icon="plus" />
                  <font-awesome-icon title="Default filters have been modified" v-if="!defaultAdvancedFilters" icon="exclamation-circle" style="color: #ba0000;" transform="shrink-4 down-8 right-8"></font-awesome-icon> 
                </font-awesome-layers>
              </b-input-group-text>
              <b-input-group-text title="Hide advanced filters" v-if="advancedFilter" @click="advancedFilter = !advancedFilter" style="cursor:pointer;"> <font-awesome-icon icon="minus"></font-awesome-icon> </b-input-group-text>
            </b-input-group-append>
            <b-popover
            target="popover-help"
            :title="$ml.get('helpwsearch')"
            triggers="hover"
            placement="bottomleft"
            variant="light"
            >
            <span v-html="$ml.get('helpwsearchtxt')"></span>
            </b-popover>
          </b-input-group>
          <transition name="advancedfilter">
          <b-row v-if="advancedFilter" class="marginaltopsm justify-content-center">
            <b-col cols="auto">
              <b-form-checkbox-group
              size="sm"
              v-model="advancedFilters"
              :options="advancedFilterOptions"
              @input="startTimeoutSearch"
            ></b-form-checkbox-group>
            </b-col>
          </b-row>
          </transition>
          <p style="text-align:center; margin-bottom:0px; margin-top:0.5rem; font-size: 90%;">
            {{$ml.get('filter')}}
            : <strong>'{{search}}'</strong> 
            -> 
            {{$ml.get('result')}}
            : <strong>{{numberOfVideos}}</strong>/{{totalNumberOfVideos}} video(s)
          </p>
        </b-form-group>
      </b-form>
      <div>
          <div style="margin-bottom:3px">Tags <font-awesome-icon id="tag-popover" icon="question-circle" /> : </div>
          <b-popover
            target="tag-popover"
            :title="$ml.get('helptag')"
            triggers="hover"
            placement="bottomleft"
            variant="light"
            >
            <span v-html="$ml.get('helptagtxt')"></span>
        </b-popover>
        <div style="display:inline-block" v-for="(tag, index) in clientTags" :key="index">
         
         <div @click="changeTagState(tag)" v-if="selectedTags.indexOf(tag) === -1 && exludedTags.indexOf(tag) === -1" class="tagButton tag-not-selected">
          <span style="padding-left:10px;padding-right:10px"><font-awesome-icon  :icon="['fas', 'minus']" style="margin-right:5px" ></font-awesome-icon>
          {{tag}}</span>
         </div>

         <div @click="changeTagState(tag)" v-if="selectedTags.indexOf(tag) != -1 && exludedTags.indexOf(tag) === -1" class="tagButton tag-selected">
          <span style="padding-left:10px;padding-right:10px"><font-awesome-icon :icon="['fas', 'check']" style="margin-right:5px" ></font-awesome-icon>
          {{tag}}</span>
         </div>

         <div @click="changeTagState(tag)" v-if="exludedTags.indexOf(tag) != -1 && selectedTags.indexOf(tag) === -1" class="tagButton tag-excluded">
          <span style="padding-left:10px;padding-right:10px"><font-awesome-icon  :icon="['fas', 'times']" style="margin-right:5px" ></font-awesome-icon>       
          {{tag}}</span>
         </div>
        </div>
      </div>

      <div style="textAlign:center">
        <b-button class="col-md-8 col-12" variant="msstreamblue" style="padding:6px" @click="selectedTags=[];exludedTags=[];startTimeoutSearchTags()">
          <span v-text="$ml.get('resetTags')"></span>
        </b-button>
      </div>
    </div>

    <b-row class="justify-content-between align-items-center" style="margin-right:0px; margin-left:0px; margin-top: 35px; margin-bottom:15px ">
      <b-button-group class="align-items-center">
        <b-button style="margin-right:5px" :variant="(thOrList === 0) ? 'greenw':'darkblue'" @click="thOrList=0; saveListParam()" title="Mosaic">
          <font-awesome-icon :icon="['fas', 'th']"></font-awesome-icon>
        </b-button>
        <b-button style="margin-right:5px" :variant="(thOrList === 1) ? 'greenw':'darkblue'" @click="thOrList=1; saveListParam()" title="List">
          <font-awesome-icon :icon="['fas', 'list']"></font-awesome-icon>
        </b-button>
        <b-button v-if="$auth.getMyUser().client_infos[0].oldTable" style="margin-right:5px" :variant="(thOrList === 2) ? 'greenw':'darkblue'" @click="thOrList=2; saveListParam()" title="Old List">
          <font-awesome-icon :icon="['fas', 'bars']"></font-awesome-icon>
        </b-button>
        <b-form-checkbox size="sm" switch v-model="isImbricated" style="margin:0px 0px 0px 5px" @change="updateImbricated()" title="Imbricated mode" >
          <svg title="Imbricated mode" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M32 32C49.67 32 64 46.33 64 64V400C64 408.8 71.16 416 80 416H480C497.7 416 512 430.3 512 448C512 465.7 497.7 480 480 480H80C35.82 480 0 444.2 0 400V64C0 46.33 14.33 32 32 32zM128 128C128 110.3 142.3 96 160 96H256C273.7 96 288 110.3 288 128C288 145.7 273.7 160 256 160H160C142.3 160 128 145.7 128 128zM352 192C369.7 192 384 206.3 384 224C384 241.7 369.7 256 352 256H224C206.3 256 192 241.7 192 224C192 206.3 206.3 192 224 192H352zM448 288C465.7 288 480 302.3 480 320C480 337.7 465.7 352 448 352H384C366.3 352 352 337.7 352 320C352 302.3 366.3 288 384 288H448z"/></svg>
        </b-form-checkbox>
        <sup><font-awesome-icon size="sm" style="margin-right:5px" id="popoverImb" icon="question-circle" /></sup>
        <b-popover size="sm" target="popoverImb" triggers="hover" placement="top">
          <template #title><small>{{$ml.get('imbmode')}}</small></template>
          <small v-html="$ml.get('imbmodetxt')"></small>
        </b-popover>
      </b-button-group>

      <b-dropdown size="sm" style="z-index:3" id="dropdown-2" v-bind:text="numberPerPage + ' / page'" variant="greenw">
        <b-dropdown-item v-bind:class="numberPerPage === 12" @click="numberPerPage=12; currentPage = 1; getVideos()">12</b-dropdown-item>
        <b-dropdown-item v-bind:class="numberPerPage === 20" @click="numberPerPage=20; currentPage = 1; getVideos()">20</b-dropdown-item>
        <b-dropdown-item v-bind:class="numberPerPage === 50" @click="numberPerPage=50; currentPage = 1; getVideos()">50</b-dropdown-item>
        <b-dropdown-item v-bind:class="numberPerPage === 100" @click="numberPerPage=100; currentPage = 1; getVideos()">100</b-dropdown-item>
      </b-dropdown>

      <b-button-group class="align-items-center">
        <b-button style="margin-left:125px" variant="mswarning" @click="getVideos();getNumberVideoPlatform()" title="Refresh list">
          <font-awesome-icon :icon="['fas', 'sync']"></font-awesome-icon>
        </b-button>
      </b-button-group>

    </b-row>

    <b-row v-if="isGetInProgress" class="justify-content-center marginaltopsm">
      <fade-loader color="#f98e35" style="position: relative; width: 45px; height: 60px; margin: auto; text-align: center"></fade-loader>
    </b-row>

    <b-row v-if="realTotalNumberOfPage > 1" class="justify-content-center align-items-center" style="margin: 5px 0px ">
      <b-pagination size="sm" style="z-index:2; margin: 0px 5px" align="center" :limit="8" :total-rows="realTotalNumberOfPage" v-model="currentPage" :per-page="1" first-number last-number @input="getVideos()">
      </b-pagination>
      <b-form v-if="realTotalNumberOfPage > 10" @submit.prevent="currentPage = goPage">
        <b-form-group style="margin: 0px 5px">
          <b-input-group size="sm" prepend="Go to page:">
            <b-form-input style="width:80px" type="number" min="1" v-model="goPage"></b-form-input>
            <b-input-group-append><b-button variant="db-sb" @click="currentPage = goPage">Go</b-button></b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-form>
    </b-row>

    <b-row v-if="thOrList === 0 || thOrList === 2" class="justify-content-between">  
      <b-col md="auto">
        <b-col md="auto">
          <div class="scrollmenu">
            <p style="margin:5px 0px; font-size: 70%" v-text="$ml.get('selectsort')"></p>
          </div>
        </b-col>

      <div class="scrollmenu" style="padding-bottom: 10px">
        <b-button size="sm" style="margin-left:0px; margin-right:2px" @click="changeActiveSort('title')" :variant="(activeSort === 'title') ? 'greenw':'darkblue'">
          {{$ml.get('title')}}
          <font-awesome-icon v-if="activeSort === 'title' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']"></font-awesome-icon>
          <font-awesome-icon v-if="activeSort === 'title' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:0px; margin-right:2px" @click="changeActiveSort('user')" :variant="(activeSort === 'user') ? 'greenw':'darkblue'">
          {{$ml.get('author')}}
          <font-awesome-icon v-if="activeSort === 'user' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']"></font-awesome-icon>
          <font-awesome-icon v-if="activeSort === 'user' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('createdAt', -1)" :variant="(activeSort === 'createdAt') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'calendar-minus']"></font-awesome-icon> 
          {{$ml.get('creationdate')}} 
          <font-awesome-icon v-if="activeSort === 'createdAt' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'createdAt' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('duration', -1)" :variant="(activeSort === 'duration') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'clock']"></font-awesome-icon> 
          {{$ml.get('duration')}}
          <font-awesome-icon v-if="activeSort === 'duration' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'duration' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('lastModifyAt', -1)" :variant="(activeSort === 'lastModifyAt') ? 'greenw':'darkblue'">
          <font-awesome-layers>
            <font-awesome-icon
              :icon="['fas', 'circle']"
              transform="shrink-12"
            />
            <font-awesome-icon :icon="['fas', 'redo-alt']" />
          </font-awesome-layers>
          {{$ml.get('modifdate')}} 
          <font-awesome-icon v-if="activeSort === 'lastModifyAt' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'lastModifyAt' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:0px; margin-right:2px" @click="changeActiveSort('encodingStatus')" :variant="(activeSort === 'encodingStatus') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon> 
          {{$ml.get('status')}}
          <font-awesome-icon v-if="activeSort === 'encodingStatus' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']"></font-awesome-icon>
          <font-awesome-icon v-if="activeSort === 'encodingStatus' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:0px; margin-right:2px" @click="changeActiveSort('error', -1)" :variant="(activeSort === 'error') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'exclamation-triangle']"></font-awesome-icon> 
          {{$ml.get('errors')}}
          <font-awesome-icon v-if="activeSort === 'error' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']"></font-awesome-icon>
          <font-awesome-icon v-if="activeSort === 'error' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>
        </b-button>        
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('currentNumberOfQualities', -1)" :variant="(activeSort === 'currentNumberOfQualities') ? 'greenw':'darkblue'">
          {{$ml.get('qnbr')}}
          <font-awesome-icon v-if="activeSort === 'currentNumberOfQualities' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'currentNumberOfQualities' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('hourview', -1)" :variant="(activeSort === 'hourview') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
          {{$ml.get('viewingtime')}}
          <font-awesome-icon v-if="activeSort === 'hourview' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'hourview' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('concurrentUsers', -1)" :variant="(activeSort === 'concurrentUsers') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon> 
          {{$ml.get('viewers')}}
          <font-awesome-icon v-if="activeSort === 'concurrentUsers' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'concurrentUsers' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('meanTime', -1)" :variant="(activeSort === 'meanTime') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'stopwatch']"></font-awesome-icon>
          {{$ml.get('meanvd')}}
          <font-awesome-icon v-if="activeSort === 'meanTime' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'meanTime' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('bestQualityPercent', -1)" :variant="(activeSort === 'bestQualityPercent') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'signal']"></font-awesome-icon> 
          {{$ml.get('topq')}}
          <font-awesome-icon v-if="activeSort === 'bestQualityPercent' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'bestQualityPercent' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('bitrate', -1)" :variant="(activeSort === 'bitrate') ? 'greenw':'darkblue'">
          &#x7E; {{$ml.get('bitrate')}}
          <font-awesome-icon v-if="activeSort === 'bitrate' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'bitrate' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('rebuff')" :variant="(activeSort === 'rebuff') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>           
          {{$ml.get('rebuff')}}
          <font-awesome-icon v-if="activeSort === 'rebuff' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'rebuff' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('offload', -1)" :variant="(activeSort === 'offload') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon> 
          {{$ml.get('eff')}}
          <font-awesome-icon v-if="activeSort === 'offload' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'offload' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('dataDelivered', -1)" :variant="(activeSort === 'dataDelivered') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon> 
          {{$ml.get('dataout')}}
          <font-awesome-icon v-if="activeSort === 'dataDelivered' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'dataDelivered' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('totalMB_peer', -1)" :variant="(activeSort === 'totalMB_peer') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon>
          {{$ml.get('dataoutp')}}
          <font-awesome-icon v-if="activeSort === 'totalMB_peer' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'totalMB_peer' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('energySaved', -1)" :variant="(activeSort === 'energySaved') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon> 
          {{$ml.get('energy')}}
          <font-awesome-icon v-if="activeSort === 'energySaved' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'energySaved' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('kwhSpent')" :variant="(activeSort === 'kwhSpent') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon> 
          {{$ml.get('KWh')}}
          <font-awesome-icon v-if="activeSort === 'kwhSpent' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'kwhSpent' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('co2Spent')" :variant="(activeSort === 'co2Spent') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon> 
          {{$ml.get('carbon')}}
          <font-awesome-icon v-if="activeSort === 'co2Spent' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'co2Spent' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('tags')" :variant="(activeSort === 'tags') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'tags']"></font-awesome-icon> 
          {{$ml.get('tags')}}
          <font-awesome-icon v-if="activeSort === 'tags' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'tags' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>
        </b-button>
      </div>
      <b-col md="auto">
        <div class="scrollmenu">
          <p style="margin:0px; padding-bottom:5px; font-size: 70%" v-text="$ml.get('last24')"></p>
        </div>
      </b-col>
    </b-col>
  </b-row>

  <b-row v-if="thOrList === 1">
    <div class="scrollmenu">
      <p style="margin:2px 15px; font-size: 70%" v-text="$ml.get('selectsort')"></p>
    </div>
  </b-row>

  <b-row v-if="thOrList === 1" class="align-items-center" style="color:white; background-color: #113448; margin: 5px 0px; border: 0.15rem solid black; border-radius: 3px">
  
    <b-row class="col-12 align-items-center" style="display: flex; overflow: auto; white-space: nowrap; padding:0%; margin: 0px">

    <b-row class="align-items-center">

    <b-col cols="2" class="colwidth">

      <div class="previewContainer3" style="z-index:1">
        <b-btn class="previewImg" style="opacity:0.5; cursor: default; background-color: #113448" fluid><small v-text="$ml.get('vidprev')"></small></b-btn>
        <div style="position:absolute; z-index:2; left: 5px; top: 3px">
          <b-form-checkbox v-model="isSelectAll" @change="selectAll"><p style="cursor: pointer; margin-top:4px"><small v-text="$ml.get('selectall')"></small></p></b-form-checkbox>
        </div>
      </div>
    </b-col>

    <b-col cols="3" style="width:300px; margin: 0px 20px 0px 0px; border-right: 2px solid white">
      <div style="margin-left:-21px">
        <b-button size="sm" :variant="(activeSort === 'type') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('type')" title="Sort by video type" >
          <font-awesome-layers >
            <font-awesome-icon :icon="['fas', 'video']" transform="shrink-4 right-2 up-3"></font-awesome-icon>
            <font-awesome-icon :icon="['fas', 'film']" transform="shrink-4 left-3 down-3"></font-awesome-icon>
          </font-awesome-layers>
        </b-button>

        <b-button size="sm" :variant="(activeSort === 'download') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('download', -1)" title="Sort by downloadable capability">
          <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" ></font-awesome-icon>
        </b-button>

        <b-button size="sm" :variant="(activeSort === 'chapters') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('chapters', -1)" title="Sort by presence of chapters">
          <font-awesome-layers >
            <font-awesome-icon :icon="['fas', 'list-ol']" transform="shrink-2" />
            <font-awesome-layers-text 
              class="fa-inverse pointerEltSB" 
              transform="shrink-5 up-5 right-6"
              style="color:#14BF98; font-weight: bold"
              value="N" />
            </font-awesome-layers>
        </b-button>

        <b-button size="sm" variant="emptyNoB" disabled title="Delete chapters">
          <font-awesome-layers >
            <font-awesome-icon :icon="['fas', 'list-ol']" transform="shrink-3"></font-awesome-icon>
            <font-awesome-icon style="color: red" :icon="['fas', 'times']" transform="shrink-5 up-5 right-6" />
          </font-awesome-layers>
        </b-button>

        <b-button size="sm" variant="emptyNoB" disabled title="Copy iFrame code">
          <font-awesome-icon :icon="['fas', 'file-export']"></font-awesome-icon>
        </b-button>

        <b-button size="sm" variant="emptyNoB" disabled title="Copy direct link">
          <font-awesome-icon :icon="['fas', 'link']"></font-awesome-icon>
        </b-button>

        <b-button size="sm" variant="emptyNoB" disabled title="Delete video" >
          <font-awesome-icon style="color: red" :icon="['fas', 'trash']" ></font-awesome-icon>
        </b-button>

        <!--<b-button size="sm" :variant="(activeSort === 'focus') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('focus')" title="Show last video opened first" >
         --> 
        <b-button size="sm" :variant="(activeSort === 'focus') ? 'emptyG' : 'emptyW'" @click="manualSortFocus('focus')" title="Show last video opened first" >
          <font-awesome-icon :icon="['fas', 'eye']" ></font-awesome-icon>
        </b-button>
      </div>

      <b-row class="justify-content-between align-items-center pointerElt" style="padding: 4px 15px 2px 0px; margin: 2px 0px 2px -20px" @click="changeActiveSort('title')" :style="(activeSort === 'title') ? {color:'#14BF98', backgroundColor:'white'}:{}" title="Sort by video title">
        <h6 style="margin:0px; padding-left: 5px">
          <strong v-text="$ml.get('titlevid')"></strong>
        </h6>
        <font-awesome-icon v-if="activeSort === 'title' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']"></font-awesome-icon>
        <font-awesome-icon v-if="activeSort === 'title' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>
      </b-row>

      <b-row class="justify-content-between align-items-center pointerElt" style="padding: 2px 15px 2px 0px; margin: 0px 0px 0px -20px" @click="changeActiveSort('user')" :style="(activeSort === 'user') ? {color:'#14BF98', backgroundColor:'white'}:{}" title="Sort by video author">
        <p style="margin:0px; padding-left: 5px">
          <small><strong v-text="$ml.get('authorvid')"></strong></small>
        </p>
        <font-awesome-icon v-if="activeSort === 'user' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']"></font-awesome-icon>
        <font-awesome-icon v-if="activeSort === 'user' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>  
      </b-row>

      <b-row class="justify-content-around align-items-center" style="padding: 2px 2px 2px 0px; margin: 0px 0px 0px -20px">
        <b-button size="sm" :variant="(activeSort === 'createdAt') ? 'emptyG' : 'emptyW'" title="Sort by creation date" @click="changeActiveSort('createdAt', -1)" >
          <small>
            <font-awesome-icon :icon="['fas', 'calendar-minus']"></font-awesome-icon>
            &nbsp;{{$ml.get('creationdate')}}
            <font-awesome-icon v-if="activeSort === 'createdAt' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'createdAt' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </small>
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'duration') ? 'emptyG' : 'emptyW'" title="Sort by video duration" @click="changeActiveSort('duration', -1)" >
          <small>
            <font-awesome-icon :icon="['fas', 'clock']"></font-awesome-icon>
            &nbsp;{{$ml.get('duration')}}
            <font-awesome-icon v-if="activeSort === 'duration' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'duration' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </small>
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'lastModifyAt') ? 'emptyG' : 'emptyW'" title="Sort by modification date" @click="changeActiveSort('lastModifyAt', -1)" >
          <small>
            <font-awesome-layers>
              <font-awesome-icon
                :icon="['fas', 'circle']"
                transform="shrink-12"
              />
              <font-awesome-icon :icon="['fas', 'redo-alt']" />
            </font-awesome-layers>
            {{$ml.get('modifdate')}}
            <font-awesome-icon v-if="activeSort === 'lastModifyAt' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'lastModifyAt' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </small>
        </b-button>

      </b-row>

    </b-col>

    <b-col cols="2" style="width: 200px; margin-right: -32px; margin-left: 2px; padding-right:30px">
      <b-row class="justify-content-center align-items-center" style="margin:0px 0px 0px -40px">
        <b-button size="sm" :variant="(activeSort === 'liveType') ? 'emptyG' : 'emptyW'" style="padding:0px !important" @click="changeActiveSort('liveType', -1)" title="Sort by type of live video: from camera, from software, custom">
          <b-badge variant="secondary" size="sm" style="top:0px; font-size:10px; padding:5px">
            LIVE
            <font-awesome-icon :icon="['fab', 'affiliatetheme']" />
            <font-awesome-icon style="margin-right:2px; margin-left:2px" :icon="['fas', 'stream']" />
            <b-img fluid :src="require(`@/assets/webcam_W.png`)" style="max-height:10px; color:white" />
          </b-badge>
          <font-awesome-icon style="margin-left:2px; padding-top:3px" v-if="activeSort === 'liveType' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']"></font-awesome-icon>
          <font-awesome-icon style="margin-left:2px; padding-top:3px" v-if="activeSort === 'liveType' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>  
        </b-button>

        <b-button size="sm" :variant="(activeSort === 'error') ? 'emptyG' : 'emptyW'" style="padding:3px !important; margin-right:5px !important; margin-left:5px !important" @click="changeActiveSort('error', -1)" title="Sort by videos with processing error(s)">
          <small>
            <font-awesome-icon style="color:red" :icon="['fas', 'exclamation-triangle']"></font-awesome-icon>
            {{$ml.get('errors')}}
            <font-awesome-icon v-if="activeSort === 'error' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'error' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>  
          </small>
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'archivesFromLiveSize') ? 'emptyG' : 'emptyW'" style="padding:0px !important; margin-right:3px !important" @click="changeActiveSort('archivesFromLiveSize', -1)" title="Sort by archives number">
          <b-badge variant="info" style="top:0px" size="sm">
            A
          </b-badge>
          <font-awesome-icon style="margin-left:2px; padding-top:3px" v-if="activeSort === 'archivesFromLiveSize' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon>
          <font-awesome-icon style="margin-left:2px; padding-top:3px" v-if="activeSort === 'archivesFromLiveSize' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>  
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'videoInAndOutSize') ? 'emptyG' : 'emptyW'" style="padding:0px !important" @click="changeActiveSort('videoInAndOutSize', -1)" title="Sort by cut number">
          <b-badge variant="success" style="top:0px" size="sm">
            C
          </b-badge>
          <font-awesome-icon style="margin-left:2px; padding-top:3px" v-if="activeSort === 'videoInAndOutSize' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon>
          <font-awesome-icon style="margin-left:2px; padding-top:3px" v-if="activeSort === 'videoInAndOutSize' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>  
        </b-button>

      </b-row>

      <b-row class="justify-content-center align-items-center" style="margin:0px 0px 0px -40px">
        <b-button size="sm" :variant="(activeSort === 'encodingStatus') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('encodingStatus')" title="Sort by video status">
          <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
          <strong> status&nbsp;</strong>
          <font-awesome-icon v-if="activeSort === 'encodingStatus' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']"></font-awesome-icon>
          <font-awesome-icon v-if="activeSort === 'encodingStatus' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>  
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'currentNumberOfQualities') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('currentNumberOfQualities', -1)" title="Sort by number of qualities created for the video">
          <small>
            {{$ml.get('qnbr')}}
            <font-awesome-icon v-if="activeSort === 'currentNumberOfQualities' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'currentNumberOfQualities' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>  
          </small>
        </b-button>
      </b-row>

      <b-row class="justify-content-center align-items-center" style="margin:0px 0px 0px -40px">
        <b-button size="sm" :variant="(activeSort === 'uploadingPercent') ? 'emptyG' : 'emptyW'" style="font-size:11px; border: 1px solid #2a5d77" @click="changeActiveSort('uploadingPercent', -1)" title="Sort by progress of uploading process (appears only when not finalized)">
          {{$ml.get('uploadper')}}&nbsp;
          <font-awesome-icon v-if="activeSort === 'uploadingPercent' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon>
          <font-awesome-icon v-if="activeSort === 'uploadingPercent' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>  
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'encodingPercent') ? 'emptyG' : 'emptyW'" style="font-size:11px; border: 1px solid #2a5d77" @click="changeActiveSort('encodingPercent', -1)" title="Sort by progress of encoding process (appears only when not finalized)">
          {{$ml.get('encodingper')}}&nbsp;
          <font-awesome-icon v-if="activeSort === 'encodingPercent' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon>
          <font-awesome-icon v-if="activeSort === 'encodingPercent' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>  
        </b-button>
      </b-row>

      <b-row class="justify-content-center align-items-center" style="margin:0px 0px 0px -40px">
        <b-button size="sm" :variant="(activeSort === 'uploadingETA') ? 'emptyG' : 'emptyW'" style="font-size:11px; border: 1px solid #2a5d77" @click="changeActiveSort('uploadingETA')" title="Sort by remaining time to finalize uploading process (appears only when not finalized)">
          <font-awesome-icon :icon="['fas', 'stopwatch']" ></font-awesome-icon> 
          {{$ml.get('uploadETA')}}&nbsp;
          <font-awesome-icon v-if="activeSort === 'uploadingETA' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon>
          <font-awesome-icon v-if="activeSort === 'uploadingETA' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>  
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'encodingETA') ? 'emptyG' : 'emptyW'" style="font-size:11px; border: 1px solid #2a5d77" @click="changeActiveSort('encodingETA')" title="Sort by remaining time to finalize encoding process (appears only when not finalized)">
          <font-awesome-icon :icon="['fas', 'stopwatch']" ></font-awesome-icon> 
          {{$ml.get('encodeETA')}}&nbsp;
          <font-awesome-icon v-if="activeSort === 'encodingETA' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon>
          <font-awesome-icon v-if="activeSort === 'encodingETA' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>  
        </b-button>
      </b-row>

    </b-col>

    <b-col cols="3" style="width: 300px; margin:0px; border-right: 2px solid white; border-left: 2px solid white">

      <b-row class="justify-content-between" style="padding:0px 10px">
        <b-button size="sm" :variant="(activeSort === 'hourview') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('hourview', -1)" title="Sort by number of hours viewed">
          <small>
            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'hourview' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'hourview' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </small>
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'concurrentUsers') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('concurrentUsers', -1)" title="Sort by number of concurrent viewers">
          <small>
            <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'concurrentUsers' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'concurrentUsers' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>            
          </small>
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'meanTime') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('meanTime', -1)" title="Sort by mean time viewing">
          <small>
            <font-awesome-icon :icon="['fas', 'stopwatch']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'meanTime' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'meanTime' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </small>
        </b-button>
      </b-row>
      <b-row class="justify-content-between" style="padding:0px 10px">
        <b-button size="sm" :variant="(activeSort === 'bestQualityPercent') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('bestQualityPercent', -1)" title="Sort by best quality %">
          <small>
            <font-awesome-icon :icon="['fas', 'signal']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'bestQualityPercent' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'bestQualityPercent' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </small>
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'bitrate') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('bitrate', -1)" title="Sort by bitrate">
          <small>
            &#x7E;
            <font-awesome-icon v-if="activeSort === 'bitrate' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'bitrate' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>          
          </small>
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'rebuff') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('rebuff')" title="Sort by rebuffering %">
          <small>
            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'rebuff' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'rebuff' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </small>
        </b-button>
      </b-row>
      <b-row class="justify-content-between" style="padding:0px 10px">
        <b-button size="sm" :variant="(activeSort === 'offload') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('offload', -1)" title="Sort by efficiency %">
          <small>
            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'offload' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'offload' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </small>
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'dataDelivered') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('dataDelivered', -1)" title="Sort by data delivered">
          <small>
            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'dataDelivered' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'dataDelivered' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </small>
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'totalMB_peer') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('totalMB_peer', -1)" title="Sort by data delivered by peers">
          <small>
            <font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'totalMB_peer' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'totalMB_peer' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </small>
        </b-button>
      </b-row>
      <b-row class="justify-content-between" style="padding:0px 10px">
        <b-button size="sm" :variant="(activeSort === 'energySaved') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('energySaved', -1)" title="Sort by energy saved">
          <small>
            <font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'energySaved' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'energySaved' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </small>
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'kwhSpent') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('kwhSpent')" title="Sort by kWh spent">
          <small>
            <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'kwhSpent' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'kwhSpent' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </small>
        </b-button>
        <b-button size="sm" :variant="(activeSort === 'co2Spent') ? 'emptyG' : 'emptyW'" @click="changeActiveSort('co2Spent')" title="Sort by carbon spent">
          <small>
            <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'co2Spent' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'co2Spent' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </small>
        </b-button>
      </b-row>

    </b-col>

    <b-col cols="2" style="width:200px">
      <b-row class="justify-content-between align-items-center pointerElt" style="padding:5px 10px; margin:5px 0px 5px 0px" @click="changeActiveSort('tags')" :style="(activeSort === 'tags') ? {color:'#14BF98', backgroundColor:'white'}:{}" title="Sort by tags">
        <small>
          <font-awesome-icon :icon="['fas', 'tags']" transform="shrink-2" />&nbsp;
          Tags
          <font-awesome-icon v-if="activeSort === 'tags' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']" />
          <font-awesome-icon v-if="activeSort === 'tags' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']" />
        </small>
      </b-row>
      <b-row style="opacity: 0.5; padding:5px 10px; margin:5px 0px 5px 0px" title="Full description of the video content">
        <small><font-awesome-icon :icon="['fas', 'file-alt']"></font-awesome-icon>&nbsp;
        Description
      </small></b-row>
    </b-col>

    </b-row>
    </b-row>
  </b-row>

  <div v-if="thOrList === 1" class="scrollmenu">
    <p style="margin:0px; padding-bottom:5px; font-size: 70%" v-text="$ml.get('last24')"></p>
  </div>

  <b-row class="align-items-center justify-content-center mt-4 mb-4">
    <h6 style="text-align:center; margin:0px" v-if="search ==='' && advancedFilters.length === 2">
      <span v-if="videos.length !== undefined &&  videos.length === 0" v-text="$ml.get('novideos')"></span>
      <span v-else>
        <span v-text="$ml.get('allvids')"></span>
        <b-badge variant="primary">{{numberOfVideos}}</b-badge>
        <span v-text="$ml.get('sortedby')"></span>
        '<span style="color:#14BF98">{{activeSortMsg}}</span>' 
        <small>(Page: {{currentPage}}/{{realTotalNumberOfPage}})</small>
      </span>
    </h6>
    <h6 style="text-align:center; margin:0px" v-else >
      <span v-if="videos.length !== undefined &&  videos.length === 0" v-text="$ml.get('novideos')"></span>
      <span v-else>
        <span v-if="advancedFilters.length !== 2" style="color:#14BF98">{{advancedFilters}}</span> videos 
        <span v-if="search !==''" >
          {{$ml.get('filtered')}}
          <span style="color:#14BF98">{{search}}</span>,
        </span>
        {{$ml.get('sby')}} 
        <span style="color:#14BF98">{{activeSortMsg}}</span>
        -> <b-badge variant="primary">{{numberOfVideos}}</b-badge> / <b-badge variant=primary>{{totalNumberOfVideos}} </b-badge> 
        <small> (Page: {{currentPage}}/{{realTotalNumberOfPage}})</small>
      </span>
    </h6>
    <b-button size="sm" style="margin-left:10px" variant="empty" @click="showLegend = !showLegend">
      <small>
        {{$ml.get('legend')}}
        <font-awesome-icon v-if="showLegend" size="xs" style="margin-left:3px" icon="chevron-up" />
        <font-awesome-icon v-else size="xs" style="margin-left:3px" icon="chevron-down" />
      </small>
    </b-button>
  </b-row>

  <b-row v-if="showLegend" class="align-items-center justify-content-center" style="margin: 25px 0px; border:1px solid black; border-radius:5px">
    <div class="mycardLiveOn" style="font-size:14px; padding:5px; margin:10px" v-text="$ml.get('ongoingl')" ></div>
    <div class="mycardLiveStop" style="font-size:14px; padding:5px; margin:10px" v-text="$ml.get('lstopped')"></div>
    <div class="mycardVOD" style="font-size:14px; padding:5px; margin:10px" v-text="$ml.get('vod')"></div>
    <div class="mycardArchive" style="font-size:14px; padding:5px; margin:10px" v-text="$ml.get('archive')"></div>
    <div class="mycardCut" style="font-size:14px; padding:5px; margin:10px" v-text="$ml.get('cutversion')"></div>

    <div class="mycardLiveStopwA" style="font-size:14px; padding:5px; margin:10px" v-text="$ml.get('lwarch')"></div>
    <div class="mycardVODwCut" style="font-size:14px; padding:5px; margin:10px" v-text="$ml.get('vodwcut')"></div>
    <div class="mycardArchiveImbwCut" style="font-size:14px; padding:5px; margin:10px" v-text="$ml.get('archwcut')"></div>
  </b-row>


  <b-row v-if="videos.length !== undefined && videos.length > 2" class="align-items-center" style="margin: 5px 0px 5px 5px; font-size:14px">
    <p style="margin: 0px 0.3rem 0px 0px">
      &#8625; 
      {{$ml.get('selected')}} 
      {{nbrVideoSelected}} 
    </p>

    <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" :disabled="nbrVideoSelected < 1" @click="isSelectAll = false; selectAll()" title="Deselect">
      <small><font-awesome-layers>
        <font-awesome-icon :icon="['fas', 'sync']" />
        <font-awesome-icon style="color:red" :icon="['fas', 'times']" transform="shrink-9" />
      </font-awesome-layers></small>
    </b-button>

    <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" :disabled="nbrVideoSelected < 1" @click="updateDownloadSelected()" title="Make all selected videos downloadable"> 
      <small><font-awesome-layers>
        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
        <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" transform="shrink-2 up-5 right-6" />
      </font-awesome-layers></small>
    </b-button>

    <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" :disabled="nbrVideoSelected < 1" @click="updateUnDownloadSelected()" title="Make all selected videos not downloadable"> 
      <small><font-awesome-layers>
        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
        <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" transform="shrink-2 up-5 right-6" />
      </font-awesome-layers></small>
    </b-button>

    <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" :disabled="nbrVideoSelected < 1" @click="updateZeroChapters()" title="Delete chapters of all selected videos" >
      <small><font-awesome-layers>
        <font-awesome-icon :icon="['fas', 'list-ol']"></font-awesome-icon>
        <font-awesome-icon style="color: red" :icon="['fas', 'times']" transform="shrink-2 up-5 right-6" />
      </font-awesome-layers></small>
    </b-button>

    <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" title="Re-launch encoding process" @click="showModal('confirmRestartEncoding')" :disabled="videos.filter((x) => (x._isSelected)).length === 0">
      <small><font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon></small>
    </b-button>

    <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" title="Set a destruction date" @click="descDate = true" :disabled="videos.filter((x) => (x._isSelected)).length === 0">
      <small><font-awesome-layers style="margin-right:12px">
        <font-awesome-icon icon="share" />
        <font-awesome-icon style="color:red" icon="trash" transform="shrink-4 right-14 up-3" />
      </font-awesome-layers></small>
    </b-button>

    <span>
      <small>
      <b-input-group v-if="descDate === true" title="Plan video destruction date">
        <date-picker id="example-datepicker3" style="font-size:12px" size="sm" v-model="deleteDate" mode="dateTime" :timezone="''" is24hr >
          <template size="sm" v-slot="{ inputValue, inputEvents }">
            <input size="sm" placeholder="dd/mm/yyyy hh:mm" v-on="inputEvents" style="text-align:center; height:21.78px; max-width:120px" :value="inputValue"/>
          </template>
        </date-picker>

        <b-button size="sm" @click="showModal('confirmPlanDesAll')" variant="emptyBBx" style="font-size:12px; padding: 4px 8px !important; line-height:0px !important" >
          <font-awesome-icon class="pointerEltSB" style="color:#14BF98" :icon="['fas', 'check']" />
        </b-button>
        <b-button size="sm" @click="descDate = false" variant="emptyBBx" style="font-size:12px; padding: 4px 8px !important; line-height:0px !important">
          <font-awesome-icon class="pointerEltSB" style="color:red" :icon="['fas', 'times']" />
        </b-button>
      </b-input-group></small>
    </span>
    
    <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" title="Clear destruction date" @click="updateZeroPlanDesSelected()" :disabled="videos.filter((x) => (x._isSelected)).length === 0">
      <small><font-awesome-layers>
        <font-awesome-icon icon="share" />
        <font-awesome-icon icon="slash" transform="left-2" />
      </font-awesome-layers></small>
    </b-button>

    <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" title="Remove all selected videos" @click="showModal('confirmDelete')" :disabled="videos.filter((x) => (x._isSelected)).length === 0">
      <small><font-awesome-icon style="color: red" :icon="['fas', 'trash']" ></font-awesome-icon></small>
    </b-button>

    <b-button v-if="isImbricated" size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" title="Show archives/cut for selected videos" @click="updateShowACSelected" :disabled="videos.filter((x) => (x._isSelected)).length === 0">
      <small>
        {{$ml.get('show')}}
        <b-badge variant="info" size="sm">
          A
        </b-badge>
        <b-badge variant="success" size="sm">
          C
        </b-badge>
      </small>
    </b-button>

    <b-button v-if="isImbricated" size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" title="Hide archives/cut for selected videos" @click="updateHideACSelected" :disabled="videos.filter((x) => (x._isSelected)).length === 0">
      <small>
        {{$ml.get('hide')}}
        <b-badge variant="info" size="sm">
          A
        </b-badge>
        <b-badge variant="success" size="sm">
          C
        </b-badge>
      </small>
    </b-button>

    <b-form-checkbox class="pointerEltVideo" style="margin-left:2rem; height:14px" v-model="isSelectAll" @change="selectAll">
      <p style="padding:5px 0px 0px 0px; margin:0px" v-text="$ml.get('selectall')"></p>
    </b-form-checkbox>

    <b-form-group v-if="videos.length !== undefined && videos.length > 5" class="col text-right" style="margin-bottom:0px">
      <b-button size="sm" variant="emptyB" href="#bottom" title="Jump to the last video of the page">
        {{$ml.get('last')}}
        <font-awesome-icon icon="chevron-down" />
      </b-button>
    </b-form-group>

  </b-row>

  <b-row v-if="thOrList === 0" style="margin: -30px -15px">
        <!--
        <div v-bind:class="{ 
            mycard2: (video.rebuff < 20 && !(video.error === true)),
            mycard: (video.rebuff >= 20 && video.rebuff < 50 && !(video.error === true)),
            mycard4: (video.rebuff >= 50 && !(video.error === true)),
            mycard5: (video.error === true || !video.hasOwnProperty('rebuff')),
          }" class='col-lg-3 col-md-4 col-sm-6 col-12' v-for="video in videos" v-bind:key="video.uuid">
        -->
        
        <div v-bind:class="{ 
            mycardLiveOn: (video.type === 'live' && video.encodingStatus !== 'stopped' && !isImbricated),

            mycardLiveOnImb: (video.type === 'live' && video.encodingStatus !== 'stopped' && (video.archivesFromLiveSize === undefined || video.archivesFromLiveSize === 0) && isImbricated),
            mycardLiveOnwA: (video.type === 'live' && video.encodingStatus !== 'stopped' && video.archivesFromLiveSize > 0 && !video._otherLoaded && isImbricated),
            mycardLiveOnwAExp: (video.type === 'live' && video.encodingStatus !== 'stopped' && video.archivesFromLiveSize > 0 && video._otherLoaded && isImbricated),

            mycardLiveStop: (video.type === 'live' && video.encodingStatus === 'stopped' && !isImbricated),
            mycardLiveStopImb: (video.type === 'live' && video.encodingStatus === 'stopped' && (video.archivesFromLiveSize === undefined || video.archivesFromLiveSize === 0) && isImbricated),
            mycardLiveStopwA: (video.type === 'live' && video.encodingStatus === 'stopped' && video.archivesFromLiveSize > 0 && !video._otherLoaded && isImbricated),
            mycardLiveStopwAExp: (video.type === 'live' && video.encodingStatus === 'stopped' && video.archivesFromLiveSize > 0 && video._otherLoaded && isImbricated),

            mycardVOD: (video.type === 'vod' && !video.inAndOutOrigin && !video.archive && !isImbricated),
            mycardVODImb: (video.type === 'vod' && !video.inAndOutOrigin && !video.archive && (video.videoInAndOutSize === undefined || video.videoInAndOutSize === 0) && isImbricated),
            mycardVODwCut: (video.type === 'vod' && !video.inAndOutOrigin && !video.archive && video.videoInAndOutSize > 0 && !video._otherLoaded && isImbricated),
            mycardVODwCutExp: (video.type === 'vod' && !video.inAndOutOrigin && !video.archive && video.videoInAndOutSize > 0 && video._otherLoaded && isImbricated),

            mycardArchive: (video.type === 'vod' && video.archive && !isImbricated),
            mycardCut: (video.type === 'vod' && video.inAndOutOrigin && !isImbricated ),

            mycardArchiveImb: (video.type === 'vod' && video.archive && isImbricated && (video.videoInAndOutSize === undefined || video.videoInAndOutSize === 0)),
            mycardArchiveImbwCut: (video.type === 'vod' && video.archive && isImbricated && (video.videoInAndOutSize > 0 && !video._otherLoaded)),
            mycardArchiveImbwCutExp: (video.type === 'vod' && video.archive && isImbricated && (video.videoInAndOutSize > 0 && video._otherLoaded)),
            
            mycardCutImb: (video.type === 'vod' && video.inAndOutOrigin && isImbricated),
          }" class='col-lg-3 col-md-4 col-sm-6 col-12' v-for="video in videos" v-bind:key="video.uuid">

          <div style="margin-top: 8px">            

            <b-row style="padding: 0px 15px">
              <div style="margin-left:-10px; padding-top: 2px; overflow: auto; white-space: nowrap">
                <b-button variant="emptyNoB" size="sm" v-if="video.encodingStatus === 'encoding' || video.encodingStatus === 'segmented'">
                  <font-awesome-layers v-if="video.type === 'live'">
                    <font-awesome-icon style="color: #ba0000" :icon="['fas', 'video']" transform="right-7" title="Live stream"></font-awesome-icon>
                    <font-awesome-icon style="color: #ba0000" :icon="['fas', 'circle-notch']" transform="shrink-3 left-5" spin title="Live stream, on air"></font-awesome-icon>
                  </font-awesome-layers>
                  <font-awesome-layers v-if="video.type === 'vod'">
                    <font-awesome-icon style="color: #ba0000" :icon="['fas', 'film']" title="VOD, processing..."></font-awesome-icon>
                  </font-awesome-layers>
                  <!--
                  <b-badge v-if="video.type === 'live' && video.archivesFromLive !== undefined && Object.keys(video.archivesFromLive).length > 0" variant="info" style="position:absolute; color:white; left: 30px; top: 9px; font-size:8px" title="Number of archives" size="sm">
                    {{Object.keys(video.archivesFromLive).length}}
                  </b-badge>
                  <b-badge v-if="video.type === 'vod' && video.videoInAndOut !== undefined && Object.keys(video.videoInAndOut).length > 0" variant="success" style="position:absolute; color:white; left: 27px; top: 11px; font-size:8px" title="Number of cut-versions" size="sm">
                    {{Object.keys(video.videoInAndOut).length}}
                  </b-badge>
                  -->
                </b-button>

                <b-button variant="emptyNoB" size="sm" v-else-if="video.encodingStatus === 'encoded'">
                  <font-awesome-layers v-if="video.type === 'live' && video.keepLive === false" title="Live stream, not kept as a VOD.">
                    <font-awesome-icon style="color: #2F90B0" :icon="['fas', 'video']" ></font-awesome-icon>
                    <font-awesome-icon style="color:red" icon="slash" />
                  </font-awesome-layers>
                  <font-awesome-layers v-else-if="video.type === 'live'" title="Live stream">
                    <font-awesome-icon style="color: #2F90B0" :icon="['fas', 'video']" ></font-awesome-icon>
                  </font-awesome-layers>
                  <font-awesome-layers v-if="video.type === 'vod'" >
                    <font-awesome-icon 
                    style="color: #17a2b8" 
                    :icon="['fas', 'video']"
                    transform="shrink-5 right-6 up-6"
                    v-if="video.archive"
                    title="Archive from a Live"
                    />
                    <font-awesome-icon 
                    style="color: #5cb85c" 
                    :icon="['fas', 'cut']" 
                    transform="shrink-5 left-7 up-6"
                    v-if="video.inAndOutOrigin"
                    title="Cut-version"
                    />
                    <font-awesome-icon style="color: #2F90B0" :icon="['fas', 'film']" title="VOD" />
                  </font-awesome-layers>

                  <!--
                  <b-badge v-if="video.type === 'vod' && video.videoInAndOut !== undefined && Object.keys(video.videoInAndOut).length > 0" variant="success" style="position:absolute; color:white; left: 27px; top: 11px; font-size:8px" title="Number of cut-versions" size="sm">
                    {{Object.keys(video.videoInAndOut).length}}
                  </b-badge>
                  -->

                </b-button>

                <b-button variant="emptyNoB" size="sm" v-else-if="video.encodingStatus === 'stopped'">
                  <font-awesome-icon v-if="video.type === 'live'" style="color: black" :icon="['fas', 'video']" title="Live stream" />
                  <font-awesome-icon v-if="video.type === 'vod'" style="color: black" :icon="['fas', 'film']" title="VOD" />

                  <!--
                  <b-badge v-if="video.type === 'live' && video.archivesFromLive !== undefined && Object.keys(video.archivesFromLive).length > 0" variant="info" style="position:absolute; color:white; left: 27px; top: 9px; font-size:8px" title="Number of archives" size="sm">
                    {{Object.keys(video.archivesFromLive).length}}
                  </b-badge>
                  <b-badge v-if="video.type === 'vod' && video.videoInAndOut !== undefined && Object.keys(video.videoInAndOut).length > 0" variant="success" style="position:absolute; color:white; left: 27px; top: 11px; font-size:8px" title="Number of cut-versions" size="sm">
                    {{Object.keys(video.videoInAndOut).length}}
                  </b-badge>
                  -->
                </b-button>
                
                <b-button variant="emptyNoB" size="sm" v-else-if="video.encodingStatus === 'uploading'">
                  <font-awesome-layers v-if="video.type === 'live'">
                    <font-awesome-icon style="color: #14BF98" :icon="['fas', 'video']" title="Live stream, starting..."></font-awesome-icon>
                  </font-awesome-layers>
                  <font-awesome-layers v-if="video.type === 'vod'">
                    <font-awesome-icon style="color: #14BF98" :icon="['fas', 'film']" title="VOD, uploading..."></font-awesome-icon>
                  </font-awesome-layers>
                </b-button>
                
                <b-button variant="emptyNoB" size="sm" v-else-if="video.encodingStatus === 'upload-failed'">
                  <font-awesome-layers v-if="video.type === 'live'">  
                    <font-awesome-icon style="color: red" :icon="['fas', 'video']" title="Live stream, prepation error"></font-awesome-icon>
                  </font-awesome-layers>
                  <font-awesome-layers v-if="video.type === 'vod'">
                    <font-awesome-icon style="color: red" :icon="['fas', 'film']" title="VOD, upload error"></font-awesome-icon>
                  </font-awesome-layers>
                </b-button>
                
                <b-button variant="emptyNoB" size="sm" v-else-if="video.encodingStatus === 'error'">
                  <font-awesome-layers v-if="video.type === 'live'">
                    <font-awesome-icon style="color: red" :icon="['fas', 'video']" title="Live stream, error"></font-awesome-icon>
                  </font-awesome-layers>
                  <font-awesome-layers v-if="video.type === 'vod'">
                    <font-awesome-icon style="color: red" :icon="['fas', 'film']" title="VOD, error"></font-awesome-icon>
                  </font-awesome-layers>
                </b-button>
                
                <b-button variant="emptyNoB" size="sm" v-else>
                  <font-awesome-layers v-if="video.type === 'live'">
                    <font-awesome-icon style="color: orange" :icon="['fas', 'video']" title="Live stream, processing..."></font-awesome-icon>
                  </font-awesome-layers>
                  <font-awesome-layers v-if="video.type === 'vod'">
                    <font-awesome-icon style="color: orange" :icon="['fas', 'film']" title="VOD, processing..."></font-awesome-icon>
                  </font-awesome-layers>
                </b-button>

                <span v-if="video.keepLive === true && (video.encodingStatus === 'encoded' || video.encodingStatus === 'stopped')">

                  <!--<b-button variant="emptyB" size="sm" @click="video.download = !video.download; updateDownload(video)">
                    <font-awesome-layers  v-if="video.download === true" title="Downloadable, click to change">
                      <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
                      <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" transform="shrink-4 up-7 right-7" />
                    </font-awesome-layers>
                    <font-awesome-layers v-if="video.download === false" title="Not downloadable, click to change">
                      <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
                      <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" transform="shrink-4 up-7 right-7" />
                    </font-awesome-layers>
                  </b-button>-->
                  <b-button variant="emptyB" size="sm" @click="video.download = !video.download; updateDownload(video)" v-if="video.type === 'vod'">
                    <font-awesome-layers  v-if="video.type === 'vod' && video.download === true" title="Downloadable, click to change">
                      <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
                      <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" transform="shrink-4 up-5 right-7" />
                    </font-awesome-layers>

                    <font-awesome-layers v-if="video.type === 'vod' && video.download === false" title="Not downloadable, click to change">
                      <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
                      <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" transform="shrink-4 up-5 right-7" />
                    </font-awesome-layers>
                  </b-button>
                  <b-button variant="emptyB" size="sm" @click="video.downloadLive = !video.downloadLive; updateDownload(video)" v-if="video.type === 'live'">
                    <font-awesome-layers  v-if="video.type === 'live' && video.downloadLive === true" title="Downloadable, click to change">
                      <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
                      <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" transform="shrink-4 up-5 right-7" />
                    </font-awesome-layers>

                    <font-awesome-layers v-if="video.type === 'live' && (!video.downloadLive || video.downloadLive === false)" title="Not downloadable, click to change">
                      <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
                      <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" transform="shrink-4 up-5 right-7" />
                    </font-awesome-layers>
                  </b-button>

                  <input type="file" name="file" :id="'file' + video.uuid" class="inputfile" @input="addChapterFile($event, video); putChapterFile(video)" />
                  <b-button variant="emptyB" size="sm" >
                    <label :for="'file'+video.uuid" style="margin-bottom:0px" >
                      <font-awesome-layers title="Click to charge chapters file">
                        <font-awesome-icon :icon="['fas', 'list-ol']" />
                        <font-awesome-layers-text v-if="video.chapters !== undefined && video.chapters.length !== 0"
                          class="fa-inverse" 
                          transform="shrink-4 up-5 right-6"
                          style="color:#14BF98; background-color: white; font-weight: bold"
                          :title="video.chapters.length+' chapter(s) present'"
                          :value="video.chapters.length" />
                        <font-awesome-layers-text v-else
                          class="fa-inverse" 
                          transform="shrink-4 up-5 right-6"
                          style="color:#14BF98; background-color: white; font-weight: bold"
                          title="No chapters"
                          value=0 />
                      </font-awesome-layers>
                    </label>
                  </b-button>

                  <b-button variant="emptyB" size="sm" v-if="video.chapters !== undefined && video.chapters.length !== 0" title="Delete chapters" @click="deleteChapters(video)">
                    <font-awesome-layers>
                      <font-awesome-icon :icon="['fas', 'list-ol']"></font-awesome-icon>
                      <font-awesome-icon style="color: red" :icon="['fas', 'times']" transform="shrink-5 up-5 right-6" />
                    </font-awesome-layers>
                  </b-button>
                  <b-button variant="emptyNoB" size="sm" v-else title="Delete chapters" disabled>
                    <font-awesome-layers>
                      <font-awesome-icon :icon="['fas', 'list-ol']"></font-awesome-icon>
                      <font-awesome-icon style="color: red" :icon="['fas', 'times']" transform="shrink-5 up-5 right-6" />
                    </font-awesome-layers>
                  </b-button>
                </span>

                <span v-else-if="video.keepLive === true">

                  <b-button variant="emptyB" size="sm" @click="video.download = !video.download; updateDownload(video)">
                    <font-awesome-layers  v-if="video.download === true" title="All the archives will be downloadable, click to change">
                      <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
                      <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" transform="shrink-4 up-6 right-7" />
                    </font-awesome-layers>
                    <font-awesome-layers v-if="video.download === false" title="All the archives will not downloadable, click to change.">
                      <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
                      <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" transform="shrink-4 up-6 right-7" />
                    </font-awesome-layers>
                  </b-button>

                  <input type="file" name="file" :id="'file' + video.uuid" class="inputfile" @input="addChapterFile($event, video); putChapterFile(video)" />
                  <b-button variant="emptyB" size="sm" >
                    <label :for="'file'+video.uuid" style="margin-bottom:0px; cursor:pointer" >
                      <font-awesome-layers title="Click to charge chapters file. It will be applied when the encoding is complete and the video is stored as a VOD.">
                        <font-awesome-icon :icon="['fas', 'list-ol']" />
                        <font-awesome-layers-text v-if="video.chapters !== undefined && video.chapters.length !== 0"
                        class="fa-inverse" 
                        transform="shrink-4 up-5 right-6"
                        style="color:#14BF98; background-color: white; font-weight: bold"
                        :title="video.chapters.length+' chapter(s) present'"
                        :value="video.chapters.length" />              
                        <font-awesome-layers-text v-else
                        class="fa-inverse" 
                        transform="shrink-4 up-5 right-6"
                        style="color:#14BF98; background-color: white; font-weight: bold"
                        title="No chapters"
                        value=0 />
                      </font-awesome-layers>
                    </label>
                  </b-button>

                  <b-button variant="emptyB" size="sm" v-if="video.chapters !== undefined && video.chapters.length !== 0" title="Delete chapters. It will be applied when the encoding is complete and the video is stored as a VOD." @click="deleteChapters(video)">
                    <font-awesome-layers>
                      <font-awesome-icon :icon="['fas', 'list-ol']"></font-awesome-icon>
                      <font-awesome-icon style="color: red" :icon="['fas', 'times']" transform="shrink-5 up-5 right-6" />
                    </font-awesome-layers>
                  </b-button>
                  <b-button variant="emptyNoB" size="sm" v-else title="Delete chapters. It will be applied when the encoding is complete and the video is stored as a VOD." disabled>
                    <font-awesome-layers>
                      <font-awesome-icon :icon="['fas', 'list-ol']"></font-awesome-icon>
                      <font-awesome-icon style="color: red" :icon="['fas', 'times']" transform="shrink-5 up-5 right-6" />
                    </font-awesome-layers>
                  </b-button>
                </span>

                <span v-else>
                  <b-button variant="emptyNoB" size="sm" disabled title="This live is not kept as a VoD at the end of the stream. This feature is hence not available.">
                    <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
                  </b-button>

                  <b-button variant="emptyNoB" size="sm" disabled title="This live is not kept as a VoD at the end of the stream. This feature is hence not available.">
                    <font-awesome-layers>
                      <font-awesome-icon :icon="['fas', 'list-ol']" />
                      <font-awesome-layers-text
                      class="fa-inverse" 
                      transform="shrink-4 up-5 right-6"
                      style="color:#14BF98; background-color: white; font-weight: bold"
                      title="No chapters"
                      value=0 />
                    </font-awesome-layers>
                  </b-button>

                  <b-button variant="emptyNoB" size="sm" disabled title="This live is not kept as a VoD at the end of the stream. This feature is hence not available.">
                    <font-awesome-layers>
                      <font-awesome-icon :icon="['fas', 'list-ol']"></font-awesome-icon>
                      <font-awesome-icon style="color: red" :icon="['fas', 'times']" transform="shrink-5 up-5 right-6" />
                    </font-awesome-layers>
                  </b-button>
                </span>

                <b-button variant="emptyB" size="sm" @click="videocopy=video; copyLink(video); showAndHideModal('confirmClickExport')" title="Copy iFrame code">
                  <font-awesome-icon :icon="['fas', 'file-export']" />
                </b-button>
                <b-button variant="emptyB" size="sm" @click="videocopy=video; copyDirectLink(video); showAndHideModal('confirmClickDirectLink')" title="Copy direct link">
                  <font-awesome-icon :icon="['fas', 'link']" />
                </b-button>
                <b-button variant="emptyB" size="sm" title="Delete" @click="videoToDelete = video; showModal('confirmOneDelete')" >
                  <font-awesome-icon style="color: red" :icon="['fas', 'trash']" />
                </b-button>
                <b-button variant="empty" v-if="video.uuid === focus" title="Last video opened" size="sm" disabled >
                  <font-awesome-icon style="color: #14BF98" :icon="['fas', 'eye']" />
                </b-button>

              </div>
            </b-row>

            <b-row  v-if="!video._modifyTitle" class="align-items-center" >
              <b-col cols=10 class="pointerEltVideo m-0 pr-0" style="padding-left: 15px" @click="startVideo(video)" :title="'Click to open '+video.title+ ' page and see all video details'">
                <h6 style="margin: 3px 0px; padding: 0px 0px 3px; border-bottom: 1px solid #2F90B0; border-radius:0; text-overflow: ellipsis; overflow: hidden; white-space: nowrap"><strong>{{video.title}}</strong></h6>
              </b-col>
              <b-col cols=2 class="p-0" title="Click to modify title">
                <b-button variant="emptyB" @click="video._modifyTitle = true; videos = videos.splice(0); video._title=video.title" size="sm">
                  <font-awesome-icon :icon="['fas', 'pencil-alt']" />
                </b-button>
              </b-col>
            </b-row>

            <b-row  v-if="video._modifyTitle" class="align-items-center" title="Video title modification">
              <b-col cols=12 style="margin:0px; padding: 0px 10px">
                <b-form @submit.prevent="updateTitle(video)" style="margin-top:5px; margin-bottom:5px">
                  <b-input-group>
                    <b-input type="text" v-model="video._title"></b-input>
                    <b-input-group-append style="align-items: center;justify-content: flex-end">
                      <b-button variant="bordered" @click="updateTitle(video)" type=submit>
                        <font-awesome-icon class="pointerEltSB" style="color:#14BF98" :icon="['fas', 'check']" />
                      </b-button>
                      <b-button variant="borderedx" @click="video._title=video.title; video._modifyTitle = false; videos = videos.splice(0);">
                        <font-awesome-icon class="pointerEltSB" style="color:red" :icon="['fas', 'times']" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form>
              </b-col>
            </b-row>

            <b-row :title="'Author of the video: '+video.user+' (click to see all video details)'" @click="startVideo(video)">
              <b-col cols="12">
                <p style="font-size:14px; margin-bottom: 10px; padding-bottom:5px; color: #2a5d77; text-overflow: ellipsis; overflow: hidden; white-space: nowrap" v-if="video.user && video.user !== ''">
                  {{$ml.get('by')}}
                  <strong> {{video.user}}</strong>
                </p>
              </b-col>
            </b-row>

            <b-row class="justify-content-center">
              <div class="previewContainer" style="z-index:1">
                <b-img @click="startVideo(video)" class="previewImg" style="object-fit:contain; cursor:pointer" :src="video.manifest.thumbnail" @error="imgUrlAlt($event, video)" title="Click on the image to launch video page" fluid></b-img>
                <div style="position:absolute; z-index:2; left: 5px; top: 3px" title="Select the video">
                  <b-form-checkbox v-model="video._isSelected" @input="updateSelectedNumber"></b-form-checkbox>
                </div>
                <b-button v-if="video.isPassword === true" variant="db-sbi" size="sm" style="position:absolute; z-index:2; right: 3px; top:3px" disabled title="Password-protected stream">
                  <font-awesome-icon icon="lock" /> 
                </b-button>
                <b-button v-if="video.startDate" variant="db-sbi" size="sm" style="position:absolute; z-index:2; left: 3px; bottom:3px; font-size:10px" disabled title="Delayed start">
                  <font-awesome-layers style="margin-right:5px">
                    <font-awesome-icon icon="share" />
                    <font-awesome-icon icon="play" transform="shrink-7 right-13 up-2" />
                  </font-awesome-layers>
                  {{adjustDate(video.startDate)}}
                </b-button>
                <b-button v-if="video.deleteDate" variant="db-sbi" size="sm" style="position:absolute; z-index:2; right: 3px; bottom:3px; font-size:10px" disabled title="Delayed destruction">
                  <font-awesome-layers style="margin-right:5px">
                    <font-awesome-icon icon="share" />
                    <font-awesome-icon style="color:red" icon="trash" transform="shrink-4 right-14 up-3" />
                  </font-awesome-layers>
                  {{adjustDate(video.deleteDate)}}
                </b-button>
              </div>
            </b-row>
            <b-row v-if="video && video.authorizationKey && video.authorizationKey.indexOf('cam') > -1" class="justify-content-center">
              <small style="font-size:11px; margin:8px" title="Camera">
                {{video.authorizationKey}}
              </small>
            </b-row>
            <b-row @click="startVideo(video)" class="justify-content-around">
              <small style="font-size:11px; margin:8px" title="Video creation date">
                <font-awesome-icon :icon="['fas', 'calendar-minus']" /> 
                {{video.createdDate}}
              </small>
              <small style="font-size:11px; margin:8px" v-if="video.type !== 'live'" title="Video duration">
                <font-awesome-icon :icon="['fas', 'clock']" /> 
                {{video.duration2}}
              </small>
              <small style="font-size:11px; margin:8px" v-if=" (video.type === 'live' && video.keepLive)" title="Total live duration">
                <font-awesome-icon :icon="['fas', 'clock']" /> 
                {{video.duration2}}
              </small>
              <small style="font-size:11px; margin:8px" 
              :style="(video.lastModifyAt === video.createdAt) ? 'color:#9a9fa2':''" 
              :title="(video.lastModifyAt === video.createdAt) ?  'Not yet modified, same as original':'Date of last modification'">
                <font-awesome-layers >
                  <font-awesome-icon
                    :icon="['fas', 'circle']"
                    transform="shrink-12"
                  />
                  <font-awesome-icon :icon="['fas', 'redo-alt']" />
                </font-awesome-layers>
                {{adjustDate(video.lastModifyAt)}}
              </small>
            </b-row>

            <b-row class="justify-content-around align-items-center m-1 p-1" style="border-top:1px solid #2a5d77; border-bottom:1px solid #2a5d77">
              <b-badge v-if="video.type === 'live' && video.encodingStatus === 'encoding'" style="font-size:11px; background-color:#ba0000; padding:5px" title="Live stream, on air" >
                <div class="d-flex align-items-center">
                  <font-awesome-icon transform="shrink-2" style="margin-right:2px" icon="circle-notch" spin />
                  <span if="video._liveDuration">{{video._liveDuration}} &nbsp;</span>
                  LIVE&nbsp;
                  <b-img v-if="video.liveCamera === true" fluid :src="require(`@/assets/webcam_W.png`)" style="max-height:10px; color:white" title="From camera" />                  
                  <font-awesome-icon v-if="video.liveCamera !== true && video.liveType === 'quanteecRTMP'" :icon="['fab', 'affiliatetheme']" title="From streaming software (RTMP)" />
                  <font-awesome-icon v-if="video.liveCamera !== true && video.liveType === 'custom'" :icon="['fas', 'stream']" title="Custom stream" />
                </div>
              </b-badge>
              <b-badge variant="secondary" v-else-if="video.type === 'live'" style="font-size:11px; padding:5px" title="Live stream, stoppedddd" >
                <div class="d-flex align-items-center">
                  LIVE&nbsp;
                  <b-img v-if="video.liveCamera === true" fluid :src="require(`@/assets/webcam_W.png`)" style="max-height:10px; color:white" title="From camera" />
                  <font-awesome-icon v-if="video.liveCamera !== true && video.liveType === 'quanteecRTMP'" :icon="['fab', 'affiliatetheme']" title="From streaming software (RTMP)" />
                  <font-awesome-icon v-if="video.liveCamera !== true && video.liveType === 'custom'" :icon="['fas', 'stream']" title="Custom stream" />
                </div>
              </b-badge>

              <b-button variant="emptyB" size="sm" title="Click to stop process" @click="videoToStopEnc = video; showModal('confirmOneStopEncoding')" v-if="video.encodingStatus === 'encoding' || video.encodingStatus === 'segmented'">
                <div style="color: #ba0000">
                  <font-awesome-icon :icon="['fas', 'cog']" spin />
                  <strong style="margin-right:2px; margin-left:2px" v-text="$ml.get('encoding')"></strong>
                  <font-awesome-icon :icon="['fas', 'stop-circle']" />
                   <strong v-if="video.bunnyPlayable" style="margin-right:2px; margin-left:2px" v-text="$ml.get('playable')"></strong>

                  <span style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></span>

                  <span v-else style="margin-left: 1rem">
                    <span v-if="(!video.inputQualities || video.inputQualities === 'QuanteecOptimization') && video.currentNumberOfQualities" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                      <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                      <span> {{video.currentNumberOfQualities}}Q</span>
                    </span>
                    <span v-else-if="video.currentNumberOfQualities" :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                      <strong>C</strong>
                      <span> {{video.currentNumberOfQualities}}Q</span>
                    </span>
                  </span>
                </div>
              </b-button>

              <b-button variant="emptyB" size="sm" title="Click to stop process" v-else-if="video.encodingStatus === 'uploading'">
                <div style="color: #14BF98">
                  <font-awesome-icon :icon="['fas', 'cog']" spin />
                  <strong style="margin-right:2px; margin-left:2px" v-text="$ml.get('uploading')"></strong>
                  <font-awesome-icon :icon="['fas', 'stop-circle']" />
                  <span style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></span>
                  <span v-else style="margin-left: 1rem">
                    <span v-if="(!video.inputQualities || video.inputQualities === 'QuanteecOptimization') && video.currentNumberOfQualities" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                      <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                      <span> {{video.currentNumberOfQualities}}Q</span>
                    </span>
                    <span v-else-if="video.currentNumberOfQualities" :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                      <strong>C</strong>
                      <span> {{video.currentNumberOfQualities}}Q</span>
                    </span>
                  </span>
                </div>
              </b-button>

              <b-button variant="emptyB" size="sm" title="Click to stop process" v-else-if="video.encodingStatus === 'upload_failed'">
                <div style="color: red">
                  <font-awesome-icon :icon="['fas', 'cog']" />
                  <strong style="margin-right:2px; margin-left:2px" v-text="$ml.get('uploadfailed')"></strong>
                  <span style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></span>
                  <span v-else style="margin-left: 1rem">
                    <span v-if="(!video.inputQualities || video.inputQualities === 'QuanteecOptimization') && video.currentNumberOfQualities" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                      <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                      <span> {{video.currentNumberOfQualities}}Q</span>
                    </span>
                    <span v-else-if="video.currentNumberOfQualities" :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                      <strong>C</strong>
                      <span> {{video.currentNumberOfQualities}}Q</span>
                    </span>
                  </span>
                </div>
              </b-button>

              <b-button variant="emptyB" size="sm" title="Click to stop process" @click="videoToStopEnc = video; showModal('confirmOneStopEncoding')" v-else-if="video.encodingStatus === 'restart'">
                <div style="color:orange">
                  <font-awesome-icon :icon="['fas', 'cog']" spin />
                  <strong style="margin-right:2px; margin-left:2px" v-text="$ml.get('restarting')"></strong>
                  <font-awesome-icon :icon="['fas', 'stop-circle']" />
                  <span style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></span>
                  <span v-else style="margin-left: 1rem">
                    <span v-if="(!video.inputQualities || video.inputQualities === 'QuanteecOptimization') && video.currentNumberOfQualities" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                      <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                      <span> {{video.currentNumberOfQualities}}Q</span>
                    </span>
                    <span v-else-if="video.currentNumberOfQualities" :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                      <strong>C</strong>
                      <span> {{video.currentNumberOfQualities}}Q</span>
                    </span>
                  </span>
                </div>
              </b-button>

              <b-button 
              size="sm"
              v-else-if="video.encodingStatus === 'stopped'"
              :variant="(video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive') ? 'emptyNoB':'emptyB'"
              :title="(video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive') ? '':'Click to re-start live'" 
              @click="if(video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive') {videoToReencode = video; showModal('confirmOneRestartEncoding')}"  
              :disabled="video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive'"
              >
                <div style="color:black">
                  <font-awesome-icon :icon="['fas', 'cog']" />
                  <strong style="margin-right:2px; margin-left:2px" v-text="$ml.get('stopped')"></strong>
                  <font-awesome-icon v-if="video.sourcePath && video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive'" :icon="['fas', 'sync']" transform="shrink-4" />

                  <span style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></span>

                  <span v-else style="margin-left: 1rem">
                    <span v-if="(!video.inputQualities || video.inputQualities === 'QuanteecOptimization') && video.currentNumberOfQualities" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                      <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                      <span> {{video.currentNumberOfQualities}}Q</span>
                    </span>
                    <span v-else-if="video.currentNumberOfQualities" :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                      <strong>C</strong>
                      <span> {{video.currentNumberOfQualities}}Q</span>
                    </span>
                  </span>
                </div>
              </b-button>

              <b-button 
                size="sm"
                v-else-if="video.encodingStatus === 'encoded'"
                :variant="(video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive') ? 'emptyNoB':'emptyB'"
                :title="(video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive') ? '':'Click to re-encode VOD'" 
                @click="if(video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive') {videoToReencode = video; showModal('confirmOneRestartEncoding')}"  
                :disabled="video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive'"
              >
                  <div style="color: #2F90B0">
                    <font-awesome-icon :icon="['fas', 'cog']" /> 
                    <span style="margin-right:2px; margin-left:2px" v-text="$ml.get('encoded')"></span> 
                    <font-awesome-icon v-if="video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive'" :icon="['fas', 'sync']" transform="shrink-4" />

                    <span style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></span>

                    <span v-else style="margin-left: 1rem">
                      <span v-if="(!video.inputQualities || video.inputQualities === 'QuanteecOptimization') && video.currentNumberOfQualities" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                        <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                        <span> {{video.currentNumberOfQualities}}Q</span>
                      </span>
                      <span v-else-if="video.currentNumberOfQualities" :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                        <strong>C</strong>
                        <span> {{video.currentNumberOfQualities}}Q</span>
                      </span>
                    </span>
                  </div>
              </b-button>

              <b-button variant="emptyB" size="sm" title="Click to re-launch process" @click="if(video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive'){videoToReencode = video; showModal('confirmOneRestartEncoding')}" v-else-if="video.encodingStatus === 'error'">
                <div style="color: red">
                  <font-awesome-icon :icon="['fas', 'cog']" />
                  <strong style="margin-right:2px; margin-left:2px" v-text="$ml.get('error')"></strong>
                  <font-awesome-icon v-if="video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive'" :icon="['fas', 'sync']" transform="shrink-4"/>

                  <span style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></span>

                  <span v-else style="margin-left: 1rem">
                    <span v-if="(!video.inputQualities || video.inputQualities === 'QuanteecOptimization') && video.currentNumberOfQualities" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                      <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                      <span> {{video.currentNumberOfQualities}}Q</span>
                    </span>
                    <span v-else-if="video.currentNumberOfQualities" :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                      <strong>C</strong>
                      <span> {{video.currentNumberOfQualities}}Q</span>
                    </span>
                  </span>
                </div>
              </b-button>

              <b-button variant="emptyB" size="sm" title="Click to stop process" @click="videoToStopEnc = video; showModal('confirmOneStopEncoding')" v-else>
                <div style="color: orange">
                  <font-awesome-icon :icon="['fas', 'cog']" spin />
                  <strong style="margin-right:2px; margin-left:2px"> {{(video.encodingStatus === "waiting_for_encoding") ? $ml.get('waiting') : video.encodingStatus+'...'}} </strong>
                  <font-awesome-icon :icon="['fas', 'stop-circle']" />

                  <span style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></span>

                  <span v-else style="margin-left: 1rem">
                    <span v-if="(!video.inputQualities || video.inputQualities === 'QuanteecOptimization') && video.currentNumberOfQualities" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                      <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                      <span> {{video.currentNumberOfQualities}}Q</span>
                    </span>
                    <span v-else-if="video.currentNumberOfQualities" :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                      <strong>C</strong>
                      <span> {{video.currentNumberOfQualities}}Q</span>
                    </span>
                  </span>
                </div>
              </b-button>

              <small style="color: red; margin-left: 1rem" :title="`Critical error(s) ${(!!video.errorType) ? '(' + video.errorType + ')' : ''}`" v-if="video.error === true && (video.encodingStatus !== 'stopped' || video.type !== 'live')">
                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
              </small>

              <div v-if="video.archivesFromLive || video.videoInAndOut">

                <b-badge style="margin-left: 1rem; cursor: pointer;" v-if="video.type === 'live' && video.archivesFromLive !== undefined && Object.keys(video.archivesFromLive).length > 0 && video._otherLoaded && isImbricated" variant="info" title="Number of archives, click to hide" size="sm" @click="unloadOtherVideos(video)">
                  {{Object.keys(video.archivesFromLive).length}}
                  <font-awesome-icon size="xs" icon="chevron-left" />
                </b-badge>
                <b-badge style="margin-left: 1rem; cursor: pointer;" v-if="video.type === 'live' && video.archivesFromLive !== undefined && Object.keys(video.archivesFromLive).length > 0 && !video._otherLoaded && isImbricated" variant="info" title="Number of archives, click to show below" size="sm" @click="loadOtherVideos(video)">
                  {{Object.keys(video.archivesFromLive).length}}
                  <font-awesome-icon size="xs" icon="chevron-right" />
                </b-badge>

                <b-badge style="margin-left: 1rem; cursor: pointer;" v-if="video.type === 'vod' && video.videoInAndOut !== undefined && Object.keys(video.videoInAndOut).length > 0 && video._otherLoaded && isImbricated" variant="success" title="Number of cut-versions, click to hide" size="sm" @click="unloadOtherVideos(video)">
                  {{Object.keys(video.videoInAndOut).length}}
                  <font-awesome-icon size="xs" icon="chevron-left" />
                </b-badge>
                <b-badge style="margin-left: 1rem; cursor: pointer;" v-if="video.type === 'vod' && video.videoInAndOut !== undefined && Object.keys(video.videoInAndOut).length > 0 && !video._otherLoaded && isImbricated" variant="success" title="Number of cut-versions,click to show below" size="sm" @click="loadOtherVideos(video)">
                  {{Object.keys(video.videoInAndOut).length}}
                  <font-awesome-icon size="xs" icon="chevron-right" />
                </b-badge>

                <b-badge style="margin-left: 1rem" v-if="video.type === 'live' && video.archivesFromLive !== undefined && Object.keys(video.archivesFromLive).length > 0 && !isImbricated" variant="info" title="Number of archives, switch to imbricated mode to show them below" size="sm" @click="loadOtherVideos(video)">
                  {{Object.keys(video.archivesFromLive).length}}
                </b-badge>
                <b-badge style="margin-left: 1rem" v-if="video.type === 'vod' && video.videoInAndOut !== undefined && Object.keys(video.videoInAndOut).length > 0 && !isImbricated" variant="success" title="Number of cut-versions, switch to imbricated mode to show them below" size="sm">
                  {{Object.keys(video.videoInAndOut).length}}
                </b-badge>

                <b-badge variant="info" style="margin-left: 2px" v-if="video._otherLoaded && video.type === 'live' && isImbricated" @click="loadOtherVideos(video)" title="Refresh list of Archives">
                  <font-awesome-icon size="xs" icon="sync" />
                </b-badge>
                <b-badge variant="success" style="margin-left: 2px" v-if="video._otherLoaded && video.type === 'vod' && video.videoInAndOut !== undefined && isImbricated" @click="loadOtherVideos(video)" title="Refresh list of Cut-versions">
                  <font-awesome-icon size="xs" icon="sync" />
                </b-badge>

              </div>

              <b-col cols="12" v-if="['encoding', 'segmented'].indexOf(video.encodingStatus) > -1 && video.type === 'vod' && video.encodingPercent < 100" title="Current progress of the encoding process">
                <b-progress :max="100" > 
                  <b-progress-bar :value="video.encodingPercent" animated variant="primary">
                    {{video.encodingPercent}}%
                  </b-progress-bar>
                </b-progress>              
                <p title="Time to finish encoding process" style="text-align:center; margin:2px"><small><font-awesome-icon :icon="['fas', 'stopwatch']" ></font-awesome-icon> {{video.encodingETA}}</small></p>
              </b-col>
              <b-col cols="12" v-else-if="video.encodingStatus === 'uploading' && video.type === 'vod'" title="Current progress of the uploading process">
                <b-progress :max="100" > 
                  <b-progress-bar :value="video.uploadingPercent" animated variant="primary">
                    {{video.uploadingPercent}}%
                  </b-progress-bar>
                </b-progress>
                <p title="Time to finish uploading process (click to see video details)" style="text-align:center; margin:2px"><small><font-awesome-icon :icon="['fas', 'stopwatch']" ></font-awesome-icon> {{video.uploadingETA}}</small></p>
              </b-col>
            </b-row>

            <div @click="startVideo(video)" title="Click to see video details" class="scrollmenu" style="padding-top:10px">
              <p title="Total viewing time"><small><font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon> {{video.hourview_unit || '0s'}}</small></p>
              <p title="Maximum concurrent viewers over the period"><small><font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon> {{video.concurrentUsers || '0'}}</small></p>
              <p title="Mean viewing time"><small><font-awesome-icon :icon="['fas', 'stopwatch']"></font-awesome-icon> {{video.meanTime_unit || '0s'}}</small></p>
            </div>

            <div @click="startVideo(video)" title="Click to see video details" class="scrollmenu">
              <p title="Best quality %"><small><font-awesome-icon :icon="['fas', 'signal']"></font-awesome-icon> {{video.bestQualityPercent_unit || '100%'}}</small></p>
              <p title="Average bitrate"><small>&#x7E; {{video.bitrate_unit || '0kbps'}}</small></p>
              <p title="Rebuffering %">
                <small v-bind:class="{
                  green: (video.rebuff < 20 && !(video.error === true)),
                  orange: (video.rebuff >= 20 && video.rebuff < 50 && !(video.error === true)),
                  red: (video.rebuff >= 50 && !(video.error === true)),
                  black: (video.error === true || !video.hasOwnProperty('rebuff')),
                }"
                >
                  <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon> {{video.rebuff_unit || '0%'}}
                </small>
              </p>
            </div>
  
            <div @click="startVideo(video)" title="Click to see video details" class="scrollmenu">
              <p title="Efficiency %"><small><font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon> {{video.offload_unit || '0'}}</small></p>
              <p title="Data delivered"><small><font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon> {{video.dataDelivered_unit || '0'}}</small></p>
              <p title="Data delivered by peers"><small><font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon> {{video.totalMB_peer_unit || '0'}}</small></p>
            </div>

            <div @click="startVideo(video)" title="Click to see video details" class="scrollmenu">
              <p title="Energy saved %"><small><font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon> {{video.energySaved_unit || '0%'}}</small></p>
              <p title="KWh spent"><small><font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon> {{video.kwhSpent_unit || '0wh'}}</small></p>
              <p title="CO2 spent"><small><font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon> {{video.co2Spent_unit || '0g'}}</small></p>
            </div>

            <div @click="startVideo(video)" title="Click to see video details" style="padding-top:10px; border-top:1px solid #2a5d77" />

            <b-row v-if="!video._modifyTags" class="pointerEltVideo" @click="startModifyTags(video)" title="Video tags, click to modify">
              <b-col cols="12">
                <p v-if="video.tags && video.tags.length > 0" style="margin:0px">
                  <small><font-awesome-layers>
                    <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180"></font-awesome-icon>
                    <font-awesome-icon :icon="['fas', 'tags']" transform="shrink-2"></font-awesome-icon>
                  </font-awesome-layers>
                  <span v-for="tag in video.tags">
                    &nbsp;{{tag}}
                  </span>
                  </small>
                </p>
                <p style="margin:0px" v-else>
                  <small><font-awesome-layers>
                    <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180"></font-awesome-icon>
                    <font-awesome-icon :icon="['fas', 'tags']" transform="shrink-2"></font-awesome-icon>
                  </font-awesome-layers> 
                  &nbsp;-</small>
                </p>
              </b-col>
            </b-row>

            <b-row v-if="video._modifyTags" class="align-items-center" title="Video tags modification">
              <b-col cols="10">
                <b-form-tags style="font-size:85%" element-id="tags" 
                v-model="video._tags" @tags-updated="updateTags(video)" placeholder="Add a Tag and press Enter"></b-form-tags>
              </b-col>
              <b-col cols="2" style="padding:0px; margin-left:-10px">
                <b-button variant="empty" @click="endModifyTags(video)" type=submit>
                  <small><font-awesome-icon style="color:#14BF98" :icon="['fas', 'check']" /></small>
                </b-button>
                <b-button variant="empty" @click="videos = videos.splice(0); video._modifyTags=false">
                  <small><font-awesome-icon style="color:red" :icon="['fas', 'times']" /></small>
                </b-button>
              </b-col>
            </b-row>

            <b-row v-if="!video._modifyDescription" class="pointerEltVideo" @click="video._modifyDescription = !video._modifyDescription; video._desc=video.description; videos=videos.splice(0)" style="margin-top:10px" title="Video description, click to modify">
              <b-col cols="12">
                <p style="margin-bottom:5px;overflow-wrap: break-word;" v-if="video.description && video.description !== ''">
                  <small><font-awesome-layers>
                    <font-awesome-icon :icon="['fas', 'file-alt']" />
                    <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180" />
                  </font-awesome-layers>
                  &nbsp;{{video.description}}</small>
                </p>
                <p style="margin-bottom:5px" v-else>
                  <small><font-awesome-layers>
                    <font-awesome-icon :icon="['fas', 'file-alt']" />
                    <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180" />
                  </font-awesome-layers>
                  &nbsp;-</small>
                </p>
              </b-col>
            </b-row>

            <b-row class="align-items-center" v-if="video._modifyDescription" title="Video description modification">
              <b-col cols="10">
                <b-form @submit.prevent="updateDescription(video)">
                  <b-form-textarea
                  id="textarea"
                  v-model="video._desc"
                  placeholder="Write description here"
                  rows="1"
                  max-rows="2"
                  style="font-size:85%; margin-top:5px; margin-bottom:5px"
                  ></b-form-textarea>
                </b-form>
              </b-col>
              <b-col cols="2" style="padding:0px; margin-left:-10px">
                <b-button variant="emptyB" @click="updateDescription(video);">
                  <small><font-awesome-icon style="color:#14BF98" :icon="['fas', 'check']" /></small>
                </b-button>
                <b-button variant="emptyB" @click="video._modifyDescription = false; video._desc=video.description; videos = videos.splice(0)">
                  <small><font-awesome-icon style="color:red" :icon="['fas', 'times']" /></small>
                </b-button>
              </b-col>
            </b-row>

            <div @click="startVideo(video)" title="Click to see video details" style="padding-top:10px" />    
          </div>
        </div>

<!--
            <p v-if="video.tags && video.tags !== ''">Tags: <strong>{{video.tags.split('|:|').join(' ')}}</strong></p>
            <p v-if="video.description && video.description !== ''">Description: {{video.description}}</p>

            <p v-if="activeSort === 'nbView'"><strong>Views:</strong> {{video.nbView || 0}}</p>
            <p v-if="activeSort === 'hourview'"><strong>Viewing hours:</strong> {{video.hourview || 0}} h</p>
            <p v-if="activeSort === 'meanTime'"><strong>Average viewing duration:</strong> {{video.meanTime || 0}} s</p>

            <p v-if="activeSort === 'dataDelivered'"><strong>Delivered data:</strong> {{video.dataDelivered || 0}} GB</p>
            <p v-if="activeSort === 'bitrate'"><strong>Average bitrate delivered:</strong> {{video.bitrate}} Mbps</p>

            <p v-if="activeSort === 'rebuff'"><strong>Rebuffering:</strong> {{video.rebuff}} %</p>
            <p v-if="activeSort === 'offload'"><strong>Offload:</strong> {{video.offload}} %</p>

            <p v-if="video.type === 'vod' && video.hasOwnProperty('duration')"><strong>Duration:</strong> {{video.duration2}}</p>
            <p v-if="activeSort === 'encodingErrors'"><strong>Encoding errors:</strong> {{video.encodingErrors || 0}}</p>

          <vue-context class="backgroundRightMenu" ref="menu1">
              <ul slot-scope="child" v-if="child.data">
                  <div class="elemRightMenu msstreamElemRightMenu">{{child.data.title}}</div>
                  <li class="elemRightMenu" v-if="['stopped','encoded', 'encoding'].indexOf(child.data.encodingStatus) > -1" @click="startVideo(child.data)">Watch</li>
                  <li v-if="['waiting_for_encoding','encoding'].indexOf(child.data.encodingStatus) === -1" class="elemRightMenu" @click="startEncoding(child.data)">Start encoding</li>
                  <li v-if="['waiting_for_encoding','encoding'].indexOf(child.data.encodingStatus) > -1" class="elemRightMenu" @click="stopVideo(child.data)">Stop encoding</li>
                  <li @click="removeVideo(child.data)">Remove</li>
              </ul>
          </vue-context>-->
  </b-row>

  <b-row v-if="thOrList === 1" class="align-items-center" style="margin:0px"
  >
    <!--
    <b-row v-bind:class="{ 
      cardList2: (video.rebuff < 20 && !(video.error === true)),
      cardList3: (video.rebuff >= 20 && video.rebuff < 50 && !(video.error === true)),
      cardList4: (video.rebuff >= 50 && !(video.error === true)),
      cardList5: (video.error === true || !video.hasOwnProperty('rebuff')),
    }" class='col-12 align-items-center' style="display: flex; overflow: auto; white-space: nowrap; padding:0%; margin: 0px 0px 5px 0px" v-for="video in videos" v-bind:key="video.uuid">
    -->
    <b-row v-bind:class="{
      cardLiveOn: (video.type === 'live' && video.encodingStatus !== 'stopped' && !isImbricated),

      cardLiveOnImb: (video.type === 'live' && video.encodingStatus !== 'stopped' && (video.archivesFromLiveSize === undefined || video.archivesFromLiveSize === 0) && isImbricated),
      cardLiveOnwA: (video.type === 'live' && video.encodingStatus !== 'stopped' && video.archivesFromLiveSize > 0 && !video._otherLoaded && isImbricated),
      cardLiveOnwAExp: (video.type === 'live' && video.encodingStatus !== 'stopped' && video.archivesFromLiveSize > 0 && video._otherLoaded && isImbricated),

      cardLiveStop: (video.type === 'live' && video.encodingStatus === 'stopped' && !isImbricated),

      cardLiveStopImb: (video.type === 'live' && video.encodingStatus === 'stopped' && (video.archivesFromLiveSize === undefined || video.archivesFromLiveSize === 0) && isImbricated),
      cardLiveStopwA: (video.type === 'live' && video.encodingStatus === 'stopped' && video.archivesFromLiveSize > 0 && !video._otherLoaded && isImbricated),
      cardLiveStopwAExp: (video.type === 'live' && video.encodingStatus === 'stopped' && video.archivesFromLiveSize > 0 && video._otherLoaded && isImbricated),

      cardVOD: (video.type === 'vod' && !video.inAndOutOrigin && !video.archive && !isImbricated),

      cardVODImb: (video.type === 'vod' && !video.inAndOutOrigin && !video.archive && (video.videoInAndOutSize === undefined || video.videoInAndOutSize === 0) && isImbricated),
      cardVODwCut: (video.type === 'vod' && !video.inAndOutOrigin && !video.archive && video.videoInAndOutSize > 0 && !video._otherLoaded && isImbricated),
      cardVODwCutExp: (video.type === 'vod' && !video.inAndOutOrigin && !video.archive && video.videoInAndOutSize > 0 && video._otherLoaded && isImbricated),

      cardArchive: (video.type === 'vod' && video.archive && !isImbricated),
      cardCut: (video.type === 'vod' && video.inAndOutOrigin && !isImbricated ),

      cardArchiveImb: (video.type === 'vod' && video.archive && isImbricated && (video.videoInAndOutSize === undefined || video.videoInAndOutSize === 0)),
      cardArchiveImbwCut: (video.type === 'vod' && video.archive && isImbricated && (video.videoInAndOutSize > 0 && !video._otherLoaded)),
      cardArchiveImbwCutExp: (video.type === 'vod' && video.archive && isImbricated && (video.videoInAndOutSize > 0 && video._otherLoaded)),
      
      cardCutImb: (video.type === 'vod' && video.inAndOutOrigin && isImbricated),
    }" class='col-12 align-items-center' style="display: flex; overflow: auto; white-space: nowrap; padding:0%; margin: 0px 0px 5px 0px" v-for="video in videos" v-bind:key="video.uuid">

    <b-row class="align-items-center">

    <b-col cols="2" class="colwidth">
      <div class="previewContainer2" style="z-index:1">
        <b-img class="previewImg" style="object-fit:contain; cursor: pointer" :src="video.manifest.thumbnail" @click="startVideo(video)" @error="imgUrlAlt($event, video)" title="Click on the image to launch video page" fluid></b-img>
        <div style="position:absolute; z-index:2; left: 5px; top: 3px" title="Select the video">
          <b-form-checkbox v-model="video._isSelected" @input="updateSelectedNumber"></b-form-checkbox>
        </div>
        <b-button v-if="video.isPassword === true" variant="db-sbi" size="sm" style="position:absolute; z-index:2; right: 4px; top:4px; font-size:11px" disabled title="Password-protected stream">
          <font-awesome-icon icon="lock" /> 
        </b-button>
        <b-button v-if="video.startDate" variant="db-sbi" size="sm" style="position:absolute; z-index:2; left: 3px; bottom:3px; font-size:10px" disabled title="Delayed start">
            <font-awesome-layers style="margin-right:5px">
              <font-awesome-icon icon="share" />
              <font-awesome-icon icon="play" transform="shrink-7 right-13 up-2" />
            </font-awesome-layers>
            {{adjustDate(video.startDate)}}
        </b-button>

        <!--
        <font-awesome-layers v-if="video.type === 'live' && video.encodingStatus === 'encoding'" style="color: #ba0000; position:absolute; z-index:2; left:60px; top:7px">
          <font-awesome-icon transform="left-28" icon="circle-notch" spin />
          <font-awesome-icon icon="stop" transform="grow-2 left-3" />
          <font-awesome-icon icon="stop" transform="grow-2 left-14" />
          <font-awesome-icon icon="video" transform="grow-2"/>

          <font-awesome-layers-text 
                transform="shrink-7 left-8" 
                value="LIVE"
                style="color:white; font-weight:700"
          />
        </font-awesome-layers>
        <font-awesome-layers v-else-if="video.type === 'live'" style="color: #787976; position:absolute; z-index:2; left:50px; top:7px">
          <font-awesome-icon icon="stop" transform="grow-2 left-3" />
          <font-awesome-icon icon="stop" transform="grow-2 left-14" />
          <font-awesome-icon icon="video" transform="grow-2"/>

          <font-awesome-layers-text 
                transform="shrink-7 left-8" 
                value="LIVE"
                style="color:white; font-weight:700"
          />
        </font-awesome-layers>

        <b-badge v-if="video.type === 'live' && video.encodingStatus === 'encoding'" style="position:absolute; z-index:2; left:5px; top:30px; font-size:10px; background-color:#ba0000" title="Live stream, on air" >
          <font-awesome-icon transform="shrink-2" icon="circle-notch" spin />
          LIVE
          <b-img v-if="video.liveCamera === true" fluid :src="require(`@/assets/webcam_W.png`)" style="max-height:10px; color:white" />                  
          <font-awesome-icon v-if="video.liveCamera !== true && video.liveType === 'quanteecRTMP'" :icon="['fab', 'affiliatetheme']" />
          <font-awesome-icon v-if="video.liveCamera !== true && video.liveType === 'custom'" :icon="['fas', 'stream']" />
        </b-badge>
        <b-badge variant="secondary" v-else-if="video.type === 'live'" style="position:absolute; z-index:2; left:5px; top:30px; font-size:10px" title="Live stream, stopped" >
          LIVE
          <b-img v-if="video.liveCamera === true" fluid :src="require(`@/assets/webcam_W.png`)" style="max-height:10px; color:white" />                  
          <font-awesome-icon v-if="video.liveCamera !== true" :icon="['fab', 'affiliatetheme']" />
          <font-awesome-icon v-if="video.liveCamera !== true && video.liveType === 'custom'" :icon="['fas', 'stream']" />
        </b-badge>
        -->

      </div>
    </b-col>

    <b-col cols="3" style="width:300px; margin: 0px 20px 0px 0px; border-right: 2px solid #2a5d77">
      <div style="margin-left:-21px">
        <b-button variant="emptyNoB" size="sm" v-if="video.encodingStatus === 'encoding' || video.encodingStatus === 'segmented'" >
          <font-awesome-layers v-if="video.type === 'live'">
            <font-awesome-icon style="color: #ba0000" :icon="['fas', 'video']" title="Live stream"></font-awesome-icon>
            <font-awesome-icon style="color: #ba0000" :icon="['fas', 'circle-notch']" transform="shrink-4 left-13" spin title="Live stream, on air"></font-awesome-icon>
          </font-awesome-layers>
          <font-awesome-layers v-if="video.type === 'vod'">
            <font-awesome-icon style="color: #ba0000" :icon="['fas', 'film']" title="VOD, processing..."></font-awesome-icon>
          </font-awesome-layers>
          <!--
          <b-badge v-if="video.type === 'live' && video.archivesFromLive !== undefined && Object.keys(video.archivesFromLive).length > 0" variant="info" style="position:absolute; color:white; left:15px; top:1px; font-size:8px" title="Number of archives" size="sm">
            {{Object.keys(video.archivesFromLive).length}}
          </b-badge>
          <b-badge v-if="video.type === 'vod' && video.videoInAndOut !== undefined && Object.keys(video.videoInAndOut).length > 0" variant="success" style="position:absolute; color:white; left:15px; top:1px; font-size:8px" title="Number of cut-versions" size="sm">
            {{Object.keys(video.videoInAndOut).length}}
          </b-badge>
          -->
        </b-button>

        <b-button variant="emptyNoB" size="sm"  v-else-if="video.encodingStatus === 'encoded'">
          <font-awesome-layers v-if="video.type === 'live' && video.keepLive === false" title="Live stream, not kept as a VOD.">
            <font-awesome-icon style="color: #2F90B0" :icon="['fas', 'video']" ></font-awesome-icon>
            <font-awesome-icon style="color:red" icon="slash" />
          </font-awesome-layers>
          <font-awesome-layers v-else-if="video.type === 'live'" title="Live stream">
            <font-awesome-icon style="color: #2F90B0" :icon="['fas', 'video']" ></font-awesome-icon>
          </font-awesome-layers>
          <font-awesome-layers v-if="video.type === 'vod'" >
            <font-awesome-icon 
            style="color: #17a2b8" 
            :icon="['fas', 'video']"
            transform="shrink-5 right-6 up-6"
            v-if="video.archive"
            title="Archive from a Live"
            />
            <font-awesome-icon 
            style="color: #5cb85c" 
            :icon="['fas', 'cut']" 
            transform="shrink-5 left-7 up-6"
            v-if="video.inAndOutOrigin"
            title="Cut-version"
            />
            <font-awesome-icon style="color: #2F90B0" :icon="['fas', 'film']" title="VOD" />
          </font-awesome-layers>

          <!--
          <b-badge v-if="video.type === 'vod' && video.videoInAndOut !== undefined && Object.keys(video.videoInAndOut).length > 0" variant="success" style="position:absolute; color:white; left:15px; top:1px; font-size:8px" title="Number of cut-versions" size="sm">
            {{Object.keys(video.videoInAndOut).length}}
          </b-badge>
          -->

        </b-button>
        
        <b-button variant="emptyNoB" size="sm"  v-else-if="video.encodingStatus === 'stopped'">
          <font-awesome-layers v-if="video.type === 'live'">
            <font-awesome-icon style="color: black" :icon="['fas', 'video']" title="Live stream"></font-awesome-icon>
          </font-awesome-layers>

          <font-awesome-layers v-if="video.type === 'vod'">
            <font-awesome-icon style="color: black" :icon="['fas', 'film']" title="VOD"></font-awesome-icon>
          </font-awesome-layers>

          <!--
          <b-badge v-if="video.type === 'live' && video.archivesFromLive !== undefined && Object.keys(video.archivesFromLive).length > 0" variant="info" style="position:absolute; color:white; left:15px; top:1px; font-size:8px" title="Number of archives" size="sm">
            {{Object.keys(video.archivesFromLive).length}}
          </b-badge>
          <b-badge v-if="video.type === 'vod' && video.videoInAndOut !== undefined && Object.keys(video.videoInAndOut).length > 0" variant="success" style="position:absolute; color:white; left:15px; top:1px; font-size:8px" title="Number of cut-versions" size="sm">
            {{Object.keys(video.videoInAndOut).length}}
          </b-badge>
          -->
        </b-button>
        
        <b-button variant="emptyNoB" size="sm"  v-else-if="video.encodingStatus === 'uploading'">
          <font-awesome-layers v-if="video.type === 'live'">
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'video']" title="Live stream, starting..."></font-awesome-icon>
          </font-awesome-layers>

          <font-awesome-layers v-if="video.type === 'vod'">
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'film']" title="VOD, uploading..."></font-awesome-icon>
          </font-awesome-layers>
        </b-button>
        
        <b-button variant="emptyNoB" size="sm"  v-else-if="video.encodingStatus === 'upload-failed'">
          <font-awesome-layers v-if="video.type === 'live'">  
            <font-awesome-icon style="color: red" :icon="['fas', 'video']" title="Live stream, preparation error"></font-awesome-icon>
          </font-awesome-layers>
          <font-awesome-layers v-if="video.type === 'vod'">
            <font-awesome-icon style="color: red" :icon="['fas', 'film']" title="VOD, upload error"></font-awesome-icon>
          </font-awesome-layers>

        </b-button>
        
        <b-button variant="emptyNoB" size="sm"  v-else-if="video.encodingStatus === 'error'">
          <font-awesome-layers v-if="video.type === 'live'">
            <font-awesome-icon style="color: red" :icon="['fas', 'video']" title="Live stream, error"></font-awesome-icon>
          </font-awesome-layers>
          <font-awesome-layers v-if="video.type === 'vod'">
            <font-awesome-icon style="color: red" :icon="['fas', 'film']" title="VOD, error"></font-awesome-icon>
          </font-awesome-layers>
        </b-button>
        
        <b-button variant="emptyNoB" size="sm" v-else>
          <font-awesome-layers v-if="video.type === 'live'">
            <font-awesome-icon style="color: orange" :icon="['fas', 'video']" title="Live stream, processing..."></font-awesome-icon>
          </font-awesome-layers>

          <font-awesome-layers v-if="video.type === 'vod'">
            <font-awesome-icon style="color: orange" :icon="['fas', 'film']" title="VOD, processing..."></font-awesome-icon>
          </font-awesome-layers>
        </b-button>

        <span v-if="video.keepLive === true && (video.encodingStatus === 'encoded' || video.encodingStatus === 'stopped')">
        <b-button variant="emptyB" size="sm" @click="video.download = !video.download; updateDownload(video)" v-if="video.type === 'vod'">
          <font-awesome-layers  v-if="video.type === 'vod' && video.download === true" title="Downloadable, click to change">
            <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" transform="shrink-4 up-5 right-7" />
          </font-awesome-layers>

          <font-awesome-layers v-if="video.type === 'vod' && video.download === false" title="Not downloadable, click to change">
            <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" transform="shrink-4 up-5 right-7" />
          </font-awesome-layers>
        </b-button>
         <b-button variant="emptyB" size="sm" @click="video.downloadLive = !video.downloadLive; updateDownload(video)" v-if="video.type === 'live'">
          <font-awesome-layers  v-if="video.type === 'live' && video.downloadLive === true" title="Downloadable, click to change">
            <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" transform="shrink-4 up-5 right-7" />
          </font-awesome-layers>

          <font-awesome-layers v-if="video.type === 'live' && (!video.downloadLive || video.downloadLive === false)" title="Not downloadable, click to change">
            <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" transform="shrink-4 up-5 right-7" />
          </font-awesome-layers>
        </b-button>

        <input type="file" name="file" :id="'file' + video.uuid" class="inputfile" @input="addChapterFile($event, video); putChapterFile(video)" />
        <b-button variant="emptyB" size="sm" >
          <label :for="'file'+video.uuid" style="margin-bottom:0px; cursor:pointer" >
            <font-awesome-layers title="Click to charge chapters file">
              <font-awesome-icon :icon="['fas', 'list-ol']" />
              <font-awesome-layers-text v-if="video.chapters !== undefined && video.chapters.length !== 0"
              class="fa-inverse" 
              transform="shrink-4 up-5 right-6"
              style="color:#14BF98; background-color: white; font-weight: bold"
              :title="video.chapters.length+' chapter(s) present'"
              :value="video.chapters.length" />              
              <font-awesome-layers-text v-else
              class="fa-inverse" 
              transform="shrink-4 up-5 right-6"
              style="color:#14BF98; background-color: white; font-weight: bold"
              title="No chapters"
              value=0 />
            </font-awesome-layers>
          </label>
        </b-button>

        <b-button variant="emptyB" size="sm" v-if="video.chapters !== undefined && video.chapters.length !== 0" title="Delete chapters" @click="deleteChapters(video)">
          <font-awesome-layers>
            <font-awesome-icon :icon="['fas', 'list-ol']"></font-awesome-icon>
            <font-awesome-icon style="color: red" :icon="['fas', 'times']" transform="shrink-5 up-5 right-6" />
          </font-awesome-layers>
        </b-button>
        <b-button variant="emptyNoB" size="sm" v-else title="Delete chapters" disabled>
          <font-awesome-layers>
            <font-awesome-icon :icon="['fas', 'list-ol']"></font-awesome-icon>
            <font-awesome-icon style="color: red" :icon="['fas', 'times']" transform="shrink-5 up-5 right-6" />
          </font-awesome-layers>
        </b-button>
        <b-button variant="emptyB" size="sm" title="Informations should be displayed at the beginning of the video" @click="video.introModal = !video.introModal; updateIntroModal(video)">
          <font-awesome-layers>
            <font-awesome-icon :icon="['fas', 'clipboard-list']"></font-awesome-icon>
            <font-awesome-icon v-if="video.introModal" style="color: #14BF98;" :icon="['fas', 'check-circle']" transform="shrink-5 up-5 right-6" />
            <font-awesome-icon v-if="!video.introModal" style="color: red;" :icon="['fas', 'minus-circle']" transform="shrink-5 up-5 right-6" />
          </font-awesome-layers>
        </b-button>
        </span>

        <span v-else-if="video.keepLive === true">

        <b-button variant="emptyB" size="sm" @click="video.download = !video.download; updateDownload(video)">
          <font-awesome-layers  v-if="video.download === true" title="Downloadable, click to change. It will be applied when the encoding is complete and the video is stored as a VOD.">
            <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" transform="shrink-4 up-5 right-7" />
          </font-awesome-layers>

          <font-awesome-layers v-if="video.download === false" title="Not downloadable, click to change. It will be applied when the encoding is complete and the video is stored as a VOD.">
            <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" transform="shrink-4 up-5 right-7" />
          </font-awesome-layers>
        </b-button>

        <input type="file" name="file" :id="'file' + video.uuid" class="inputfile" @input="addChapterFile($event, video); putChapterFile(video)" />
        <b-button variant="emptyB" size="sm" >
          <label :for="'file'+video.uuid" style="margin-bottom:0px; cursor:pointer" >
            <font-awesome-layers title="Click to charge chapters file. It will be applied when the encoding is complete and the video is stored as a VOD.">
              <font-awesome-icon :icon="['fas', 'list-ol']" />
              <font-awesome-layers-text v-if="video.chapters !== undefined && video.chapters.length !== 0"
              class="fa-inverse" 
              transform="shrink-4 up-5 right-6"
              style="color:#14BF98; background-color: white; font-weight: bold"
              :title="video.chapters.length+' chapter(s) present'"
              :value="video.chapters.length" />              
              <font-awesome-layers-text v-else
              class="fa-inverse" 
              transform="shrink-4 up-5 right-6"
              style="color:#14BF98; background-color: white; font-weight: bold"
              title="No chapters"
              value=0 />
            </font-awesome-layers>
          </label>
        </b-button>

        <b-button variant="emptyB" size="sm" v-if="video.chapters !== undefined && video.chapters.length !== 0" title="Delete chapters. It will be applied when the encoding is complete and the video is stored as a VOD." @click="deleteChapters(video)">
          <font-awesome-layers>
            <font-awesome-icon :icon="['fas', 'list-ol']"></font-awesome-icon>
            <font-awesome-icon style="color: red" :icon="['fas', 'times']" transform="shrink-5 up-5 right-6" />
          </font-awesome-layers>
        </b-button>
        <b-button variant="emptyNoB" size="sm" v-else title="Delete chapters. It will be applied when the encoding is complete and the video is stored as a VOD." disabled>
          <font-awesome-layers>
            <font-awesome-icon :icon="['fas', 'list-ol']"></font-awesome-icon>
            <font-awesome-icon style="color: red" :icon="['fas', 'times']" transform="shrink-5 up-5 right-6" />
          </font-awesome-layers>
        </b-button>
        </span>

        <span v-else>

        <b-button variant="emptyNoB" size="sm" disabled title="This live is not kept as a VoD at the end of the stream. This feature is hence not available.">
          <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
        </b-button>

        <b-button variant="emptyNoB" size="sm" disabled title="This live is not kept as a VoD at the end of the stream. This feature is hence not available.">
          <font-awesome-layers>
            <font-awesome-icon :icon="['fas', 'list-ol']" />
            <font-awesome-layers-text
            class="fa-inverse" 
            transform="shrink-4 up-5 right-6"
            style="color:#14BF98; background-color: white; font-weight: bold"
            title="No chapters"
            value=0 />
          </font-awesome-layers>

        </b-button>

        <b-button variant="emptyNoB" size="sm" disabled title="This live is not kept as a VoD at the end of the stream. This feature is hence not available.">
          <font-awesome-layers>
            <font-awesome-icon :icon="['fas', 'list-ol']"></font-awesome-icon>
            <font-awesome-icon style="color: red" :icon="['fas', 'times']" transform="shrink-5 up-5 right-6" />
          </font-awesome-layers>
        </b-button>
        </span>

        <b-button variant="emptyB" size="sm" @click="videocopy=video; copyLink(video); showAndHideModal('confirmClickExport')" title="Copy iFrame code">
          <font-awesome-icon :icon="['fas', 'file-export']" />
        </b-button>
        <b-button variant="emptyB" size="sm" @click="videocopy=video; copyDirectLink(video); showAndHideModal('confirmClickDirectLink')" title="Copy direct link">
          <font-awesome-icon :icon="['fas', 'link']" />
        </b-button>
        <b-button variant="emptyB" size="sm" title="Delete" @click="videoToDelete = video; showModal('confirmOneDelete')" >
          <font-awesome-icon style="color: red" :icon="['fas', 'trash']" />
        </b-button>
        <b-button variant="empty" v-if="video.uuid === focus" title="Last video opened" size="sm" disabled >
          <font-awesome-icon style="color: #14BF98" :icon="['fas', 'eye']" />
        </b-button>
      </div>

      <b-row  v-if="!video._modifyTitle" style="margin-right:0px" class="align-items-center">
        <b-col class="pointerEltVideo" cols=10 style="padding:0px; margin:0px" @click="startVideo(video)" :title="'Click to open '+video.title+ ' page and see all video details'">
          <h6 style="margin: 4px 2px 4px 0px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap"><strong>{{video.title}}</strong></h6>
        </b-col>
        <b-col cols=1 title="Click to modify title">
          <b-button variant="emptyB" @click="video._modifyTitle = true; videos = videos.splice(0); video._title=video.title" size="sm">
            <font-awesome-icon :icon="['fas', 'pencil-alt']" />
          </b-button>
        </b-col>
      </b-row>

      <!-- Modify title -->
      <b-row  v-if="video._modifyTitle" class="align-items-center" style="padding-left:0px" title="Video title modification">
        <b-col cols=12 style="padding-left: 0px; margin-left:0px">
          <b-form @submit.prevent="updateTitle(video)" >
            <b-input-group>
              <b-input type="text" v-model="video._title"></b-input>
              <b-input-group-append style="align-items: center;justify-content: flex-end">
                <b-button variant="bordered" type=submit>
                  <font-awesome-icon class="pointerEltSB" style="color:#14BF98" :icon="['fas', 'check']" />
                </b-button>
                <b-button variant="borderedx" @click="video._modifyTitle = false; videos = videos.splice(0)">
                  <font-awesome-icon class="pointerEltSB" style="color:red" :icon="['fas', 'times']" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
        </b-col>
      </b-row>

      <b-row @click="startVideo(video)" :title="'Author of the video: '+video.user+' (click to see all video details)'">
        <p style="margin-bottom:0px; padding-bottom:3px; color: #2a5d77; text-overflow: ellipsis; overflow: hidden; white-space: nowrap" v-if="video.user && video.user !== ''">
          <small>
            {{$ml.get('by')}} 
            <strong>{{video.user}}</strong>
          </small>
        </p>
      </b-row>
      <b-row v-if="video && video.authorizationKey && video.authorizationKey.indexOf('cam') > -1" class="justify-content-center">
        <small style="font-size:11px; margin:8px" title="Camera">
          {{video.authorizationKey}}
        </small>
      </b-row>
      <b-row class="justify-content-around" @click="startVideo(video)" >
        <small style="font-size:11px; margin:3px" title="Video creation date">
          <font-awesome-icon :icon="['fas', 'calendar-minus']" /> 
          {{video.createdDate}}
        </small>
        <small style="font-size:11px; margin:3px" v-if="video.type !== 'live'" title="Video duration">
          <font-awesome-icon :icon="['fas', 'clock']" />
          {{video.duration2}}
        </small>
        <small style="font-size:11px; margin:3px" v-if=" (video.type === 'live' && video.keepLive)" title="Total live duration">
          <font-awesome-icon :icon="['fas', 'clock']" /> 
          {{video.duration2}}
        </small>
        <small style="font-size:11px; margin:3px" 
              :style="(video.lastModifyAt === video.createdAt) ? 'color:#9a9fa2':''" 
              :title="(video.lastModifyAt === video.createdAt) ?  'Not yet modified, same as original':'Date of last modification'"
        >
          <font-awesome-layers>
            <font-awesome-icon
              :icon="['fas', 'circle']"
              transform="shrink-12"
            />
            <font-awesome-icon :icon="['fas', 'redo-alt']" />
          </font-awesome-layers>
          {{adjustDate(video.lastModifyAt)}}
          <span v-if="video.lastModifyAt === video.createdDate" title="Never modified"><small>*</small></span>
        </small>
      </b-row>

    </b-col>

    <b-col cols="2" style="width: 200px; margin-right: -32px; margin-left: 2px; padding-right:30px">
      <b-row class="justify-content-center align-items-center" style="margin:0px 0px 0px -40px; line-height:10px">
        
      </b-row>

      <b-row class="justify-content-center align-items-center" style="margin:0px 0px 0px -40px; line-height:10px">
        <b-badge v-if="video.type === 'live' && video.encodingStatus === 'encoding'" style="font-size:11px; padding:5px; background-color:#ba0000" title="Live stream, on air" >
          <div class="d-flex align-items-center">
            <font-awesome-icon transform="shrink-2" style="margin-right:2px" icon="circle-notch" spin />
            <span if="video._liveDuration">{{video._liveDuration}} &nbsp;</span>
            LIVE&nbsp;
            <b-img v-if="video.liveCamera === true" :src="require(`@/assets/webcam_W.png`)" style="max-height:10px; color:white" title="From camera" />                  
            <font-awesome-icon v-if="video.liveCamera !== true && video.liveType === 'quanteecRTMP'" :icon="['fab', 'affiliatetheme']" title="From streaming software (RTMP)" />
            <font-awesome-icon v-if="video.liveCamera !== true && video.liveType === 'custom'" :icon="['fas', 'stream']" title="Custom stream" />
          </div>
        </b-badge>
        <b-badge variant="secondary" v-else-if="video.type === 'live'" style="font-size:11px; padding:5px" title="Live stream, stopped" >
          <div class="d-flex align-items-center">
            LIVE&nbsp;
            <b-img v-if="video.liveCamera === true" :src="require(`@/assets/webcam_W.png`)" style="max-height:10px; color:white" title="From camera" />    
            <font-awesome-icon v-if="video.liveCamera !== true && video.liveType === 'quanteecRTMP'" :icon="['fab', 'affiliatetheme']" title="From streaming software (RTMP)" />
            <font-awesome-icon v-if="video.liveCamera !== true && video.liveType === 'custom'" :icon="['fas', 'stream']" title="Custom stream" />
          </div>
        </b-badge>

        <small><font-awesome-icon size="sm" style="color: red; margin-left: 1rem" :title="`Critical error(s) ${(!!video.errorType) ? '(' + video.errorType + ')' : ''}`" v-if="video.error === true && (video.encodingStatus !== 'stopped' || video.type !== 'live')" :icon="['fas', 'exclamation-triangle']" /></small>

        <b-badge style="margin-left: 1rem; cursor: pointer;" v-if="video.type === 'live' && video.archivesFromLive !== undefined && Object.keys(video.archivesFromLive).length > 0 && video._otherLoaded && isImbricated" variant="info" title="Number of archives, click to hide" size="sm" @click="unloadOtherVideos(video)">
          {{Object.keys(video.archivesFromLive).length}}
          <font-awesome-icon size="xs" icon="chevron-up" />
        </b-badge>
        <b-badge style="margin-left: 1rem; cursor: pointer;" v-if="video.type === 'live' && video.archivesFromLive !== undefined && Object.keys(video.archivesFromLive).length > 0 && !video._otherLoaded && isImbricated" variant="info" title="Number of archives, click to show below" size="sm" @click="loadOtherVideos(video)">
          {{Object.keys(video.archivesFromLive).length}}
          <font-awesome-icon size="xs" icon="chevron-down" />
        </b-badge>

        <b-badge style="margin-left: 1rem; cursor: pointer;" v-if="video.type === 'vod' && video.videoInAndOut !== undefined && Object.keys(video.videoInAndOut).length > 0 && video._otherLoaded && isImbricated" variant="success" title="Number of cut-versions, click to hide" size="sm" @click="unloadOtherVideos(video)">
          {{Object.keys(video.videoInAndOut).length}}
          <font-awesome-icon size="xs" icon="chevron-up" />
        </b-badge>
        <b-badge style="margin-left: 1rem; cursor: pointer;" v-if="video.type === 'vod' && video.videoInAndOut !== undefined && Object.keys(video.videoInAndOut).length > 0 && !video._otherLoaded && isImbricated" variant="success" title="Number of cut-versions,click to show below" size="sm" @click="loadOtherVideos(video)">
          {{Object.keys(video.videoInAndOut).length}}
          <font-awesome-icon size="xs" icon="chevron-down" />
        </b-badge>

        <b-badge style="margin-left: 1rem" v-if="video.type === 'live' && video.archivesFromLive !== undefined && Object.keys(video.archivesFromLive).length > 0 && !isImbricated" variant="info" title="Number of archives, switch to imbricated mode to show them below" size="sm" @click="loadOtherVideos(video)">
          {{Object.keys(video.archivesFromLive).length}}
        </b-badge>
        <b-badge style="margin-left: 1rem" v-if="video.type === 'vod' && video.videoInAndOut !== undefined && Object.keys(video.videoInAndOut).length > 0 && !isImbricated" variant="success" title="Number of cut-versions, switch to imbricated mode to show them below" size="sm">
          {{Object.keys(video.videoInAndOut).length}}
        </b-badge>

        <b-badge variant="info" style="margin-left:5px" v-if="video._otherLoaded && video.type === 'live' && isImbricated" @click="loadOtherVideos(video)" title="Refresh list of Archives">
          <font-awesome-icon size="xs" icon="sync" />
        </b-badge>
        <b-badge variant="success" style="margin-left:5px" v-if="video._otherLoaded && video.type === 'vod' && video.videoInAndOut !== undefined && isImbricated" @click="loadOtherVideos(video)" title="Refresh list of Cut-versions">
          <font-awesome-icon size="xs" icon="sync" />
        </b-badge>

      </b-row>

      <b-row class="justify-content-center align-items-center" style="margin:3px 0px 3px -40px">
        <b-button variant="emptyB" size="sm" title="Click to stop process" @click="videoToStopEnc = video; showModal('confirmOneStopEncoding')" v-if="video.encodingStatus === 'encoding' || video.encodingStatus === 'segmented'">
          <div style="color: #ba0000">
            <font-awesome-icon :icon="['fas', 'cog']" spin />
            <strong style="margin-right:2px; margin-left:2px" v-text="$ml.get('encoding')"></strong>
            <font-awesome-icon :icon="['fas', 'stop-circle']" />
            <strong v-if="video.bunnyPlayable" style="margin-right:2px; margin-left:2px" v-text="$ml.get('playable')"></strong>

            <small style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></small>

            <small style="margin-left: 1rem" v-else-if="video.currentNumberOfQualities">
              <span v-if="!video.inputQualities || video.inputQualities === 'QuanteecOptimization'" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
              <span v-else :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                <strong>C</strong>
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
            </small>

          </div>
        </b-button>
        <b-button variant="emptyB" size="sm" title="Click to stop process" v-else-if="video.encodingStatus === 'uploading'">
          <div style="color: #14BF98">
            <font-awesome-icon :icon="['fas', 'cog']" spin />
            <strong style="margin-right:2px; margin-left:2px" v-text="$ml.get('uploading')"></strong>
            <font-awesome-icon :icon="['fas', 'stop-circle']" />

            <small style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></small>

            <small style="margin-left: 1rem" v-else-if="video.currentNumberOfQualities">
              <span v-if="!video.inputQualities || video.inputQualities === 'QuanteecOptimization'" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
              <span v-else :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                <strong>C</strong>
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
            </small>

          </div>
        </b-button>
        <b-button variant="emptyB" size="sm" title="Click to stop process" v-else-if="video.encodingStatus === 'upload_failed'">
          <div style="color: red">
            <font-awesome-icon :icon="['fas', 'cog']" />
            <strong style="margin-right:2px; margin-left:2px" v-text="$ml.get('uploadfailed')"></strong>

            <small style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></small>

            <small style="margin-left: 1rem" v-else-if="video.currentNumberOfQualities">
              <span v-if="!video.inputQualities || video.inputQualities === 'QuanteecOptimization'" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
              <span v-else :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                <strong>C</strong>
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
            </small>

          </div>
        </b-button>
        <b-button variant="emptyB" size="sm" title="Click to stop process" @click="videoToStopEnc = video; showModal('confirmOneStopEncoding')" v-else-if="video.encodingStatus === 'restart'">
          <div style="color:orange">
            <font-awesome-icon :icon="['fas', 'cog']" spin />
            <strong style="margin-right:2px; margin-left:2px" v-text="$ml.get('restarting')"></strong>
            <font-awesome-icon :icon="['fas', 'stop-circle']" />
            <small style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></small>

            <small style="margin-left: 1rem" v-else-if="video.currentNumberOfQualities">
              <span v-if="!video.inputQualities || video.inputQualities === 'QuanteecOptimization'" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
              <span v-else :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                <strong>C</strong>
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
            </small>

          </div>
        </b-button>
        <b-button  
        size="sm"
        v-else-if="video.encodingStatus === 'stopped'"
        :variant="(video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive') ? 'emptyNoB':'emptyB'"
        :title="(video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive') ? '':'Click to re-start live'" 
        @click="if(video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive') {videoToReencode = video; showModal('confirmOneRestartEncoding')}"  
        :disabled="video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive'"
        >
          <div style="color:black">
            <font-awesome-icon :icon="['fas', 'cog']" />
            <strong style="margin-right:2px; margin-left:2px" v-text="$ml.get('stopped')"></strong>
            <font-awesome-icon v-if="video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive'" :icon="['fas', 'sync']" transform="shrink-4"/>
            <small style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></small>

            <small style="margin-left: 1rem" v-else-if="video.currentNumberOfQualities">
              <span v-if="!video.inputQualities || video.inputQualities === 'QuanteecOptimization'" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
              <span v-else :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                <strong>C</strong>
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
            </small>

          </div>
        </b-button>
        <b-button 
        size="sm"
        v-else-if="video.encodingStatus === 'encoded' && video.type === 'live'"
        :variant="(video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive') ? 'emptyNoB':'emptyB'"
        :title="(video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive') ? '':'Click to re-start live'" 
        @click="if(video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive') {videoToReencode = video; showModal('confirmOneRestartEncoding')}"  
        :disabled="video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive'"
        >
          <div style="color: #2F90B0">
            <font-awesome-icon :icon="['fas', 'cog']" />
            <strong style="margin-right:2px; margin-left:2px" v-text="$ml.get('encoded')"></strong>
            <font-awesome-icon v-if="video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive'" :icon="['fas', 'sync']" transform="shrink-4"/>
            <small style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></small>

            <small style="margin-left: 1rem" v-else-if="video.currentNumberOfQualities">
              <span v-if="!video.inputQualities || video.inputQualities === 'QuanteecOptimization'" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
              <span v-else :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                <strong>C</strong>
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
            </small>

          </div>
        </b-button>
        <b-button 
        size="sm"
        v-else-if="video.encodingStatus === 'encoded'"
        :variant="(video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive') ? 'emptyNoB':'emptyB'"
        :title="(video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive') ? '':'Click to re-encode VOD'" 
        @click="if(video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive') {videoToReencode = video; showModal('confirmOneRestartEncoding')}"  
        :disabled="video.sourcePath.toLowerCase() === 'quanteec' || video.sourcePath.toLowerCase() === 'archive'"
        >
          <div style="color: #2F90B0">
            <font-awesome-icon :icon="['fas', 'cog']" />
            <strong style="margin-right:2px; margin-left:2px" v-text="$ml.get('encoded')"></strong>
            <font-awesome-icon v-if="video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive'" :icon="['fas', 'sync']" transform="shrink-4"/>
            <small style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></small>

            <small style="margin-left: 1rem" v-else-if="video.currentNumberOfQualities">
              <span v-if="!video.inputQualities || video.inputQualities === 'QuanteecOptimization'" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
              <span v-else :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                <strong>C</strong>
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
            </small>

          </div>
        </b-button>

        <b-button variant="emptyB" size="sm" title="Click to re-launch process" @click="if(video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive'){videoToReencode = video; showModal('confirmOneRestartEncoding')}" v-else-if="video.encodingStatus === 'error'">
          <div style="color: red">
            <font-awesome-icon :icon="['fas', 'cog']" />
            <strong style="margin-right:2px; margin-left:2px" v-text="$ml.get('error')"></strong>
            <font-awesome-icon v-if="video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive'" :icon="['fas', 'sync']" transform="shrink-4"/>
            <small style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></small>

            <small style="margin-left: 1rem" v-else-if="video.currentNumberOfQualities">
              <span v-if="!video.inputQualities || video.inputQualities === 'QuanteecOptimization'" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
              <span v-else :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                <strong>C</strong>
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
            </small>

          </div>
        </b-button>
        <b-button variant="emptyB" size="sm" title="Click to stop process" @click="videoToStopEnc = video; showModal('confirmOneStopEncoding')" v-else>
          <div style="color: orange">
            <font-awesome-icon :icon="['fas', 'cog']" spin />
            <strong style="margin-right:2px; margin-left:2px"> {{(video.encodingStatus === "waiting_for_encoding") ? "waiting..." : video.encodingStatus+'...'}} </strong>
            <font-awesome-icon :icon="['fas', 'stop-circle']" />
            <small style="margin-left: 1rem" v-if="video.encoding === 'passthrough'" title="Video in passthrough mode: one quality, same as original"><strong>P</strong></small>

            <small style="margin-left: 1rem" v-else-if="video.currentNumberOfQualities">
              <span v-if="!video.inputQualities || video.inputQualities === 'QuanteecOptimization'" :title="'Encoded with QUANTEEC algorithm in '+video.currentNumberOfQualities+' quality(ies)'">
                <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
              <span v-else :title="'Custom encoding in '+video.currentNumberOfQualities+' quality(ies)'">
                <strong>C</strong>
                <span> {{video.currentNumberOfQualities}}Q</span>
              </span>
            </small>

          </div>
        </b-button>
      </b-row>

      <b-row class="justify-content-center" v-if="['encoding', 'segmented'].indexOf(video.encodingStatus) > -1 && video.type === 'vod' && video.encodingPercent < 100" style="margin:0px 0px 0px -40px" title="Current progress of the encoding process">
        <b-progress style="font-size:9px; height:10px; width:104px; margin-right:2px" :max="100" >
          <b-progress-bar :value="video.encodingPercent" animated variant="primary">
            {{video.encodingPercent}}%
          </b-progress-bar>
        </b-progress>
      </b-row>
      <b-row class="justify-content-center" v-if="video.encodingStatus === 'uploading' && video.type === 'vod'" style="margin:0px 0px 0px -40px" title="Current progress of the uploading process">
        <b-progress style="font-size:9px; height:10px; width:104px; margin-right:2px" :max="100" >
          <b-progress-bar :value="video.uploadingPercent" animated variant="primary">
            {{video.uploadingPercent}}%
          </b-progress-bar>
        </b-progress>
      </b-row>
      <b-row class="justify-content-center" v-if="['encoding', 'segmented'].indexOf(video.encodingStatus) > -1 && video.type === 'vod'" style="margin:0px 0px 0px -40px" title="Time to finish encoding process">
        <p style="font-size:11px; margin:4px 0px 0px 0px"><font-awesome-icon :icon="['fas', 'stopwatch']" ></font-awesome-icon> {{video.encodingETA}}</p>
      </b-row>
      <b-row class="justify-content-center" v-if="video.encodingStatus === 'uploading' && video.type === 'vod'" style="margin:0px 0px 0px -40px" title="Time to finish uploading process">
        <p style="font-size:11px; margin:4px 0px 0px 0px"><font-awesome-icon :icon="['fas', 'stopwatch']" ></font-awesome-icon> {{video.uploadingETA}}</p>
      </b-row>

      <b-row class="justify-content-center align-items-center" style="margin:0px 0px 0px -40px; line-height:10px">
        <small>

          <b-button size="sm" v-if="!video._modifyPlanDes" variant="emptyB" style="font-size:12px" @click="video._modifyPlanDes = true; video._deleteDate = video.deleteDate; videos = videos.splice(0)" title="Plan video destruction date">
            <font-awesome-layers style="margin-right:12px">
              <font-awesome-icon icon="share" />
              <font-awesome-icon style="color:red" icon="trash" transform="shrink-4 right-14 up-3" />
            </font-awesome-layers>
            <span v-if="video.deleteDate">{{adjustDate(video.deleteDate)}}</span>
            <span v-else v-text="$ml.get('nodate')"></span>
          </b-button>

          <b-button size="sm" v-if="video.deleteDate && !video._modifyPlanDes" @click="deleteDeleteProgrammed(video)" variant="emptyB" title="Clear video destruction date" style="font-size:12px; padding: 4px 8px !important; line-height:0px !important">
            <font-awesome-layers>
              <font-awesome-icon icon="share" />
              <font-awesome-icon icon="slash" transform="left-2" />
            </font-awesome-layers>
          </b-button>

          <b-input-group v-if="video._modifyPlanDes" title="Plan video destruction date">
            <date-picker id="example-datepicker" style="font-size:12px" size="sm" v-model="video._deleteDate" mode="dateTime" :timezone="''" is24hr :popover="{visibility: 'visible'}">
              <template size="sm" v-slot="{ inputValue, inputEvents }">
                <input size="sm" placeholder="dd/mm/yyyy hh:mm" v-on="inputEvents" style="text-align:center; height:21.78px; max-width:120px" :value="inputValue"/>
              </template>
            </date-picker>

            <b-button size="sm" @click="titleTamp=video.title; deleteProgrammed(video)" variant="emptyBBx" style="font-size:12px; padding: 4px 8px !important; line-height:0px !important" >
              <font-awesome-icon class="pointerEltSB" style="color:#14BF98" :icon="['fas', 'check']" />
            </b-button>
            <b-button size="sm" @click="video._modifyPlanDes = false; videos = videos.splice(0)" variant="emptyBBx" style="font-size:12px; padding: 4px 8px !important; line-height:0px !important">
              <font-awesome-icon class="pointerEltSB" style="color:red" :icon="['fas', 'times']" />
            </b-button>
          </b-input-group>

          <b-row class="justify-content-center align-items-center" v-if="video._deleteDate && (video._deleteDate < currentDate)" style="color:red; font-size:10px; margin-top:5px" title="Date/time prior to now">
            <font-awesome-icon icon="exclamation-triangle" />
            <span v-text="$ml.get('deletenow')"></span>
          </b-row>

        </small>

      </b-row>

    </b-col>

    <b-col cols="3" style="width: 300px; margin:0px; border-right: 2px solid #2a5d77; border-left: 2px solid #2a5d77" @click="startVideo(video)" title="Click to see all video details">

      <b-row class="justify-content-between" style="padding:0px 10px">
        <b-button variant="nothing" title="Total viewing time" ><small><font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon> {{video.hourview_unit || 0}}</small></b-button>
        <b-button variant="nothing" title="Maximum concurrent viewers over the period" ><small><font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon> {{video.concurrentUsers || 0}}</small></b-button>
        <b-button variant="nothing" title="Mean viewing time" ><small><font-awesome-icon :icon="['fas', 'stopwatch']"></font-awesome-icon> {{video.meanTime_unit || 0}}</small></b-button>
      </b-row>
      <b-row class="justify-content-between" style="padding:0px 10px">
        <b-button variant="nothing" title="Best quality %"><small><font-awesome-icon :icon="['fas', 'signal']"></font-awesome-icon> {{video.bestQualityPercent_unit || 0}}</small>
        </b-button>
        <b-button variant="nothing" title="Average bitrate"><small>&#x7E; {{video.bitrate_unit || 0}}</small></b-button>
        <b-button variant="nothing" title="Rebuffering %">
          <small v-bind:class="{
            green: (video.rebuff < 20 && !(video.error === true)),
            orange: (video.rebuff >= 20 && video.rebuff < 50 && !(video.error === true)),
            red: (video.rebuff >= 50 && !(video.error === true)),
            black: (video.error === true || !video.hasOwnProperty('rebuff')),
          }"
          >
            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon> {{video.rebuff_unit || 0}}
          </small>
        </b-button>
      </b-row>
      <b-row class="justify-content-between" style="padding:0px 10px">
        <b-button variant="nothing" title="Efficiency %" ><small><font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon> {{video.offload_unit || 0}}</small></b-button>
        <b-button variant="nothing" title="Data delivered" ><small><font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon> {{video.dataDelivered_unit || 0}}</small></b-button>
        <b-button variant="nothing" title="Data delivered by peers" ><small><font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon> {{video.totalMB_peer_unit || 0}}</small></b-button>
      </b-row>
      <b-row class="justify-content-between" style="padding:0px 10px">
        <b-button variant="nothing" title="Energy saved %" ><small><font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon> {{video.energySaved_unit || 0}}</small></b-button>
        <b-button variant="nothing" title="KWh spent" ><small><font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon> {{video.kwhSpent_unit || 0}}</small></b-button>
        <b-button variant="nothing" title="CO2 spent" ><small><font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon> {{video.co2Spent_unit || 0}}</small></b-button>
      </b-row>

    </b-col>

    <b-col cols="2" style="width:200px">
      <b-row v-if="!video._modifyTags" class="pointerEltVideo" style="padding:5px 0px; margin:5px 0px 5px 0px" @click="startModifyTags(video)" title="Video tags, click to modify">
        <small v-if="video.tags && video.tags.length>0">
          <font-awesome-layers>
            <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180"></font-awesome-icon>
            <font-awesome-icon :icon="['fas', 'tags']" transform="shrink-2"></font-awesome-icon>
          </font-awesome-layers>
          <span v-for="tag in video.tags">
            &nbsp;{{tag}}
          </span>
        </small>
        <small v-else>
          <font-awesome-layers>
            <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180"></font-awesome-icon>
            <font-awesome-icon :icon="['fas', 'tags']" transform="shrink-2"></font-awesome-icon>
          </font-awesome-layers> 
          &nbsp;-
        </small>
      </b-row>

      <b-row v-if="video._modifyTags" class="align-items-center" title="Video tags modification" style="margin-left:-20px">
        <b-col cols="10">
          <b-form-tags style="font-size:85%; width:155px" element-id="tags" 
          v-model="video._tags" @tags-updated="updateTags(video)" placeholder="Add Tag & press Enter"></b-form-tags>
        </b-col>
        <b-col cols="2" style="margin-left:0px; padding:0px">
          <b-button variant="emptyB" @click="endModifyTags(video)" type=submit>
            <small><font-awesome-icon style="color:#14BF98" :icon="['fas', 'check']" /></small>
          </b-button>
          <b-button variant="emptyB" @click="videos = videos.splice(0); video._modifyTags=false">
            <small><font-awesome-icon style="color:red" :icon="['fas', 'times']" /></small>
          </b-button>
        </b-col>
      </b-row>
      
      <b-row v-if="!video._modifyDescription" style="padding:5px 0px; margin:5px 0px 5px 0px" class="pointerEltVideo" @click="video._modifyDescription = !video._modifyDescription; video._desc=video.description; videos=videos.splice(0)" title="Video description, click to modify">
        <small v-if="video.description && video.description !== ''" style="overflow-wrap: break-word;">
          <font-awesome-layers>
            <font-awesome-icon :icon="['fas', 'file-alt']" />
            <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180" />
          </font-awesome-layers>
          &nbsp;{{video.description}}
        </small>
        <small v-else>
          <font-awesome-layers>
            <font-awesome-icon :icon="['fas', 'file-alt']" />
            <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180" />
          </font-awesome-layers>
          &nbsp;-
        </small>
      </b-row>

      <b-row v-if="video._modifyDescription" class="align-items-center" title="Video description modification" style="margin-left:-20px">
        <b-col cols="10">
          <b-form @submit.prevent="updateDescription(video)">
            <b-form-textarea
            id="textarea"
            v-model="video._desc"
            placeholder="Write description here"
            rows="1"
            max-rows="2"
            style="font-size:85%; margin-top:5px; width:155px"
            ></b-form-textarea>
          </b-form>
        </b-col>
        <b-col cols="2" style="margin-left:0px; padding:0px">
          <b-button variant="emptyB" @click="updateDescription(video);">
            <small><font-awesome-icon style="color:#14BF98" :icon="['fas', 'check']" /></small>
          </b-button>
          <b-button variant="emptyB" @click="video._modifyDescription = false; video._desc=video.description; videos = videos.splice(0);">
            <small><font-awesome-icon style="color:red" :icon="['fas', 'times']" /></small>
          </b-button>
        </b-col>
      </b-row>

    </b-col>

  </b-row>
  </b-row>
</b-row>

  <b-row v-if="thOrList === 2" class="marginaltop">
    <b-table show-empty responsive striped bordered :items="videos" :fields="listFields">
      <template v-slot:cell(selected)="row">
        <b-form-checkbox
          v-model="row.item._isSelected"
          @input="updateSelectedNumber"
        >
        </b-form-checkbox>
      </template>

      <template v-slot:cell(actions)="row">
        <b-button variant="mswarning" @click="row.toggleDetails">
          {{(row.showingDetails ? '-' : '+')}}
        </b-button>
      </template>

      <template v-slot:cell(encodingStatus)="row">
        {{row.item.encodingStatus}}
        <div v-if="row.item.encodingStatus &&  ['encoding', 'segmented'].indexOf(row.item.encodingStatus) > -1 && row.item.encodingPercent && row.item.encodingPercent < 100">
          <p><strong v-text="$ml.get('encodingper')">:</strong></p>
          <b-progress :value="row.item.encodingPercent" :max="100" show-progress animated></b-progress>
          <p v-text="$ml.get('encodeETA')">: {{row.item.encodingETA}}</p>
        </div>
        <div v-if="row.item.encodingStatus &&  row.item.encodingStatus === 'uploading' && row.item.uploadingPercent && row.item.uploadingPercent < 100">
          <p><strong v-text="$ml.get('uploadper')"></strong></p>
          <b-progress :value="row.item.uploadingPercent" :max="100" show-progress animated></b-progress>
          <p v-text="$ml.get('uploadETA')">: {{row.item.uploadingETA}}</p>
        </div>
      </template>

      <template v-slot:cell(tags)="row">
       <div v-if="row.item.tags && row.item.tags.length > 0">{{row.item.tags}}</div>
      </template>

      <template v-slot:row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>

      <template v-slot:cell(watch)="row">
        <b-button variant="green" @click="startVideo(row.item)"> 
          {{$ml.get('newvideos')}}
        </b-button>
      </template>
      <template v-slot:cell(sort)="row">
        <div v-if="listFields.findIndex(elem => elem.key === activeSort) === -1">
          {{ row.item[activeSort] }}
        </div>
      </template>
      <template v-slot:head(sort)="head">
        {{head.label = 'Sort Option: ' + activeSort}}
      </template>
    </b-table>
  </b-row>
  
    <b-row v-if="videos.length !== undefined && videos.length > 2" class="align-items-center" style="font-size:14px; margin: 5px 0px 5px 5px">
      <p style="margin: 0px 0.3rem 0px 0px">&#8627; {{$ml.get('selected')}} {{nbrVideoSelected}} </p>

      <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" :disabled="nbrVideoSelected < 1" @click="isSelectAll = false; selectAll()" title="Deselect">
        <small><font-awesome-layers>
          <font-awesome-icon :icon="['fas', 'sync']" />
          <font-awesome-icon style="color:red" :icon="['fas', 'times']" transform="shrink-9" />
        </font-awesome-layers></small>
      </b-button>

      <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" :disabled="nbrVideoSelected < 1" @click="updateDownloadSelected()" title="Make all selected videos downloadable"> 
        <small><font-awesome-layers>
          <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
          <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" transform="shrink-2 up-5 right-6" />
        </font-awesome-layers></small>
      </b-button>

      <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" :disabled="nbrVideoSelected < 1" @click="updateUnDownloadSelected()" title="Make all selected videos not downloadable"> 
        <small><font-awesome-layers>
          <font-awesome-icon :icon="['fas', 'arrow-alt-circle-down']" />
          <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" transform="shrink-2 up-5 right-6" />
        </font-awesome-layers></small>
      </b-button>

      <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" :disabled="nbrVideoSelected < 1" @click="updateZeroChapters()" title="Delete chapters of all selected videos" >
        <small><font-awesome-layers>
          <font-awesome-icon :icon="['fas', 'list-ol']"></font-awesome-icon>
          <font-awesome-icon style="color: red" :icon="['fas', 'times']" transform="shrink-2 up-5 right-6" />
        </font-awesome-layers></small>
      </b-button>

      <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" title="Re-launch encoding process" @click="showModal('confirmRestartEncoding')" :disabled="videos.filter((x) => (x._isSelected)).length === 0">
        <small><font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon></small>
      </b-button>

      <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" title="Set a destruction date" @click="descDate = true" :disabled="videos.filter((x) => (x._isSelected)).length === 0">
        <small><font-awesome-layers style="margin-right:12px">
          <font-awesome-icon icon="share" />
          <font-awesome-icon style="color:red" icon="trash" transform="shrink-4 right-14 up-3" />
        </font-awesome-layers></small>
      </b-button>

      <span>
        <small><b-input-group v-if="descDate === true" title="Plan video destruction date">
          <date-picker id="example-datepicker3" style="font-size:12px" size="sm" v-model="deleteDate" mode="dateTime" :timezone="''" is24hr >
            <template size="sm" v-slot="{ inputValue, inputEvents }">
              <input size="sm" placeholder="dd/mm/yyyy hh:mm" v-on="inputEvents" style="text-align:center; height:21.78px; max-width:120px" :value="inputValue"/>
            </template>
          </date-picker>

          <b-button size="sm" @click="showModal('confirmPlanDesAll')" variant="emptyBBx" style="font-size:12px; padding: 4px 8px !important; line-height:0px !important" >
            <font-awesome-icon class="pointerEltSB" style="color:#14BF98" :icon="['fas', 'check']" />
          </b-button>
          <b-button size="sm" @click="descDate = false" variant="emptyBBx" style="font-size:12px; padding: 4px 8px !important; line-height:0px !important">
            <font-awesome-icon class="pointerEltSB" style="color:red" :icon="['fas', 'times']" />
          </b-button>
        </b-input-group></small>
      </span>
      
      <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" title="Clear destruction date" @click="updateZeroPlanDesSelected()" :disabled="videos.filter((x) => (x._isSelected)).length === 0">
        <small><font-awesome-layers>
          <font-awesome-icon icon="share" />
          <font-awesome-icon icon="slash" transform="left-2" />
        </font-awesome-layers></small>
      </b-button>

      <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" title="Remove all selected videos" @click="showModal('confirmDelete')" :disabled="videos.filter((x) => (x._isSelected)).length === 0">
        <small><font-awesome-icon style="color: red" :icon="['fas', 'trash']" ></font-awesome-icon></small>
      </b-button>

      <b-button v-if="isImbricated" size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" title="Show archives/cut for selected videos" @click="updateShowACSelected" :disabled="videos.filter((x) => (x._isSelected)).length === 0">
        <small>
          {{$ml.get('show')}} 
          <b-badge variant="info" size="sm">
            A
          </b-badge>
          <b-badge variant="success" size="sm">
            C
          </b-badge>
        </small>
      </b-button>

      <b-button v-if="isImbricated" size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" title="Hide archives/cut for selected videos" @click="updateHideACSelected" :disabled="videos.filter((x) => (x._isSelected)).length === 0">
        <small>
          {{$ml.get('hide')}} 
          <b-badge variant="info" size="sm">
            A
          </b-badge>
          <b-badge variant="success" size="sm">
            C
          </b-badge>
        </small>
      </b-button>

      <b-form-group v-if="videos.length !== undefined && videos.length > 3" class="col text-right" style="margin-bottom:0px">
        <b-button size="sm" variant="emptyB" href="#top" title="Back to the first video of the page">
          Top
          <font-awesome-icon icon="chevron-up" />
        </b-button>
        <!--
          <b-button size="sm" variant="emptyB" href="#bottom" title="Jump to the last video of the page">
            <font-awesome-icon icon="chevron-down" />
          </b-button>
        -->
      </b-form-group>

    </b-row>

    <b-row v-if="videos.length !== undefined && videos.length > 2" class="align-items-center" style="margin: 0px 0px 2rem 1.6rem; font-size:14px">
      <b-form-checkbox class="pointerEltVideo" v-model="isSelectAll" @change="selectAll"><p style="margin-top:4px" v-text="$ml.get('selectall')"></p></b-form-checkbox>
    </b-row>
  </b-container>

  <b-pagination 
    size="sm"
    v-if="videos.length !== undefined && videos.length > 2" 
    align="center" 
    :limit="8" 
    :total-rows="realTotalNumberOfPage" 
    v-model="currentPage" 
    :per-page="1" 
    first-number last-number 
    @input="getVideos()">
  </b-pagination>

  <b-row v-if="realTotalNumberOfPage > 10 && videos.length !== undefined && videos.length > 2" class="justify-content-center" style="margin-right:0px">
    <b-col cols="10" xs="8" md="8" lg="3">
      <b-form @submit.prevent="currentPage = goPage">
        <b-form-group >
          <b-input-group size="sm" prepend="Go to page:">
            <b-form-input type="number" min="1" v-model="goPage"></b-form-input>
            <b-input-group-append><b-button variant="db-sb" @click="currentPage = goPage">Go</b-button></b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-form>
    </b-col>
  </b-row>

  <a id="bottom"></a>

  <!--<b-modal ref="invalidDateModal" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">Error</h4>
      </div>
      <p style="line-height:normal">Invalid Date</p>
      <b-row class="justify-content-center">
        <b-button class="col-md-3 col-5" variant="mswarning" @click="hideModal('invalidDateModal')">Retry</b-button>
      </b-row>
  </b-modal>-->

  <b-modal ref="confirmDelete" hide-footer hide-header>
    <div class="d-block text-center">
      <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
        <font-awesome-icon style="color: red; margin-right:5px" :icon="['fas', 'trash']" />
        {{$ml.get('videod')}}
      </h4>
    </div>
    <p style="line-height:normal" v-html="$ml.get('confirmdall')"></p>
    <b-row class="justify-content-around">
      <b-btn class="col-5" variant="quanteec" @click="removeSelected();hideModal('confirmDelete')">
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'trash']" />
        {{$ml.get('delete')}}
      </b-btn>
      <b-btn class="col-5" variant="quanteeclg" @click="hideModal('confirmDelete')">
        <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
        {{$ml.get('cancel')}}
      </b-btn>
    </b-row>
  </b-modal>

  <b-modal ref="confirmOneDelete" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="color: red; margin-right:5px" :icon="['fas', 'trash']" />
          {{$ml.get('videod')}}
        </h4>
      </div>
      <p style="line-height:normal" >
        <span v-html="$ml.get('confirmd')"></span>
        <strong><span style="color: #2F90B0; word-break:break-word">{{videoToDelete.title}}</span></strong>. <br /><br />
        <span v-html="$ml.get('confirmd2')"></span>
      </p>
      <b-row class="justify-content-around">
        <b-btn class="col-5" variant="quanteec" @click="removeVideo(videoToDelete);hideModal('confirmOneDelete')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'trash']" />
          {{$ml.get('delete')}}
        </b-btn>
        <b-btn class="col-5" variant="quanteeclg" @click="hideModal('confirmOneDelete')">
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
          {{$ml.get('cancel')}}
        </b-btn>
      </b-row>
  </b-modal> 

  <b-modal ref="confirmRestartEncoding" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'cog']" />
          {{$ml.get('processingvids')}}
        </h4>
      </div>
      <p style="line-height:normal" v-html="$ml.get('relaunchconfirmall')"></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-5 col-5" variant="msstreamblue" @click="restartEncodingSelected();hideModal('confirmRestartEncoding')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'cog']" />
          {{$ml.get('relaunch')}}
        </b-btn>
        <b-btn class="col-md-5 col-5" variant="quanteeclg" @click="hideModal('confirmRestartEncoding')">
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
          {{$ml.get('cancel')}}
        </b-btn>
      </b-row>
  </b-modal>

  <b-modal ref="confirmOneRestartEncoding" hide-footer hide-header @hidden="refreshModal" @cancel="refreshModal" @show="resetModal(videoToReencode)">
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'cog']" />
          {{$ml.get('processingvids')}}
        </h4>
      </div>
      <p style="line-height:normal">
        {{$ml.get('relaunchconfirm')}}
        <strong><span style="color: #2F90B0">{{videoToReencode.title}}</span></strong>
        .
      </p>
      <b-form-checkbox size="sm" style="margin-bottom:7px;" v-model="restartEncodingQuality" switch>{{$ml.get('modifyencp')}}</b-form-checkbox>
          <div v-if="restartEncodingQuality && videoToReencode.liveType === 'camera'">
            <b-form-group style="text-align:center" 
              label="Targeted audience:"
            >
              <b-row class="justify-content-around">
                <b-col lg="4" md="4" sm="6" cols="10">
                  <b-row class="justify-content-center align-items-center commonChoice3" @click="videoToReencode.directStream = 'no';" v-bind:class="{'selectedChoice2': videoToReencode.directStream === 'no', 'unselectedChoice2': videoToReencode.directStream !== 'no'}">
                    <small style="line-height:normal">
                      {{$ml.get('nodelayo')}}
                    </small>
                  </b-row>
                </b-col>
                <b-col lg="4" md="4" sm="6" cols="10">
                  <b-row class="justify-content-center align-items-center commonChoice3" @click="videoToReencode.directStream = 'middle';" v-bind:class="{'selectedChoice2': videoToReencode.directStream === 'middle', 'unselectedChoice2': videoToReencode.directStream !== 'middle'}">
                    <small style="line-height:normal">
                      {{$ml.get('mixdelay')}}
                    </small>
                  </b-row>
                </b-col>
                <b-col lg="4" md="4" sm="6" cols="10">
                  <b-row class="justify-content-center align-items-center commonChoice3" @click="videoToReencode.directStream = 'yes';" v-bind:class="{'selectedChoice2': videoToReencode.directStream === 'yes', 'unselectedChoice2': videoToReencode.directStream !== 'yes'}">
                    <small style="line-height:normal">
                      {{$ml.get('lowdelay')}}
                    </small>
                  </b-row>
                </b-col>
              </b-row>
            </b-form-group>
          </div>  
          
          <b-card v-if="restartEncodingQuality" border-variant="msstream" no-body style="margin-top:0px; margin-bottom:20px">
            <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
              <h6 style="margin:0px" v-text="$ml.get('qencmethod')"></h6>
            </b-card-header>
            <div>
              <b-form-group label="" v-slot="{ ariaDescribedby }">
                <b-form-radio-group v-model="qualitiesSelection" style="padding:20px 0px 0px 0px">
                
                  <b-row class="ml-5 align-items-center">
                    <b-form-radio v-model="qualitiesSelection" :aria-describedby="ariaDescribedby" name="some-radios" value="default">
                      <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />&nbsp;
                      <strong style="color:#2a5d77">QUANTEEC</strong> algorithm <small v-text="$ml.get('defaultenc')"></small>
                    </b-form-radio>
                  </b-row>

                  <b-form-checkbox size="sm" style="text-align:center" v-if="qualitiesSelection === 'default' && videoToReencode.type === 'vod'" v-model="firstPass" > 
                    <span id="popover1">Passthrough-first </span>
                    <b-popover size="sm" target="popover1" triggers="hover" placement="top">
                      <template #title ><small>Passthrough-first</small></template>
                      <small v-html="$ml.get('pttext')"></small>
                    </b-popover>
                  </b-form-checkbox>

                  <b-row class="ml-5 align-items-center mt-3">
                    <b-form-radio v-model="qualitiesSelection" :aria-describedby="ariaDescribedby" name="some-radios" value="qualities">
                      {{$ml.get('customQ')}} <small v-if="qualitiesSelection === 'qualities'" v-text="$ml.get('confbelow')"></small>
                    </b-form-radio>
                  </b-row>

                  <b-form-checkbox size="sm" style="text-align:center" v-if="qualitiesSelection === 'qualities' && videoToReencode.type === 'vod'" v-model="firstPass" > 
                    <span id="popover2">Passthrough-first </span>
                    <b-popover size="sm" target="popover2" triggers="hover" placement="top">
                      <template #title ><small>Passthrough-first</small></template>
                      <small v-html="$ml.get('pttext')"></small>
                    </b-popover>
                  </b-form-checkbox>

                  <b-row class="ml-5 align-items-center mt-3">
                    <b-form-radio v-model="qualitiesSelection" :aria-describedby="ariaDescribedby" name="some-radios" value="passthrough">
                      Passthrough <small v-text="$ml.get('sameaso')"></small>
                    </b-form-radio>
                  </b-row>

                </b-form-radio-group>
              </b-form-group>
            </div>

            <div v-if="qualitiesSelection==='qualities'">
              <div style="border-top:1px solid #2a5d77; margin:10px 30px 20px 30px"></div>
              <b-row class="justify-content-center align-items-center mb-2">
                <h6 v-text="$ml.get('addq')"></h6>
              </b-row>
                
              <b-table centered responsive striped bordered :items="qualitiesModal" :fields="qualitiesTable">
                <template v-slot:cell(bitrate)="row">
                  <b-form-input size="sm" style="max-width:120px" v-model="row.item.bitrate" />
                </template>

                <template v-slot:cell(resolution)="row">
                  <b-form-select size="sm" v-model="row.item.resolution" :options="resolutions"></b-form-select>
                </template>

                <template v-slot:cell(actions)="row">
                  <b-button size="sm" variant="quanteec" @click="removeQuality(row.index)">
                    <font-awesome-icon icon="trash" />
                  </b-button>
                </template>
              </b-table>

              <b-row class="justify-content-center align-items-center mb-3">
                <b-button size="sm" variant="msstreamblue" @click="addQuality()">
                  <b-icon icon="plus-circle" />
                  {{$ml.get('addqe')}}
                </b-button>
              </b-row>
              <div style="padding:5px"><small v-text="$ml.get('specificQ')"></small></div>  
            </div>
          </b-card>
      
      <b-row class="justify-content-around">
        <b-btn class="col-md-5 col-5" variant="msstreamblue" @click="restartEncoding(videoToReencode);hideModal('confirmOneRestartEncoding')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'cog']" />
          {{$ml.get('relaunch')}}
        </b-btn>
        <b-btn class="col-md-5 col-5" variant="quanteeclg" @click="hideModal('confirmOneRestartEncoding')">
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
          {{$ml.get('cancel')}}
        </b-btn>
      </b-row>
  </b-modal> 

  <b-modal ref="confirmOneStopEncoding" hide-footer hide-header>
    <div class="d-block text-center">
      <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'stop-circle']" />
        {{$ml.get('encprocstop')}}
      </h4>
    </div>
    <p style="line-height:normal">{{$ml.get('encprocstopconf')}} <strong><span style="color: #2F90B0">{{videoToStopEnc.title}}</span></strong>.</p>
    <b-row class="justify-content-around">
      <b-btn class="col-md-5 col-5" variant="quanteec" @click="stopEncoding(videoToStopEnc);hideModal('confirmOneStopEncoding')">
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'stop-circle']" />
        {{$ml.get('stopproc')}}
      </b-btn>
      <b-btn class="col-md-5 col-5" variant="quanteeclg" @click="hideModal('confirmOneStopEncoding')">
        <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
        {{$ml.get('cancel')}}
      </b-btn>
    </b-row>
  </b-modal> 

  <b-modal ref="errorSeveralLiveWebcam" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-layers style="margin-right:15px">
            <font-awesome-icon style="color:red" icon="share" />
            <font-awesome-icon style="color:red" icon="play" transform="shrink-7 right-13 up-2" />
          </font-awesome-layers>
          <span v-html="$ml.get('videoprocresterr')"></span>
        </h4>
      </div>
      <p style="line-height: normal" v-text="$ml.get('restartliveserr')"></p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('errorSeveralLiveWebcam')"
          >
          {{$ml.get('close')}}
          </b-btn
        >
      </b-row>
    </b-modal>

  <b-modal ref="confirmClickExport" hide-footer hide-header>
    <div class="d-block text-center">
      <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'file-export']" />
        {{$ml.get('iframecode')}} 
      </h4>
    </div>
    <p style="line-height:normal" >{{$ml.get('iframecodetxt')}} <span style="color: #2F90B0">{{videocopy.title}}</span> {{$ml.get('clip')}} </p>
    <b-row class="justify-content-around">
      <b-btn class="col-5" variant="quanteeclg" @click="hideModal('confirmClickExport')">
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
        {{$ml.get('close')}}
      </b-btn>
    </b-row>
  </b-modal>
  
  <b-modal ref="confirmClickDirectLink" hide-footer hide-header>
    <div class="d-block text-center">
      <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'link']" />
        {{$ml.get('directlink')}} 
      </h4>
    </div>
    <p style="line-height:normal"><span style="color: #2F90B0">{{$ml.get('directlinktxt')}} {{videocopy.title}}</span> {{$ml.get('clip')}} </p>
    <b-row class="justify-content-around">
      <b-btn class="col-5" variant="quanteeclg" @click="hideModal('confirmClickDirectLink')">
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
        {{$ml.get('close')}}
      </b-btn>
    </b-row>
  </b-modal>

  <b-modal ref="confirmPlanDesAll" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-layers style="margin-right:20px">
            <font-awesome-icon icon="share" />
            <font-awesome-icon style="color:red" icon="trash" transform="shrink-4 right-14 up-3" />
          </font-awesome-layers>
          {{$ml.get('delayeddesplan')}}
        </h4>
      </div>
      <p style="line-height:normal">
        <span v-html="$ml.get('delayeddesplantxt')"></span> 
        <strong>{{adjustDate(deleteDate)}}</strong>.
      </p>
      <span v-if="deleteDate < currentDate" style="color:red; font-size:12px; margin-bottom:20px" title="Date/time prior to now">
        <font-awesome-icon icon="exclamation-triangle" />
        {{$ml.get('delayedreason')}}
      </span>

      <b-row class="justify-content-around mt-2">
        <b-btn class="col-md-5 col-5" variant="msstreamblue" @click="updatePlanDesSelected(deleteDate);hideModal('confirmPlanDesAll')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'cog']" />
          {{$ml.get('confirm')}}
        </b-btn>
        <b-btn class="col-md-5 col-5" variant="quanteeclg" @click="hideModal('confirmPlanDesAll')">
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
          {{$ml.get('cancel')}}
        </b-btn>
      </b-row>
  </b-modal>

  <b-modal ref="successDeleteProgrammed" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-layers style="margin-right:15px">
            <font-awesome-icon icon="share" />
            <font-awesome-icon icon="play" transform="shrink-7 right-13 up-2" />
          </font-awesome-layers>
          {{$ml.get('delayeddesplan')}}
        </h4>
      </div>
      <p style="line-height: normal">
        {{$ml.get('delayedtime')}} {{nbErrPlanSel}}.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('successDeleteProgrammed')"
          >{{$ml.get('close')}}</b-btn
        >
      </b-row>
    </b-modal>

     <b-modal ref="errorDeleteProgrammed" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-layers style="margin-right:15px">
            <font-awesome-icon style="color:red" icon="share" />
            <font-awesome-icon style="color:red" icon="play" transform="shrink-7 right-13 up-2" />
          </font-awesome-layers>
          <span v-html="$ml.get('delayeddeserr')"></span>
        </h4>
      </div>
      <p style="line-height: normal">
        <span v-html="$ml.get('delayeddeserr2')"></span>
        <strong style="color:red">{{titleTamp}}</strong>.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('errorDeleteProgrammed')"
          >{{$ml.get('close')}}</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="successDeleteDeleteProgrammed" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-layers style="margin-right:15px">
            <font-awesome-icon icon="share" />
            <font-awesome-icon icon="play" transform="shrink-7 right-13 up-2" />
          </font-awesome-layers>
          {{$ml.get('delayeddesclear')}}
        </h4>
      </div>
      <p style="line-height: normal">
        {{$ml.get('delayeddescleardates')}}
        {{nbErrPlanDeSel}}.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('successDeleteDeleteProgrammed')"
          >{{$ml.get('close')}}</b-btn
        >
      </b-row>
    </b-modal>

     <b-modal ref="errorDeleteDeleteProgrammed" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-layers style="margin-right:15px">
            <font-awesome-icon style="color:red" icon="share" />
            <font-awesome-icon style="color:red" icon="play" transform="shrink-7 right-13 up-2" />
          </font-awesome-layers>
            <span v-html="$ml.get('delayeddescleardateserr')"></span>
        </h4>
      </div>
      <p style="line-height: normal">
        {{$ml.get('delayeddescleardateserrtxt')}} 
        <strong style="color:red">{{titleTamp}}</strong>.
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('errorDeleteDeleteProgrammed')"
          >{{$ml.get('close')}}</b-btn
        >
      </b-row>
    </b-modal>

  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js';
let moment = require("moment");
import FadeLoader from "vue-spinner/src/FadeLoader.vue";
import VideoService from "@/services/video.service";
import AuthorizationKeyService from "@/services/authorizationKey.service";
import AnalyticsService from "@/services/analytics.service";
import { VueContext } from "vue-context";
import { BASE_READER, EMBED_URL } from "@/services/base-url";
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
var videoService = new VideoService();
var authorizationKeyService = new AuthorizationKeyService();
var analyticsService = new AnalyticsService();

export default {
  name: "VideoList",
  components: {
    VueContext,
    FadeLoader,
    DatePicker
  },
  data: function () {
    return {
      isImbricated: true,
      nbrVideoSelected: 0,
      videoToDelete: {},
      videoToReencode: {},
      videoToStopEnc: {},
      videocopy: {},
      video2: {},
      oldSearch: '',
      userView:
        this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyView() || this.$auth.getMyUser().username
          : this.$auth.getMyUser().username,
      clientView:
        this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
      isSelectAll: false,
      listFields: [
        { key: "selected", label: "Select" },
        { key: "title", label: "Title" },

        { key: "nbView", label: "Views" },
        { key: "user", label: "Author" },
        { key: "encodingStatus", label: "Encoding Status" },
        { key: "tags", label: "Tags" },

        { key: "sort", label: "Current Sort Option" },
        { key: "actions", label: "Details" },
        { key: "watch", label: "Watch" },
      ],
      selectedAuthorizationKeys: [],
      showGlobalAnalytics: false,
      showSelectedAnalytics: false,
      mySort: JSON.stringify({ createdAt: -1 }),
      activeSort: "createdAt",
      sortMsg: "",
      activeSortOrder: -1,
      isActive: 6,
      thOrList: 0,
      showType: ["all", "live", "vod"],
      showStatus: [
        "all",
        "to_encode",
        "waiting_for_encoding",
        "encoding",
        "encoded",
        "to_stop",
        "stopped",
        "error",
        "uploading",
        "segmented",
        "restart",
        "upload_failed"
      ],
      showWarning: ["all", "green", "orange", "red", "black"],
      activatedSearch: "Checkboxes",
      barOrCheck: false,
      firstFocusUsed: false,
      baseurl: BASE_READER,
      top: "0px",
      left: "0px",
      videos: [],
      errors: [],
      //PAGE
      totalNumberOfPage: 1000000,
      realTotalNumberOfPage: 1000000,
      currentPage: 1,
      goPage: 1,
      numberPerPage: (this.$auth.getMyUser().client_infos && this.$auth.getMyUser().client_infos[0] && this.$auth.getMyUser().client_infos[0].defaultNumberPerPage) ? this.$auth.getMyUser().client_infos[0].defaultNumberPerPage : 20,
      lastGetWithPage: false,

      //SEARCH PARAM
      search: "",
      searchParameters: {},
      titleTamp: "",

      // Advanced Filter :
      advancedFilter: false,
      oldAdvancedFilters: 'livevod',
      advancedFiltersDefault: ['live', 'vod'],
      advancedFilters: ['live', 'vod'],
      advancedFilterOptions: [
        { text: 'Live', value: 'live' },
        { text: 'VOD', value: 'vod' },
        /*{ text: 'Live archive', value: 'archive' },
        { text: 'Cut', value: 'cut' }*/
      ],

      //STATS
      numberOfVideos: 0,
      totalNumberOfVideos: 0,
      liveNumber: 0,
      vodNumber: 0,
      passthroughNumber: 0,
      encoding1Number: 0,
      to_stopNumber: 0,
      stoppedNumber: 0,
      waiting_for_encodingNumber: 0,
      to_encodeNumber: 0,
      encodingNumber: 0,
      encodedNumber: 0,
      restartNumber: 0,
      errorNumber: 0,
      totalNumberOfAuthorizationKeys: 0,
      keyTypeLiveNumber: 0,
      keyTypeVodNumber: 0,
      keyTypeLVNumber: 0,
      greenNumber: 0,
      orangeNumber: 0,
      redNumber: 0,
      blackNumber: 0,
      fileChapters: null,
      modifyChapters: '',
      nbErrPlanSel: 0,
      nbErrPlanDeSel: 0,

      currentDate : new Date(),
      deleteDate: "",
      descDate: false,

      // LOADER
      isGetInProgress: false,
      timeoutSearch: null,
      timeoutSearchDuration: 2,

      showLegend: false,

      // Modify qualities
      restartEncodingQuality: false,
      qualitiesSelection: 'default',
      firstPass: false,
      qualitiesModal:[],
      qualitiesTable : 
        [
            { key: "bitrate", label: "Bitrate (kbps)", thClass: 'text-center', tdClass: 'text-center'},
            { key:"resolution", label :"Resolution", thClass: 'text-center', tdClass: 'text-center'},
            { key: "actions", label: "Action(s)", thClass: 'text-center', tdClass: 'text-center'}
        ],
      resolutions:[
        {
          value:
          {
            width:256,
            height:144
          },
          text:"YouTube 144p: 256x144"
        },
        {
          value:
          {
            width:384,
            height:576
          },
          text:"SECAM: 384x576"
        },
        {
          value:
          {
            width:450,
            height:576
          },
          text:"PAL: 450x576"
        },
        {
          value:
          {
            width:323,
            height:486
          },
          text:"NTSC: 323x486"
        },
        {
          value:
          {
            width:352,
            height:288
          },
          text:"MPEG-1 PAL: 352x288"
        },
        {
          value:
          {
            width:352,
            height:243
          },
          text:"MPEG-1 NTSC: 352x243"
        },
        {
          value:
          {
            width:720,
            height:576
          },
          text:"MPEG-2 PAL: 720x576"
        },
        {
          value:
          {
            width:480,
            height:576
          },
          text:"MPEG-2 PAL: 720x480"
        },
        {
          value:
          {
            width:1280,
            height:720
          },
          text:"HD: 1280x720"
        },
        {
          value:
          {
            width:1920,
            height:1080
          },
          text:"Full HD: 1920x1080"
        },
        {
          value:
          {
            width:3840,
            height:2160
          },
          text:"UHD (4K): 3840x2160"
        },        
        {
          value:
          {
            width:7680,
            height:4320
          },
          text:"UHD (8K): 7680x4320"
        },         
      ],
      clientTags:[],
      selectedTags:[],
      exludedTags:[],
    };
  },
  beforeDestroy() {
    try {
      clearTimeout(this.timeoutSearch);
    } catch (e) {}
    try {
      clearTimeout(this.timeoutNumberVideoPlatform);
    } catch (e) {}
    try {
      clearInterval(this.intervalCheckEncodingPercent);
    } catch (e) {}
    try {
      clearInterval(this.intervalLivePosition);
    } catch (e) {}
  },
  mounted: function () {
    //this.currentPage = this.$store.state.pageNumber;
    //this.search = this.$store.state.search;
    //this.searchParameters = this.$store.state.searchParameters;

    // Get search storage
    let storageSearchInfos = this.getSearchParameters();
    let storageSort = this.getSortParameters();
    let storageList = this.getListParam();
    let storagePage = this.getCurrentPage();
    this.searchParameters =
      storageSearchInfos.searchParameters || this.searchParameters;
    this.search = storageSearchInfos.searchBar || this.search;
    this.showType = storageSearchInfos.typeCheck || this.showType;
    this.showStatus = /*storageSearchInfos.statusCheck ||*/ this.showStatus;
    this.showWarning = storageSearchInfos.warningCheck || this.showWarning;
    this.advancedFilters = storageSearchInfos.advancedFilters || this.advancedFilters;

    if(storageSearchInfos.searchParameters)
    {
      storageSearchInfos.searchParameters["$and"].forEach(param=>{
        if(Object.keys(param)[0] === "tags")
        {

          if(param.tags["$in"])
          {
            
            this.selectedTags = param.tags["$in"]
          }

          if(param.tags["$nin"])
          {
            this.exludedTags = param.tags["$nin"]
          }
        }
      })
    }


    this.activeSort = storageSort.sort || this.activeSort;
    this.activeSortOrder =
      storageSort.sortOrder !== null && storageSort.sortOrder !== undefined
        ? storageSort.sortOrder
        : this.activeSortOrder;
    this.mySort = JSON.stringify({ [this.activeSort]: this.activeSortOrder });

    this.thOrList =
      storageList.thOrList !== null && storageList.thOrList !== undefined && !isNaN(storageList.thOrList)
        ? storageList.thOrList
        : +this.thOrList;
    this.currentPage = this.$store.state.pageNumber || 1;
    if (this.currentPage === 1) {
      this.getClientTags().then(()=>{
        this.selectedTags.forEach(tag=>{
          let currentTag = document.getElementById("tag-"+tag)
          if(currentTag){
          currentTag.classList.add('tag-selected');
          currentTag.classList.remove('tag-not-selected');
          }

        })

        this.exludedTags.forEach(tag=>{

          let currentTag = document.getElementById("tag-"+tag)
          if(currentTag){
          currentTag.classList.add('tag-excluded');
          currentTag.classList.remove('tag-not-selected');
          }


        })
      })
      this.getVideos(this.currentPage);
    }

    /*this.timeoutNumberVideoPlatform = setTimeout(
      this.getNumberVideoPlatform,
      100
    );*/
    this.intervalCheckEncodingPercent = setInterval(
      this.checkEncodingPercent,
      5000
    );
    this.intervalLivePosition = setInterval(
      this.livePosition,
      1000
    );

    EventBus.$on('VideoListRefresh', this.getVideos.bind(this));
    
  },
  computed: {
    defaultAdvancedFilters() {
      function areEqual(array1, array2) {
        if (array1.length === array2.length) {
          return array1.every(element => {
            if (array2.includes(element)) {
              return true;
            }

            return false;
          });
        }

        return false;
      }

      return areEqual(this.advancedFilters, this.advancedFiltersDefault);
    },
    focusPage() {
      return this.$store.state.pageNumber;
    },
    focus() {
      return this.$store.state.focus;
    },
    numberSelected() {
      return this.getListAllVideos().filter((elem) => elem.isSelected).length;
    },
    
    activeSortMsg() {
      switch (this.activeSort) {
        case '':
          this.sortMsg = "none";
          break;
        case 'user':
          this.sortMsg = "author";
          break;
        case 'createdAt':
          this.sortMsg = "creation date";
          break;
        case 'lastModifyAt':
          this.sortMsg = "last update date";
          break;  
        case 'liveType':
          this.sortMsg = "type of live video";
          break;
        case 'archivesFromLiveSize':
          this.sortMsg = "number of archives";
          break;
        case 'videoInAndOutSize':
          this.sortMsg = "number of cut-versions";
          break;
        case 'encodingStatus':
          this.sortMsg = "processing status";
          break;
        case 'currentNumberOfQualities':
          this.sortMsg = "number of qualities";
          break;
        case 'error':
          this.sortMsg = "processing error(s)";
          break;
        case 'bestQualityPercent':
          this.sortMsg = "top quality %";
          break;
        case 'rebuff':
          this.sortMsg = "rebuffering %";
          break;
        case 'offload':
          this.sortMsg = "efficiency %";
          break;
        case 'dataDelivered':
          this.sortMsg = "data delivered";
          break;
        case 'concurrentUsers':
          this.sortMsg = "concurrent viewers";
          break;
        case 'energySaved':
          this.sortMsg = "% of energy saved";
          break;
        case 'kwhSpent':
          this.sortMsg = "KWh spent";
          break;
        case 'co2Spent':
          this.sortMsg = "CO2 rejected";
          break;
        case 'nbView':
          this.sortMsg = "views number";
          break;
        case 'hourview':
          this.sortMsg = "viewing hours";
          break;
        case 'meanTime':
          this.sortMsg = "mean viewing duration";
          break;
        case 'chapters.length':
          this.sortMsg = "presence of chapters";
          break;
        case 'type':
          this.sortMsg = "video type";
          break;
        case 'download':
          this.sortMsg = "downloadable feature";
          break;
        case 'uploadingPercent':
          this.sortMsg = "uploading %";
          break;
        case 'encodingPercent':
          this.sortMsg = "encoding %";
          break;
        case 'uploadingETA':
          this.sortMsg = "uploading remaining time";
          break;
        case 'encodingETA':
          this.sortMsg = "encoding remaining time";
          break;

        default:
          this.sortMsg = this.activeSort;
      }
      return this.sortMsg;
    },
  },
  methods: {
    updateImbricated() {
      this.onSearchBar();
    },
    getClientTags(){
      return new Promise((resolve) => {
        videoService.getClientTags(this.$auth.token(), this.clientView).then(res=>{
          res.forEach(tag=>{
            this.clientTags.push(tag._id)
          })
          this.clientTags.sort((a, b) => a.localeCompare(b));
          resolve()

        }).catch(err=>{
          console.error(`Error getting client's tags`, err)
          reject()
        })
      })

    },
    deleteProgrammed(video, test) {
      let goDelete = () => {
        videoService
        .deleteProgrammed(video._deleteDate, video.uuid, this.$auth.token())
        .then((task) => {
          this.titleTamp = video.title;
          video.deleteDate = video._deleteDate;
          video._modifyPlanDes = false;
          this.videos = this.videos.splice(0);
          //this.showModal('successDeleteProgrammed')
        }).catch(err => {
          this.showModal('errorDeleteProgrammed')
        });
      }

      if (new Date(video._deleteDate).getTime() <= new Date().getTime()) {
        if ((video.archivesFromLiveSize !== undefined && video.archivesFromLiveSize >= 0) || (video.videoInAndOutSize !== undefined && video.videoInAndOutSize >= 0)) {
          this.loadOtherVideos(video, goDelete);
        } else {
          goDelete();
        }  
      } else {
        goDelete();
      }
      
    
    },
    deleteDeleteProgrammed(video, test) {
      videoService
        .deleteProgrammed("", video.uuid, this.$auth.token())
        .then((task) => {
          this.titleTamp = video.title;
          video.deleteDate = "";
          video._deleteDate = "";          
          //this.showModal('successDeleteDeleteProgrammed')
        }).catch(err => {
          if (!test) {
            this.showModal('errorDeleteDeleteProgrammed')
          } else {
            throw new Error();
          }
        });
    },
    emitVoD() {
        EventBus.$emit('windowVoD');
        //this.$router.push('/videoupload/vod')
    },
    emitLive() {
        EventBus.$emit('windowLive', {specificVideoID: null});
        //this.$router.push('/videoupload/live');
    },
    adjustDate(date) {
      return (date !== undefined) ? moment(date).format("DD/MM/YY @HH:mm"): "";
    },    
    startTimeoutSearch() {
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {}
      if (this.oldSearch !== this.search || this.advancedFilters.join('') !== this.oldAdvancedFilters) {
        this.isGetInProgress = true;
        this.timeoutSearch = setTimeout(this.onSearchBar, this.timeoutSearchDuration * 1000);
      } else {
        this.isGetInProgress = false;
      }
    },
    startTimeoutSearchTags() {
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {}
      this.isGetInProgress = true;
      this.timeoutSearch = setTimeout(this.onSearchBar, this.timeoutSearchDuration * 1000);

    },
    imgUrlAlt(event, video) {
      if (video.type === "live") {
        event.target.src = `/thumbnaillive.jpg`;
      } else if (video.encodingStatus === "encoding") {
        event.target.src = `/thumbnail2.jpg`;
      } else {
        event.target.src = `/thumbnail.jpg`;
      }
      
    },
    onRowSelected(items) {
      this.videoSelected = items;
    },
    showModal2(ref) {
      this.$refs[ref].show();
    },
    hideModal2(ref) {
      this.$refs[ref].hide();
    },
    checkOrBar() {
      if (this.barOrCheck) {
        this.activatedSearch = "Searchbar";
        this.search = "";
        this.onSearchBar();
      } else {
        this.activatedSearch = "Checkboxes";
        this.onSearchBar();
      }
    },
    
    showAndHideModal(ref) {
      let self = this;
      self.showModal(ref);
      setTimeout(function() {
        self.hideModal(ref)
      }, 3000);
    },

    startModifyTags(video) {
      if (video.tags && video.tags.length > 0) {
        video._tags = video.tags
      } else {
        video._tags = [];
      }
      video._modifyTags = true;
      this.videos = this.videos.splice(0);
    },

    endModifyTags(video) {
      video.tags = video._tags
      video._modifyTags = false;
      var tags = video._tags;
      tags.forEach(tag=>{
        if(this.clientTags.indexOf(tag) === -1)
        {
          this.clientTags.push(tag)
        }
      })
        videoService.putVideoById({tags: tags}, video.uuid, this.$auth.token()).then(() => {
          this.videos = this.videos.splice(0);
        }).catch((err) => {

        })
    },
    updateTags(video) {

    },

    changeTagState(tag)
    {
      var selectedIndex = this.selectedTags.indexOf(tag);
      var excludedIndex = this.exludedTags.indexOf(tag)
      
      //TO-DO récupérer l'icone du tag et le changer 

      if((selectedIndex === -1 && excludedIndex === -1))
      {
          this.selectedTags.push(tag)
          this.startTimeoutSearchTags();
      } else if (selectedIndex != -1 && excludedIndex === -1) {
          this.selectedTags.splice(selectedIndex,1)
          this.exludedTags.push(tag)
          this.startTimeoutSearchTags();
      } else {
          this.exludedTags.splice(excludedIndex, 1)
          this.startTimeoutSearchTags();
      }
      this.clientTags = this.clientTags.splice(0)
    },

    updateTitle(video) {
        videoService.putVideoById({title: video._title}, video.uuid, this.$auth.token()).then(() => {
          video._modifyTitle = false;
          video.title = video._title;
          this.videos = this.videos.splice(0);
        }).catch((err) => {
        })
    },

    cancelTitle(video){
      video._modifyTitle = false;
      this.videos = this.videos.splice(0);
    },
    updateDescription(video) {
        videoService.putVideoById({description: video._desc}, video.uuid, this.$auth.token()).then(() => {
          video._modifyDescription = false;
          video.description = video._desc;
          this.videos = this.videos.splice(0);
        }).catch((err) => {

        })
    },
    cancelDescription(video){
      video._modifyDescription = false;
      this.videos = this.videos.splice(0);
    },

    updateDownload(video) {
      if (video.type === "live") {
        videoService.putVideoDownload(video.downloadLive, video.uuid, this.$auth.token()).then(() => {
          //TODO Au lieu de changer dans les vidéos, on peut recharger la liste des archives maintenant !
          this.videos.forEach(otherVideo => {
            if (otherVideo.type === "vod" && otherVideo.archive && otherVideo.archiveLive === video.uuid) {
              otherVideo.download = video.downloadLive;
            }
          })
          this.videos = this.videos.splice(0);
        }).catch((err) => {

        })
      } else {
        videoService.putVideoDownload(video.download, video.uuid, this.$auth.token()).then(() => {
        
        }).catch((err) => {

        })
      }
    },
    updateIntroModal(video) {
      videoService
        .putVideoById(
          { introModal: video.introModal },
          video.uuid,
          this.$auth.token()
        )
        .then(() => {

        })
        .catch((err) => {

        });
      
    },

    updateDownloadSelected() {
      let allVideos = this.getListAllVideos();
      for (var video of allVideos) {
        if (video._isSelected) {
         video.download = true;
         this.updateDownload(video);
        }
      }
/*      this.isSelectAll = false;
      this.selectAll();*/
    },

    updateUnDownloadSelected() {
      let allVideos = this.getListAllVideos();
      for (var video of allVideos) {
        if (video._isSelected) {
         video.download = false;
         this.updateDownload(video);
        }
      }
/*      this.isSelectAll = false;
      this.selectAll();*/
    },

    updateShowACSelected() {
      let allVideos = this.getListAllVideos();
      for (var video of allVideos) {
        if (video._isSelected) {
         this.loadOtherVideos(video);
        }
      }
      this.isSelectAll = false;
      this.selectAll();
    },

    updateHideACSelected() {
      let allVideos = this.getListAllVideos();
      for (var video of allVideos) {
        if (video._isSelected) {
         this.unloadOtherVideos(video);
        }
      }
      this.isSelectAll = false;
      this.selectAll();
    },

    restartEncoding(video) {
      let myEncoding = (this.qualitiesSelection === "default" || this.qualitiesSelection === "qualities") ? "encoding" : "passthrough";
      let myInputQualities = "QuanteecOptimization";
      if (this.qualitiesSelection === "default" || this.qualitiesSelection === "passthrough") {
        myInputQualities = "QuanteecOptimization";
      } else if (this.qualitiesSelection === "qualities") {
        myInputQualities = this.qualitiesModal;
      }
      let myFirstPass = false;
      if (video.type === 'vod' && this.firstPass) {
        myFirstPass = this.firstPass;
      }
      videoService.putVideoById({firstPass: myFirstPass, encoding:myEncoding, inputQualities: myInputQualities, directStream: video.directStream}, video.uuid, this.$auth.token())
        .then(() => {
          if (video.type === 'live' && video.liveCamera === true) {
            this.openLiveWebcam(video);
          } else {
            videoService.putEncodingToVideoById(video.uuid, this.$auth.token()).then(() => {
              video.encodingStatus="restart"
              this.checkEncodingPercent()
              this.videos = this.videos.splice(0)
            }).catch((err) => {})
          }
      }).catch(err => {
        console.log(err);
      })
    },

    restartEncodingSelected() {
      let liveFromWebcams = 0;

      let allVideos = this.getListAllVideos();
      for (var video of allVideos) {
        if (video._isSelected && video.type === "live" && video.liveCamera === true) {
          liveFromWebcams++;
        }
      }
      if (liveFromWebcams > 1) {
        this.showModal('errorSeveralLiveWebcam');
      } else {
        for (var video of allVideos) {
          if (video._isSelected && video.sourcePath.toLowerCase() !== 'quanteec' && video.sourcePath.toLowerCase() !== 'archive') {
            this.restartEncoding(video);
          }
        }
      }
      
    },

    stopEncoding(video) {
      videoService.deleteEncodingToVideoById(video.uuid, this.$auth.token()).then(() => {
        video.encodingStatus = "to_stop";
        this.videos = this.videos.splice(0);
        this.checkEncodingPercent();
      }).catch((err) => {})
    },

    addChapterFile(event, video) {
      try {
       video._file = event.target.files[0];
      } catch(err) {

      }
    },

    putChapterFile(video) {
      if (video._file) {
        var form = new FormData();
        form.append("video", video._file, video._file.filename);
        videoService.putChaptersFile(video.uuid, form, this.$auth.token()).then((videoOuput) => {
          delete video._file;
          video.chapters = videoOuput.chapters;
          this.videos = this.videos.splice(0);
        }).catch((err) => {
          console.log(err);
        })
        document.getElementById("file"+video.uuid).value=null;
      }
    },

    deleteChapters(video) {
      videoService.putChapters({chapters: []}, video.uuid, this.$auth.token()).then(() => {
        video.chapters = [];
        this.videos = this.videos.splice(0);
      }).catch((err) => {

      })
    },

    updateZeroChapters() {
      let allVideos = this.getListAllVideos();
      for (var video of allVideos) {
        if (video._isSelected) {
         this.deleteChapters(video);
        }
      }
/*      this.isSelectAll = false;
      this.selectAll();*/
    },

    updatePlanDesSelected(dDate) {
      let allVideos = this.getListAllVideos();
      for (var video of allVideos) {
        if (video._isSelected) {
          video.deleteDate = dDate;
          video._deleteDate = dDate;
          this.descDate = false;
          try {
            this.deleteProgrammed(video, true);
          } catch(err) {
            // Si erreur
            nbErrPlanSel++;
          }
        }
      }
      this.showModal('successDeleteProgrammed');
    },

    updateZeroPlanDesSelected() {
      let allVideos = this.getListAllVideos();
      for (var video of allVideos) {
        if (video._isSelected) {
          try {
            this.deleteDeleteProgrammed(video, true);
          } catch(err) {
            // Si erreur
            nbErrPlanDeSel++;
          }
        }
      }
      this.showModal('successDeleteDeleteProgrammed');
    },
    applyAdvancedFilters(customSearchParameters) {
      let mySearchParameters = customSearchParameters || this.searchParameters;
      if (this.advancedFilters.length !== 4) {
        if (!mySearchParameters["$and"]) {
          mySearchParameters["$and"] = [];
        }
        if (this.advancedFilters.indexOf('live') === -1) {
          mySearchParameters["$and"].push({"type":"vod"});
        }
        if (this.advancedFilters.indexOf('vod') === -1) {
          let ruleVoD = {"$or": [{"type":"live"}]};
          if (this.advancedFilters.indexOf('archive') > -1 || this.advancedFilters.indexOf('cut') > -1) {
            ruleVoD["$or"].push({"$and": [{"type":"vod"}, {"$or":[]}]})
          }
          if (this.advancedFilters.indexOf('archive') > -1 && !this.isImbricated) {
            ruleVoD["$or"][1]["$and"][1]["$or"].push({archive:true});
          }
          if (this.advancedFilters.indexOf('cut') > -1 && !this.isImbricated) {
            ruleVoD["$or"][1]["$and"][1]["$or"].push({inAndOutOrigin:{"$exists":true}});
          }
          mySearchParameters["$and"].push(ruleVoD);
        }
        if (this.advancedFilters.indexOf('archive') === -1 && this.isImbricated) {
          mySearchParameters["$and"].push({"$or":[{"archive":{"$exists":false}},{"archive":false}]})
        }
        if (this.advancedFilters.indexOf('cut') === -1 && this.isImbricated) {
          mySearchParameters["$and"].push({"$or":[{"inAndOutOrigin":{"$exists":false}},{"inAndOutOrigin":''}]})
        }
      }
      try {
        if(mySearchParameters["$and"].length === 0) {
          delete mySearchParameters["$and"];
        }
      } catch(err) {}
      //console.log('[Advanced filters]', this.isImbricated, mySearchParameters["$and"])
       
    },
    addAdvancedFilters(value) {
      if (this.advancedFilters.indexOf(value) === -1) {
        this.advancedFilters.push(value);
      }
    },
    rmAdvancedFilters(value) {
      if (this.advancedFilters.indexOf(value) !== -1) {
        this.advancedFilters.splice(this.advancedFilters.indexOf(value), 1);
      }
    },
    onSearchBar() {
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {}
      let words = this.search.toLowerCase().split(" ");
      this.oldSearch = this.search;
      this.oldAdvancedFilters = this.advancedFilters.join("");
      this.searchParameters = {};
      this.searchParameters["$and"] = [];

      for (let word of words) 
      {
        if (word.startsWith("uuid:") || word.startsWith("id:")) 
        {
          let uuid = word.split(":")[1].split("+");
          if (uuid.length > 1) {
            this.searchParameters["$and"].push({ uuid: { $in: uuid } });
          } else {
            this.searchParameters["$and"].push({ uuid: word.split(":")[1] });
          }
        } else if (word.startsWith("description:")) {
          let decription = word.split(":")[1].split("+");
          decription = decription.map((elem) => {
            return "(?i)^.*" + elem + ".*";
          });
          if (decription.length > 1) {
            this.searchParameters["$and"].push({
              description: { $regex: decription.join("|") },
            });
          } else {
            this.searchParameters["$and"].push({
              description: { $regex: decription[0] },
            });
          }
        } else if (word.startsWith("encoding:")) {
          let encoding = word.split(":")[1].split("+");
          if (encoding.length > 1) {
            this.searchParameters["$and"].push({ encoding: { $in: encoding } });
          } else {
            this.searchParameters["$and"].push({
              encoding: word.split(":")[1],
            });
          }

          } else if (word.startsWith("status:")) {
          let status = word.split(":")[1].split("+");
          if (status.length > 1) {
            this.searchParameters["$and"].push({ encodingStatus: { $in: status } });
          } else {
            this.searchParameters["$and"].push({
              encodingStatus: word.split(":")[1],
            });
          }
          
          } else if (
          word.startsWith("authorizationkey:") ||
          word.startsWith("key:")
        ) {
          let authorizationKey = word.split(":")[1].split("+");
          if (authorizationKey.length > 1) {
            this.searchParameters["$and"].push({
              authorizationKey: { $in: authorizationKey },
            });
          } else {
            this.searchParameters["$and"].push({
              authorizationKey: word.split(":")[1],
            });
          }

          } else if (word.startsWith("title:")) 
          {
            let title = word.split(":")[1].split("+");
            title = title.map((elem) => {
              return "(?i)^.*" + elem + ".*";
            });
            if (title.length > 1) {
              this.searchParameters["$and"].push({
                title: { $regex: title.join("|") },
              });
            } else {
              this.searchParameters["$and"].push({
                title: { $regex: title[0] },
              });
            }

          } else {
            var objTest = { $regex: "(?i)^.*" + word + ".*" };
            this.searchParameters["$and"].push({
              $or: [{ title: objTest }],
            });
          }
          
          if (this.selectedTags.length>0 || this.exludedTags.length>0)
          {

            if(this.selectedTags.length>0)
            {
              this.searchParameters["$and"].push({
                tags:{$in:this.selectedTags}
              })
            }
            if(this.exludedTags.length>0)
            {
              this.searchParameters["$and"].push({
                tags:{$nin:this.exludedTags}
              })
            }
            /*
          let tags = word.split(":")[1].split("+");
          tags = tags.map((elem) => {
            return "(?i)^.*" + elem + ".*";
          });
          if (tags.length > 1) {
            this.searchParameters["$and"].push({
              tags: { $regex: tags.join("|") },
            });
          } else {
            this.searchParameters["$and"].push({
              tags: { $regex: tags[0] },
            });
          }

          } else {
          var objTest = { $regex: "(?i)^.*" + word + ".*" };
          this.searchParameters["$and"].push({
            $or: [{ title: objTest }],
          });*/
        }
      }

      //console.log("SEARCH PARAMETERS",this.searchParameters);

      // CheckType
      if (this.showType.length == 3) {
        delete this.searchParameters.type;
      } else {
        if (this.showType.length > 1) {
          this.searchParameters["$and"].push({ type: { $in: this.showType } });
        } else {
          this.searchParameters["$and"].push({ type: this.showType[0] });
        }
      }

      // checkStatus
      if (this.showStatus.length === 10) {
        delete this.searchParameters.encodingStatus;
      } else {
        if (this.showStatus.length > 1) {
          this.searchParameters["$and"].push({
            encodingStatus: { $in: this.showStatus },
          });
        } else {
          this.searchParameters["$and"].push({
            encodingStatus: this.showStatus[0],
          });
        }
      }

      // Check Warning
      if (this.showWarning.length == 5) {
        delete this.searchParameters.warning;
      } else {
        var warning = [...this.showWarning];
        let colorOr = [];
        if (warning.indexOf("black") === -1) {
          // Pas de black
          this.searchParameters["$and"].push({ error: false });
        } else if (warning.length === 1) {
          // Du black tout seul
          this.searchParameters["$and"].push({ error: true });
        } else {
          // Du black et autre
          colorOr.push({ error: true });
        }
        if (warning.indexOf("green") > -1) {
          colorOr.push({ rebuff: { $lte: 20 } });
        }
        if (warning.indexOf("orange") > -1) {
          colorOr.push({ rebuff: { $gt: 20, $lte: 50 } });
        }
        if (warning.indexOf("red") > -1) {
          colorOr.push({ rebuff: { $gt: 50 } });
        }
        if (colorOr.length > 0) {
          this.searchParameters["$and"].push({ $or: colorOr });
        }
      }

      let previousSearchParameters = this.getSearchParameters();
      this.saveSearchParameters();
      this.currentPage = 1;
      this.getVideos();
    },
    onSearchOK() {
      this.currentPage = 1;
      this.getVideos();
    },
    saveListParam() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem("QuanteecLabs_list", this.thOrList);
      } catch (err) {}
    },
    getListParam() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.thOrList = searchStorage.getItem("QuanteecLabs_list");
        result.thOrList = +result.thOrList;
      } catch (err) {}

      return result;
    },
    saveSearchParameters() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem(
          "QuanteecLabs_searchparameters",
          JSON.stringify(this.searchParameters)
        );
        searchStorage.setItem("QuanteecLabs_searchbar", this.search);
        searchStorage.setItem(
          "QuanteecLabs_typecheck",
          JSON.stringify(this.showType)
        );
        searchStorage.setItem(
          "QuanteecLabs_statuscheck",
          JSON.stringify(this.showStatus)
        );
        searchStorage.setItem(
          "QuanteecLabs_warningcheck",
          JSON.stringify(this.showWarning)
        );
        searchStorage.setItem(
          "QuanteecLabs_advancedfilters",
          JSON.stringify(this.advancedFilters)
        );
      } catch (err) {}
    },
    getSearchParameters() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.searchParametersString = searchStorage.getItem(
          "QuanteecLabs_searchparameters"
        );
        result.searchParameters = JSON.parse(
          searchStorage.getItem("QuanteecLabs_searchparameters")
        );
        result.searchBar = searchStorage.getItem("QuanteecLabs_searchbar");
        result.typeCheck = JSON.parse(
          searchStorage.getItem("QuanteecLabs_typecheck")
        );
        result.statusCheck = JSON.parse(
          searchStorage.getItem("QuanteecLabs_statuscheck")
        );
        result.warningCheck = JSON.parse(
          searchStorage.getItem("QuanteecLabs_warningcheck")
        );
        result.advancedFilters = JSON.parse(
          searchStorage.getItem("QuanteecLabs_advancedfilters")
        );
      } catch (err) {
        console.log(err);
      }

      return result;
    },
    saveSortParameters() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem("QuanteecLabs_sortparam", this.activeSort);
        searchStorage.setItem(
          "QuanteecLabs_sortorder",
          this.activeSortOrder === 1 ? "asc" : "desc"
        );
      } catch (err) {}
    },
    getSortParameters() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.sort = searchStorage.getItem("QuanteecLabs_sortparam");
        result.sortOrder = searchStorage.getItem("QuanteecLabs_sortorder");
        if (result.sortOrder === "asc") {
          result.sortOrder = 1;
        } else {
          result.sortOrder = -1;
        }
      } catch (err) {}

      return result;
    },
    saveCurrentPage() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem(
          "QuanteecLabs_page",
          JSON.stringify(this.currentPage)
        );
      } catch (err) {}
    },
    getCurrentPage() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.currentPage = searchStorage.getItem("QuanteecLabs_page");
      } catch (err) {
        console.log(err);
      }

      return result;
    },
    getOtherVideos() {
      let result = [];
      try {
        let searchStorage = sessionStorage;
        result = JSON.parse(searchStorage.getItem("QuanteecLabs_othervideos"));
      } catch (err) {
        console.log(err);
      }
      if(result === undefined || result === null) {
        result = [];
      }

      return result;
    },
    saveOtherVideo(uuid) {
      let result = this.getOtherVideos();
      let idx = result.findIndex(x => x === uuid)
      if (idx === -1) {
        result.push(uuid);
      }
      try {
        let searchStorage = sessionStorage;
        result = searchStorage.setItem("QuanteecLabs_othervideos", JSON.stringify(result));
      } catch (err) {
        console.log(err);
      }
    },
    removeSavedOtherVideo(uuid) {
      let result = this.getOtherVideos();
      let idx = result.findIndex(x => x === uuid)
      if (idx > -1) {
        result.splice(idx, 1);
      }
      try {
        let searchStorage = sessionStorage;
        result = searchStorage.setItem("QuanteecLabs_othervideos", JSON.stringify(result));
      } catch (err) {
        console.log(err);
      }
    },
    manageCheckType(checked) {
      if (this.showType.indexOf(checked) == -1 && checked !== "all") {
        this.showType.push(checked);
      } else if (checked == "all" && this.showType.indexOf("all") != -1) {
        this.showType = [];
      } else if (checked == "all" && this.showType.indexOf("all") == -1) {
        this.showType = ["all", "live", "vod"];
      } else if (checked != "all" && this.showType.indexOf(checked) != -1) {
        let indexChecked = this.showType.indexOf(checked);
        this.showType.splice(indexChecked, 1);
        if (this.showType.indexOf("all") != -1) {
          let indexAll = this.showType.indexOf("all");
          this.showType.splice(indexAll, 1);
        }
      }
      if (this.showType.indexOf("all") == -1 && this.showType.length == 2) {
        this.showType.push("all");
      }
    },
    manageCheckStatus(checked) {
      if (this.showStatus.indexOf(checked) == -1 && checked !== "all") {
        this.showStatus.push(checked);
      } else if (checked == "all" && this.showStatus.indexOf("all") != -1) {
        this.showStatus = [];
      } else if (checked == "all" && this.showStatus.indexOf("all") == -1) {
        this.showStatus = [
          "all",
          "to_encode",
          "waiting_for_encoding",
          "encoding",
          "encoded",
          "to_stop",
          "stopped",
          "segmented",
          "restart",
          "uploading",
          "error",
        ];
      } else if (checked != "all" && this.showStatus.indexOf(checked) != -1) {
        let indexChecked = this.showStatus.indexOf(checked);
        this.showStatus.splice(indexChecked, 1);
        if (this.showStatus.indexOf("all") != -1) {
          let indexAll = this.showStatus.indexOf("all");
          this.showStatus.splice(indexAll, 1);
        }
      }
      if (this.showStatus.indexOf("all") == -1 && this.showStatus.length == 7) {
        this.showStatus.push("all");
      }
    },
    manageCheckWarning(checked) {
      if (this.showWarning.indexOf(checked) == -1 && checked !== "all") {
        this.showWarning.push(checked);
      } else if (checked == "all" && this.showWarning.indexOf("all") != -1) {
        this.showWarning = [];
      } else if (checked == "all" && this.showWarning.indexOf("all") == -1) {
        this.showWarning = ["all", "green", "orange", "red", "black"];
      } else if (checked != "all" && this.showWarning.indexOf(checked) != -1) {
        let indexChecked = this.showWarning.indexOf(checked);
        this.showWarning.splice(indexChecked, 1);
        if (this.showWarning.indexOf("all") != -1) {
          let indexAll = this.showWarning.indexOf("all");
          this.showWarning.splice(indexAll, 1);
        }
      }
      if (
        this.showWarning.indexOf("all") == -1 &&
        this.showWarning.length == 4
      ) {
        this.showWarning.push("all");
      }
    },
    unloadOtherVideos(videoClosed) {
      let videosToRemove = [];
      for(let i = 0; i < this.videos.length; i++) {
        let video = this.videos[i];
        if (video.archive && video.archiveLive === videoClosed.uuid) {
          videosToRemove.push(video.uuid);
        } else if (video.inAndOutOrigin && (video.inAndOutOrigin === videoClosed.uuid || videosToRemove.indexOf(video.inAndOutOrigin) > -1) ) {
          videosToRemove.push(video.uuid);
        }
      }
      videosToRemove.forEach(elem => {
        this.videos.splice(this.videos.findIndex(x => x.uuid === elem), 1);
      })
      videoClosed._otherLoaded = false;
      videoClosed._otherError = false;
      this.removeSavedOtherVideo(videoClosed.uuid);
    },
    loadOtherVideos(video, callback) {
        video._otherLoaded = false;
        video._otherError = false;
        let filter = "";
        let otherFilter = {};
        if (this.$auth.getMyUser().roles.indexOf("admin") > -1) {
          var client = this.clientView;
          otherFilter["client"] = client;
        }
        if (video.archivesFromLive && video.archivesFromLiveSize > 0) {
          filter = JSON.stringify({archive: true, archiveLive: video.uuid, ...otherFilter});
        } else if (video.videoInAndOut && video.videoInAndOutSize > 0) {
          filter = JSON.stringify({inAndOutOrigin: video.uuid, ...otherFilter})
        }
        if (filter === "" || filter === "{}") {
          if (callback) {
            callback();
          }
          return;
        }
        videoService
        .getVideosPageForClient(this.$auth.token(), {page:1, sort:this.mySort, pagesize:1000, filter: filter})
        .then((otherVideos) => {
          video._otherLoaded = true;
          //video._archives = archiveVideos;
          let indexOfMainVideo = this.videos.findIndex(x => x.uuid === video.uuid);
          let currentIndex = indexOfMainVideo + 1
          for (let i = 0; i < otherVideos._embedded.length; i++) {
            let newVideo = otherVideos._embedded[i];
            let indexVideo = this.videos.findIndex(x => x.uuid === newVideo.uuid)
            if (indexVideo === -1) {
              this.videos.splice(currentIndex, 0, newVideo);
              currentIndex++;
            } else {
              this.videos.splice(indexVideo, 1, newVideo);
            }
          }
          
          // Init special params
          for (let videoIdx in otherVideos._embedded) {
            // Archive and cut
            otherVideos._embedded[videoIdx]._otherLoaded = false;
            otherVideos._embedded[videoIdx]._otherError = false;

            otherVideos._embedded[videoIdx]._deleteDate = otherVideos._embedded[videoIdx].deleteDate;
            otherVideos._embedded[videoIdx]._modifyChapters = false;
            otherVideos._embedded[videoIdx]._modifyTitle = false;
            otherVideos._embedded[videoIdx]._modifyTags = false;
            otherVideos._embedded[videoIdx]._modifyDescription = false;
            otherVideos._embedded[videoIdx]._modifyPlanDes = false;
            otherVideos._embedded[videoIdx].duration2 = this.fancyDurationFormat(
              otherVideos._embedded[videoIdx].duration
            );
            otherVideos._embedded[videoIdx].createdDate = moment(
              otherVideos._embedded[videoIdx].createdAt
            ).format("DD/MM/YY @HH:mm");
            if (
              otherVideos._embedded[videoIdx].uuid === this.$store.state.focus &&
              !this.firstFocusUsed
            ) {
              this.firstFocusUsed = true;
            }

            if(otherVideos._embedded[videoIdx].tags && typeof otherVideos._embedded[videoIdx].tags === string )
            {
              otherVideos._embedded[videoIdx].tags = otherVideos._embedded[videoIdx].tags.split('|:|');
            }
          }
          this.saveOtherVideo(video.uuid);
          if (callback) {
            callback();
          }
        }).catch(err => {
          video._otherLoaded = true;
          video._otherError = true; // Erreur au chargement des archives/cuts
          if (callback) {
            callback();
          }
        })
    },
    loadArchivesFromVideo(video) {
        video._archivesLoaded = false;
        video._archivesError = false;
        videoService
        .getVideosPageForClient(this.$auth.token(), {page:1, pagesize:1000,sort: this.mySort, filter: JSON.stringify({archive: true, archiveLive: video.uuid})})
        .then((archiveVideos) => {
          video._archivesLoaded = true;
          //video._archives = archiveVideos;
          let indexOfMainVideo = this.videos.findIndex(x => x.uuid === video.uuid);
          this.videos.splice(indexOfMainVideo + 1, 0, ...archiveVideos._embedded);
          // Init special params
          for (let videoIdx in archiveVideos) {
            // Archive and cut
            archiveVideos[videoIdx]._archivesLoaded = false;
            archiveVideos[videoIdx]._archivesError = false;
            archiveVideos[videoIdx]._archives = [];
            archiveVideos[videoIdx]._cutsLoaded = false;
            archiveVideos[videoIdx]._cutsError = false;
            archiveVideos[videoIdx]._cuts = [];

            if(archiveVideos[videoIdx].tags && typeof archiveVideos[videoIdx].tags === string )
            {
              archiveVideos[videoIdx].tags = archiveVideos[videoIdx].tags.split('|:|');
            }

            archiveVideos[videoIdx]._deleteDate = archiveVideos[videoIdx].deleteDate;
            archiveVideos[videoIdx]._modifyChapters = false;
            archiveVideos[videoIdx]._modifyTitle = false;
            archiveVideos[videoIdx]._modifyTags = false;
            archiveVideos[videoIdx]._modifyDescription = false;
            archiveVideos[videoIdx]._modifyPlanDes = false;
            archiveVideos[videoIdx].duration2 = this.fancyDurationFormat(
              archiveVideos[videoIdx].duration
            );
            archiveVideos[videoIdx].createdDate = moment(
              archiveVideos[videoIdx].createdAt
            ).format("DD/MM/YY @HH:mm");
            if (
              archiveVideos[videoIdx].uuid === this.$store.state.focus &&
              !this.firstFocusUsed
            ) {
              this.firstFocusUsed = true;
            }
          }
        }).catch(err => {
          video._archivesLoaded = true;
          video._archivesError = true; // Erreur au chargement des archives
        })
    },
    loadCutsFromVideo(video) {
        video._cutsLoaded = false;
        video._cutsError = false;
        videoService
        .getVideosPageForClient(this.$auth.token(), {page:1, pagesize:1000, sort: this.mySort,filter: JSON.stringify({inAndOutOrigin: video.uuid})})
        .then((cutVideos) => {
          video._cutsLoaded = true;
          //video._cuts = cutVideos;
          let indexOfMainVideo = this.videos.findIndex(x => x.uuid === video.uuid);
          this.videos.splice(indexOfMainVideo + 1, 0, ...cutVideos._embedded);
          for (let videoIdx in cutVideos) {
            // Archive and cut
            cutVideos[videoIdx]._archivesLoaded = false;
            cutVideos[videoIdx]._archivesError = false;
            cutVideos[videoIdx]._archives = [];
            cutVideos[videoIdx]._cutsLoaded = false;
            cutVideos[videoIdx]._cutsError = false;
            cutVideos[videoIdx]._cuts = [];

            cutVideos[videoIdx]._deleteDate = cutVideos[video].deleteDate;
            cutVideos[videoIdx]._modifyChapters = false;
            cutVideos[videoIdx]._modifyTitle = false;
            cutVideos[videoIdx]._modifyTags = false;
            cutVideos[videoIdx]._modifyDescription = false;
            cutVideos[videoIdx]._modifyPlanDes = false;
            cutVideos[videoIdx].duration2 = this.fancyDurationFormat(
              cutVideos[videoIdx].duration
            );
            cutVideos[videoIdx].createdDate = moment(
              cutVideos[videoIdx].createdAt
            ).format("DD/MM/YY @HH:mm");
            if (
              cutVideos[videoIdx].uuid === this.$store.state.focus &&
              !this.firstFocusUsed
            ) {
              this.firstFocusUsed = true;
            }
          }
        }).catch(err => {
          video._cutsLoaded = true;
          video._cutsError = true; // Erreur au chargement des archives
        })
    },
    getVideos(page) {
      if (this.$auth.getMyUser().roles.indexOf("admin") > -1) {
        var client = this.clientView;
        this.searchParameters["client"] = client;
      }
      this.applyAdvancedFilters();
      let filter = JSON.stringify(this.searchParameters);
      let params;
      this.isGetInProgress = true;
      this.videos = [];
      this.numberOfVideos = 0;
      page = page || this.currentPage;
      this.$store.commit("newFocus", {
        uuid: this.$store.state.focus,
        pageNumber: this.currentPage,
      });
      params = {
        page: page,
        pagesize: this.numberPerPage,
        sort: this.mySort,
      };
      if (filter && filter !== "{}") {
        params.filter = filter;
      }

      this.getNumberVideoPlatform();

      videoService
        .getVideosPageForClient(this.$auth.token(), params)
        .then((videos) => {
          this.videos = videos._embedded;
          this.numberOfVideos = videos._size;
          this.viewMenu = {};
          this.totalNumberOfPage = Math.ceil(
            this.numberOfVideos / this.numberPerPage
          );
          this.realTotalNumberOfPage = Math.ceil(
            this.numberOfVideos / this.numberPerPage
          );
          let otherVideosToLoad = this.getOtherVideos();
          for (let video in this.videos) {
            if (otherVideosToLoad.indexOf(this.videos[video].uuid) > -1) {
              this.loadOtherVideos(this.videos[video]);
            }
            // Archive and cut
            this.videos[video]._otherLoaded = false;
            this.videos[video]._otherError = false;
            if (!this.isImbricated && ((this.videos[video].archivesFromLiveSize && this.videos[video].archivesFromLiveSize > 0) || (this.videos[video].videoInAndOutSize && this.videos[video].videoInAndOutSize > 0))) {
              this.videos[video]._otherLoaded = true;
            }


            if( this.videos[video].tags && typeof  this.videos[video].tags === "string" )
            {
               this.videos[video].tags =  this.videos[video].tags.split('|:|');
            }

            this.videos[video]._deleteDate = this.videos[video].deleteDate;
            this.videos[video]._modifyChapters = false;
            this.videos[video]._modifyTitle = false;
            this.videos[video]._modifyTags = false;
            this.videos[video]._modifyDescription = false;
            this.videos[video]._modifyPlanDes = false;
            try {
              this.videos[video].duration2 = this.fancyDurationFormat(
                this.videos[video].duration
              );
              
              this.videos[video].createdDate = moment(
                this.videos[video].createdAt
              ).format("DD/MM/YY @HH:mm");
              if (
                this.videos[video].uuid === this.$store.state.focus 
                && !this.firstFocusUsed
              ) {
                this.firstFocusUsed = true;
              }
            } catch(err) {
              console.log(err);
            }
          }
          this.isGetInProgress = false;
          this.updateSelectedNumber();
          
        })
        .catch((e) => {
          console.log(e);
          this.isGetInProgress = false;
          this.updateSelectedNumber();
        });
    },
    getNumberVideoPlatform() {
      let myFilter = {};
      this.applyAdvancedFilters(myFilter)
      videoService
        .getVideosPageForClient(this.$auth.token(), {
          pagesize: 0,
          filter: JSON.stringify({ client: this.clientView, ...myFilter}),
        })
        .then((videos) => {
          this.totalNumberOfVideos = videos._size;
        });
      /*videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({type:"live", client: this.clientView})}).then(videos => {
          this.liveNumber=videos._size
        })
        videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({type:"vod", client: this.clientView})}).then(videos => {
          this.vodNumber=videos._size
        })*/

        videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({encodingStatus:"to_encode", client: this.clientView})}).then(videos => {
          this.to_encodeNumber=videos._size
        })
        videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({encodingStatus:"waiting_for_encoding", client: this.clientView})}).then(videos => {
          this.waiting_for_encodingNumber=videos._size
        })
        videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({encodingStatus:"encoding", client: this.clientView})}).then(videos => {
          this.encodingNumber=videos._size
        })
        videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({encodingStatus:"encoded", client: this.clientView})}).then(videos => {
          this.encodedNumber=videos._size
        })
        videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({encodingStatus:"to_stop", client: this.clientView})}).then(videos => {
          this.to_stopNumber=videos._size
        })
        videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({encodingStatus:"stopped", client: this.clientView})}).then(videos => {
          this.stoppedNumber=videos._size
        })
        videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({encodingStatus:"restart", client: this.clientView})}).then(videos => {
          this.restartNumber=videos._size
        })
        videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({encodingStatus:"error", client: this.clientView})}).then(videos => {
          this.errorNumber=videos._size
        })


        /*
        videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({rebuff:{"$lte": 20}, error: false, client: this.clientView})}).then(videos => {
          this.greenNumber=videos._size
        })
        videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({rebuff:{"$gt":20,"$lte": 50}, error: false, client: this.clientView})}).then(videos => {
          this.orangeNumber=videos._size
        })
        videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({rebuff:{"$gt": 50}, error: false, client: this.clientView})}).then(videos => {
          this.redNumber=videos._size
        })
        videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({error: true, client: this.clientView})}).then(videos => {
          this.blackNumber=videos._size
        })*/
    },
    startVideo(video) {
      this.$store.commit("newFocus", {
        uuid: video.uuid,
        pageNumber: this.currentPage,
      });

      this.$router.push("/player/" + video.uuid);
    },
    stopVideo(video) {
      videoService
        .deleteEncodingToVideoById(video.uuid, this.$auth.token())
        .then(() => {
          this.getVideos();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getListAllVideos() {
      /*let list = [];
      this.videos.forEach(video => {
        list.push(video);
        if (video._archives.length > 0) {
          video._archives.forEach(archiveVideo => {
            list.push(archiveVideo);
            if (archiveVideo._cuts.length > 0) {
              archiveVideo._cuts.forEach(cutVideo => {
                list.push(cutVideo)
              })
            }
          })
        }
        if (video._cuts.length > 0) {
          video._cuts.forEach(cutVideo => {
            list.push(cutVideo)
          })
        }
      })*/
      return this.videos;
    },
    removeVideo(video) {
      if (video.inAndOutOrigin) {
        let videoIdx = this.videos.findIndex(x => x.uuid === video.inAndOutOrigin);
        if (videoIdx > -1) {
          this.videos[videoIdx]._forceCheck = true;
        }
      }
      if (video.archive && video.archiveLive) {
        let videoIdx = this.videos.findIndex(x => x.uuid === video.archiveLive);
        if (videoIdx > -1) {
          this.videos[videoIdx]._forceCheck = true;
        }
      }
      let goDelete = () => {
        videoService
        .deleteVideoById(video.uuid, this.$auth.token())
        .then((response) => {
          if (response && response.info) {
            video.deleteDate = new Date();
            video._deleteDate = video.deleteDate;
            video._modifyPlanDes = false;
            this.videos = this.videos.splice(0);
          } else {
            let indexVideo = this.videos.findIndex(x => x.uuid === video.uuid);
            if (indexVideo > -1) {
              this.videos.splice(indexVideo, 1);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
      }
      if ((video.archivesFromLiveSize !== undefined && video.archivesFromLiveSize >= 0) || (video.videoInAndOutSize !== undefined && video.videoInAndOutSize >= 0)) {
        this.loadOtherVideos(video, goDelete);
      } else {
        goDelete();
      }  
    },
    startEncoding(video) {
      videoService
        .putEncodingToVideoById(video.uuid, this.$auth.token())
        .then(() => {
          video.deleteDate;
          //this.getVideos();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    getElapsedTime: function (startTime) {

        // Record end time
        let endTime = new Date();

        // Compute time difference in milliseconds
        let timeDiff = endTime.getTime() - startTime.getTime();
        if (timeDiff < 0) {
          timeDiff = 0;
        }

        // Convert time difference from milliseconds to seconds
        timeDiff = timeDiff / 1000;

        // Extract integer seconds that dont form a minute using %
        let seconds = Math.floor(timeDiff % 60); //ignoring uncomplete seconds (floor)

        // Pad seconds with a zero if neccessary
        let secondsAsString = seconds < 10 ? "0" + seconds : seconds + "";

        // Convert time difference from seconds to minutes using %
        timeDiff = Math.floor(timeDiff / 60);

        // Extract integer minutes that don't form an hour using %
        let minutes = timeDiff % 60; //no need to floor possible incomplete minutes, becase they've been handled as seconds

        // Pad minutes with a zero if neccessary
        let minutesAsString = minutes < 10 ? "0" + minutes : minutes + "";

        // Convert time difference from minutes to hours
        timeDiff = Math.floor(timeDiff / 60);

        // Extract integer hours that don't form a day using %
        let hours = timeDiff % 24; //no need to floor possible incomplete hours, becase they've been handled as seconds

        // Convert time difference from hours to days
        timeDiff = Math.floor(timeDiff / 24);

        // The rest of timeDiff is number of days
        let days = timeDiff;

        let totalHours = hours + (days * 24); // add days to hours
        let totalHoursAsString = totalHours < 10 ? "0" + totalHours : totalHours + "";

        if (totalHoursAsString === "00") {
            return minutesAsString + ":" + secondsAsString;
        } else {
            return totalHoursAsString + ":" + minutesAsString + ":" + secondsAsString;
        }
    },
    livePosition() {
      let listAll = this.getListAllVideos();
      let myVideos = listAll.filter((elem) => {
        return (
          elem.type === "live"
          && elem.encodingStatus === "encoding"
          && elem.startDateLive
        );
      });

      if (myVideos.length > 0) {
        myVideos.forEach(video => {
          video._liveDuration = this.getElapsedTime(new Date(video.startDateLive))
        })
        this.videos = this.videos.splice(0);
      }
    },
    checkEncodingPercent() {
      let currentDate = new Date().getTime();
      let listAll = this.getListAllVideos();
      let myVideos = listAll.filter((elem) => {
        return (
          [
            "waiting_for_encoding",
            "encoding",
            "to_encode",
            "to_stop",
            "segmented",
            "restart",
            "uploading"
          ].indexOf(elem.encodingStatus) > -1
          || new Date(elem.deleteDate).getTime() <= currentDate
          || elem._forceCheck
        );
      });
      let filter = {
        client: this.clientView,
        $or: [],
      };
      for (let video of myVideos) {
        filter["$or"].push({ uuid: video.uuid });
        //TODO gérer les archives et cut qui sont un niveau en dessous.
      }
      if (myVideos.length > 0) {
        videoService
          .getVideosPageForClient(this.$auth.token(), {
            pagesize: this.numberPerPage,
            filter: (JSON.stringify(filter) !== "{}") ? JSON.stringify(filter) : undefined,
          })
          .then((result) => {
            var newData = result._embedded;
            for (var data in newData) {
              var myObject = this.videos.find(
                (elem) => newData[data].uuid === elem.uuid
              );
              myObject._forceCheck = false;
              // Recharger les archives s'il y en a de nouvelles
              if (JSON.stringify(newData[data].archivesFromLive) !== JSON.stringify(myObject.archivesFromLive) && myObject._otherLoaded) {
                this.loadOtherVideos(myObject); 
              }

              for (var key of Object.keys(newData[data])) {
                myObject[key] = newData[data][key];
              }
              try {
                myObject.duration = newData[data].duration || myObject.duration;
                myObject.duration2 = this.fancyDurationFormat(myObject.duration);
              }catch(err) {}

              if ((myObject.videoInAndOutSize !== undefined && myObject.videoInAndOutSize <= 0) || (myObject.archivesFromLiveSize !== undefined && myObject.archivesFromLiveSize <= 0)) {
                myObject._otherLoaded = false;
                myObject._otherError = false;
                this.removeSavedOtherVideo(myObject.uuid);
              }
              /*myObject.encodingStatus = newData[data].encodingStatus || myObject.encodingStatus;
              if (myObject.type === 'vod') {
                myObject.duration = newData[data].duration || myObject.duration;
                myObject.duration2 = this.fancyDurationFormat(myObject.duration);
              }
              if (newData[data].hasOwnProperty('encodingPercent')) {
                myObject.encodingPercent = newData[data].encodingPercent;
              }*/
            }
            if (newData.length > 0) {
              this.videos = this.videos.splice(0);
            }
            if (newData.length < myVideos.length) {
              let videosToDelete = myVideos.filter(x => newData.findIndex(y => y.uuid === x.uuid) === -1);
              for (let toDelete in videosToDelete) {

                if (videosToDelete[toDelete].inAndOutOrigin) {
                  let videoIdx = this.videos.findIndex(x => x.uuid === videosToDelete[toDelete].inAndOutOrigin);
                  if (videoIdx > -1) {
                    this.videos[videoIdx]._forceCheck = true;
                  }
                }
                if (videosToDelete[toDelete].archive && videosToDelete[toDelete].archiveLive) {
                  let videoIdx = this.videos.findIndex(x => x.uuid === videosToDelete[toDelete].archiveLive);
                  if (videoIdx > -1) {
                    this.videos[videoIdx]._forceCheck = true;
                  }
                }

                let goDelete = () => {
                  let deleteIndex = this.videos.findIndex(x => videosToDelete[toDelete].uuid === x.uuid);
                  this.videos.splice(deleteIndex, 1);
                }
                if ((videosToDelete[toDelete].archivesFromLiveSize !== undefined && videosToDelete[toDelete].archivesFromLiveSize >= 0) || (videosToDelete[toDelete].videoInAndOutSize !== undefined && videosToDelete[toDelete].videoInAndOutSize >= 0)) {
                  this.loadOtherVideos(videosToDelete[toDelete], goDelete);
                } else {
                  goDelete();
                }
                
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    copyLink(video) {
      let directLink =
            EMBED_URL +
            "/embeded.html?uuid=" +
            video.uuid +
            "&type=" +
            video.type +
            "&analyticsID=" + 
            this.clientView +
            "&wm=" +
            this.userView;
      if (video.inputInfos.indexOf("audio=false") > -1) {
        directLink += `&audio=0`;
      }
      let embeded =
        '<div style="position:relative;padding-top:56.25%;"><iframe style="position:absolute;top:0;width:100%;height:100%" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameBorder="0" scrolling="no" src="' +
        EMBED_URL +
        "/embeded.html?uuid=" +
        video.uuid +
        "&type=" +
        video.type +
        '&analyticsID=' + 
        this.clientView

      embeded += '"></iframe></div>';
      this.$copyText(embeded);
    },
    copyDirectLink(video) {
      let directLink =
            EMBED_URL +
            "/embeded.html?uuid=" +
            video.uuid +
            "&type=" +
            video.type +
            "&analyticsID=" + 
            this.clientView


          if (video.inputInfos.indexOf("audio=false") > -1) {
            directLink += `&audio=0`;
          }

      this.$copyText(directLink);
    },
    selectAll() {
      var self = this;
      let allVideos = this.getListAllVideos();
      allVideos.forEach(function (elem) {
        elem._isSelected = self.isSelectAll;
      });
      this.updateSelectedNumber();
    },
    checkAllSelected() {
      let allVideos = this.getListAllVideos();
      let oneNotSelected = allVideos.findIndex(x => !x._isSelected);
      if (oneNotSelected > -1) {
        this.isSelectAll = false;
      } else {
        this.isSelectAll = true;
      }
    },
    updateSelectedNumber() {
      let allVideos = this.getListAllVideos();
      this.nbrVideoSelected = allVideos.filter(x => x._isSelected).length;
      this.checkAllSelected();
    },
    changeActiveSort(value, defaultOrder) {
      var sortObject = {};
      if (value !== this.activeSort) {
        this.activeSortOrder = (defaultOrder !== undefined) ? defaultOrder : 1;
        this.activeSort = value;
      } else {
        this.activeSortOrder = this.activeSortOrder === 1 ? -1 : 1;
      }
      this.saveSortParameters();
      sortObject[this.activeSort] = this.activeSortOrder;
      this.mySort = JSON.stringify(sortObject);
      this.getVideos();
    },
    removeSelected() {
      let allVideos = this.getListAllVideos();
      for (var video of allVideos) {
        if (video._isSelected) {
          this.removeVideo(video);
        }
      }
      
      this.isSelectAll = false;
    },
    manualSortFocus() {
      //TODO Afficher la video non-cut et non-archive dont est issue la video
      let videos = this.videos;
      let index = -1;
      videos.forEach((video, idx) => {
        if (video.uuid === this.$store.state.focus) {
          index = idx;
        }
      })
      if (index > -1) {
        let myVideo = videos.splice(index, 1);
        videos.unshift(myVideo[0]);
      }
    },
    fancySpeedAndETA(encodingStart, duration, percent) {
      let speed = 0;
      let eta = null;
      let date = new Date().getTime();

      let startDate = new Date(encodingStart).getTime();
      let endDate = ((date - startDate) * 100) / percent + startDate;
      let secEncoded = Math.floor(duration);

      eta = new Date(endDate);
      speed = 0;

      return {
        speed: speed,
        eta: eta,
      };
    },
    fancyDurationFormat(duration) {
      let time = duration;
      // Hours, minutes and seconds
      var hrs = ~~(time / 3600);
      var mins = ~~((time % 3600) / 60);
      var secs = ~~time % 60;

      // Output like "1:01" or "4:03:59" or "123:03:59"
      var ret = "";

      if (hrs > 0) {
        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
      }

      if ((mins > 0) || (hrs > 0)) {
        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
      }

      ret += "" + secs + "s";
      return ret;
    },
     openLiveWebcam(video) {
    let uuid = video.uuid;
    EventBus.$emit('windowLive', {specificVideoID: uuid});
  },
  addQuality() {
    var newQuality = {
        bitrate : 5000,
        resolution:{
            height: 1080,
            width: 1920,
        },
        FPS: 30,
    }
    this.qualitiesModal.push(newQuality);
  },
    removeQuality(idx)
    {
      this.qualitiesModal.splice(idx,1)
    },
    resetModal(video){
      this.qualitiesModal = (video.encoding !== "passthrough" && video.inputQualities !== "QuanteecOptimization") ? video.inputQualities : [];
      this.qualitiesSelection = (video.encoding === "passthrough") ? "passthrough" : (video.inputQualities === "QuanteecOptimization") ? "default" : "qualities";
      this.firstPass = (video.type === "live") ?  false : video.firstPass;
      this.restartEncodingQuality = false;
    },
    refreshModal(){
      this.qualitiesModal = [];
      this.qualitiesSelection = "default";
      this.firstPass = false;
      this.restartEncodingQuality = false;
    },
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.oldcard {
  border: 5px dashed #ba0000;
}

@media (max-width: 1140px) {
  .colwidth {
    width: 1210px;
  }
}
@media (min-width: 1140px) {
  .colwidth {
    width: 400px;
  }
}


@media (min-width: 768px) {
  .greysearch {
    border: 0.125rem solid;
    border-radius: 10px;
    padding: 10px 10px;
    margin: -10px -10px;
    border-color: #2a5d77;
  }

  .btn-mswarning2 {
    color: #fff !important;
    background-color: #f98e35 !important;
    border-radius: 0.25rem !important;
    border: 0.1rem solid #2a5d77 !important;
    transition: 0.15s all ease-in-out;
    &:hover {
      color: #f98e35 !important;
      border: 0.1rem solid #2a5d77 !important;
      background-color: #fbfcfc !important;
      text-decoration: none;
    }
  }
}

.greysearch {
  margin: 0px 0px;
}

/* end of general styles */

.scrollmenu {
  display: flex;
  justify-content: space-between;
  overflow: auto;
  white-space: nowrap;
}

.pushed {
  background-color: #ff0037;
}

.previewContainer {
  position: relative;
  width: 100%;
  margin-bottom: 0.5rem;
  padding-top: 56.25%;
  background-color: black;
}

.previewContainer2 {
  position: relative;
  width: 100%;
  padding-top: 66.25%;
  background-color: black;
}

.previewContainer3 {
  position: relative;
  width: 100%;
  padding-top: 70.25%;
  background-color: black;
}

@media (min-width: 1226px) {

  .previewContainer2 {
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    background-color: black;
  }
}

.previewImg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}

.scrolling-box {
  overflow-y: scroll;
  scroll-behavior: smooth;
  height:calc(100vh - 60px);
  margin:0px;
}

.advancedfilter-enter-active, .advancedfilter-leave-active {
  transition: opacity .2s;
}
.advancedfilter-enter, .advancedfilter-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.custom-control-label {
  padding-top: 5px;
}

.badge-info {
  border: 1px solid #5bc0de !important;//#6c757d;
  &:hover {
    cursor: pointer;
    background-color:white !important;
    border: 1px solid #5bc0de !important;//#6c757d;
    color: #5bc0de;
  }
}

.badge-success {
  border: 1px solid #5cb85c !important;//#6c757d;
  &:hover {
    cursor: pointer;
    background-color:white !important;
    border: 1px solid #5cb85c !important;//#6c757d;
    color: #5cb85c;
  }
}

/*
.input-file {
  cursor: pointer;
  color: #00b1ca;
  font-size: 12px;
  width: 10rem;
}
*/

.unselectedChoice2 {
  border: 3px solid;
  border-radius: 10px;
  border-color: rgba(grey, 1);
  box-shadow: rgba(#0f182f, 0.117647) 1px 2px 7px, rgba(#0f182f, 0.117647) 1px 2px 7px;
}

.selectedChoice2 {
  border: 3px solid;
  border-radius: 10px;
  //border-color: rgba(#19b952, 1);
  border-color: rgba(#14BF98, 1);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.commonChoice2 {
  text-align: center;
  min-height: 120px;
  font-weight: 400;
  font-size: 1.1rem;
  color:#2a5d77;
  cursor: pointer;
  margin: 10px;
  padding: 5px;
}

.commonChoice3 {
  text-align: center;
  min-height: 70px;
  font-weight: 400;
  font-size: 1.1rem;
  color:#2a5d77;
  cursor: pointer;
  margin: 2px;
  padding: 2px;
}

.unselectedChoice {
  border: 4px solid;
  border-radius: 10px;
  border-color: rgba(grey, 1);
  box-shadow: rgba(#0f182f, 0.117647) 1px 2px 7px, rgba(#0f182f, 0.117647) 1px 2px 7px;
}

.selectedChoice {
  border: 4px solid;
  border-radius: 10px;
  //border-color: rgba(#19b952, 1);
  border-color: rgba(#ba0000, 1);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.commonChoice {
  text-align: center;
  min-height: 60px;
  font-weight: 500;
  font-size: 2rem;
  color:black;
  cursor: pointer;
}

.green {
  color: #14BF98;
}
.red {
  color: red;
}
.orange {
  color:orange;
}
.black {
  color:black;
}

.tag-not-selected {
  border: 1px solid black;
  border-radius: 10px;
  min-width: 50px;
  display: inline-block;
  text-align:center;
  margin-right:10px;
  margin-bottom:10px;
  background-color:#2a5d77;
  color:white;
  cursor:pointer;
}

.tag-selected {
  border: 1px solid black;
  border-radius: 10px;
  min-width: 50px;
  display: inline-block;
  text-align:center;
  margin-right:10px;
  margin-bottom:10px;
  
  background-color:#14BF98;
  color:white;
  cursor:pointer;
}

.tag-excluded {
  border: 1px solid black;
  border-radius: 10px;
  min-width: 50px;
  display: inline-block;
  text-align:center;
  margin-right:10px;
  margin-bottom:10px;
  background-color:red;
  color:white;
  cursor:pointer;
}

</style>
